// import React, { useEffect, useState, useRef } from 'react';
// import {
//   Container, Card, Table, Button, Modal, Form, Row, Col,
//   Spinner, Alert, InputGroup
// } from 'react-bootstrap';
// import {
//   FaEdit, FaTrash, FaSave, FaTimes, FaCalendarAlt,
//   FaFileContract, FaCheckCircle, FaClock,
//   FaTimesCircle, FaEye, FaSearch, FaBan, FaPaperPlane,
//   FaFileInvoiceDollar, FaExclamationTriangle, FaBolt,
//   FaRedo, FaFileInvoice
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';
// import Select from 'react-select';a//

// import { PageHeader } from '../../components/shared/PageHeader';
// import { ConfirmModal } from '../../components/shared/ConfirmModal';
// import { usePlanAccess } from '../../hooks/usePlanAccess';

// // ─────────────────────────────────────────
// // SELECT FIX (resolve dropdown escondido atrás de cards)
// // ─────────────────────────────────────────
// const selectFix = {
//   menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
//   menuPosition: 'fixed',
//   styles: {
//     menuPortal: base => ({ ...base, zIndex: 9999 }),
//   },
// };

// // ─────────────────────────────────────────
// // UTILS
// // ─────────────────────────────────────────
// const toDate = (v) => {
//   if (!v) return null;

//   if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
//     const [y, m, d] = v.split('-').map(Number);
//     return new Date(y, m - 1, d, 12, 0, 0);
//   }

//   const d = new Date(v);
//   return isNaN(d) ? null : d;
// };

// const formatYmd = (v) => {
//   const d = toDate(v);
//   if (!d) return '';

//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
// };

// // Formata YYYY-MM-DD → DD/MM/YYYY (curto, sem quebrar linha)
// const formatBr = (v) => {
//   const d = toDate(v);
//   if (!d) return '-';
//   return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
// };

// const isValidYmd = (v) => {
//   if (!v || typeof v !== 'string') return false;
//   if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;

//   const year = parseInt(v.split('-')[0], 10);
//   return year >= 1900 && year <= 2100;
// };

// const getToday = () => {
//   const d = new Date();

//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
// };

// const brl = (value) => {
//   return Number(value || 0).toLocaleString('pt-BR', {
//     style: 'currency',
//     currency: 'BRL'
//   });
// };

// const calculateEndDate = (start, dur, unit) => {
//   if (!start || !dur || !unit) return '';

//   const [y, mo, d] = start.split('-').map(Number);
//   const date = new Date(y, mo - 1, d, 12, 0, 0);
//   const n = parseInt(dur, 10);

//   switch (String(unit).toLowerCase()) {
//     case 'dias':
//     case 'days':
//       date.setDate(date.getDate() + n);
//       break;

//     case 'semanas':
//     case 'weeks':
//       date.setDate(date.getDate() + n * 7);
//       break;

//     case 'meses':
//     case 'months':
//       date.setMonth(date.getMonth() + n);
//       break;

//     case 'anos':
//     case 'years':
//       date.setFullYear(date.getFullYear() + n);
//       break;

//     default:
//       return '';
//   }

//   return formatYmd(date);
// };

// // ─────────────────────────────────────────
// // CÁLCULO CENTRAL DE VALORES (FONTE ÚNICA DE VERDADE)
// // Usado tanto na tabela quanto no formulário.
// // ─────────────────────────────────────────
// const calcularValores = ({
//   quantidadeAnuncios,
//   valorPlano,
//   qtdEquipamentos,
//   desconto,
//   descontoParcela,
//   qtdParcelas,
// }) => {
//   const qtdAds = Math.max(1, parseInt(quantidadeAnuncios || 1, 10));
//   const valPlano = parseFloat(valorPlano || 0);
//   const qtdEquip = Math.max(1, qtdEquipamentos || 1);
//   const descG = parseFloat(desconto || 0);
//   const descP = parseFloat(descontoParcela || 0);
//   const qtdParc = Math.max(1, parseInt(qtdParcelas || 1, 10));

//   const valorBase = qtdAds * valPlano * qtdEquip;
//   const descTotal = descG + (descP * qtdParc);
//   const totalFinal = Math.max(valorBase - descTotal, 0);
//   const valorParcela = qtdParc > 0
//     ? Math.max((valorBase - descG) / qtdParc - descP, 0)
//     : 0;

//   return { valorBase, descTotal, totalFinal, valorParcela, qtdParc };
// };

// // ─────────────────────────────────────────
// // GERA PARCELAS — recebe o valor POR PARCELA já calculado
// // (mesma fonte do cabeçalho: valorParcela de calcularValores)
// // e distribui o resto de arredondamento na última parcela.
// // ─────────────────────────────────────────
// const generateParcelas = (start, dur, unit, valorParcela, totalFinal, qtd) => {
//   if (!start || !dur || !unit) return [];

//   const u = String(unit).toLowerCase();

//   // Planos em dias → 1 única parcela com o total final
//   if (u === 'dias' || u === 'days') {
//     return [{
//       numero: 1,
//       valor: Number(Number(totalFinal).toFixed(2)),
//       dataVencimento: start,
//       pago: false,
//       dataPagamento: '',
//     }];
//   }

//   const n = Math.max(1, parseInt(qtd || dur, 10) || 1);
//   const valParc = Number(Number(valorParcela).toFixed(2));

//   // Distribuição justa: todas iguais ao valorParcela,
//   // e a última absorve o resto de arredondamento p/ bater o total.
//   const somaParcial = valParc * (n - 1);
//   const valorUltima = Number((Number(totalFinal) - somaParcial).toFixed(2));

//   const [y, mo, d] = start.split('-').map(Number);
//   const base = new Date(y, mo - 1, d, 12, 0, 0);

//   return Array.from({ length: n }, (_, i) => {
//     const dt = new Date(base);

//     if (u === 'semanas' || u === 'weeks') {
//       dt.setDate(dt.getDate() + i * 7);
//     } else if (u === 'meses' || u === 'months') {
//       dt.setMonth(dt.getMonth() + i);
//     } else if (u === 'anos' || u === 'years') {
//       dt.setFullYear(dt.getFullYear() + i);
//     }

//     return {
//       numero: i + 1,
//       valor: i === n - 1 ? valorUltima : valParc,
//       dataVencimento: formatYmd(dt),
//       pago: false,
//       dataPagamento: '',
//     };
//   });
// };

// const normalizeContractStatus = (status) => {
//   const raw = String(status || '').trim();
//   const upper = raw.toUpperCase();
//   const lower = raw.toLowerCase();

//   if (upper === 'DRAFT') return 'pendente';
//   if (upper === 'SENT') return 'aguardando_assinatura';
//   if (upper === 'SIGNED') return 'assinado';

//   if (
//     upper === 'CANCELED' ||
//     upper === 'CANCELLED' ||
//     upper === 'DISPENSED'
//   ) {
//     return 'dispensado';
//   }

//   if (lower === 'pendente') return 'pendente';
//   if (lower === 'aguardando_assinatura') return 'aguardando_assinatura';
//   if (lower === 'assinado') return 'assinado';
//   if (lower === 'dispensado') return 'dispensado';

//   return 'pendente';
// };

// const formatarPedido = (order) => ({
//   id: order.id,
//   clienteId: order.customerId,
//   planoId: order.mediaPlanId,
//   equipamentosSelecionados: order.equipments?.map(e => e.equipmentId) ?? [],

//   status:
//     order.status === 'CANCELADO' ? 'cancelado' :
//     order.status === 'CONCLUIDO' ? 'finalizado' : 'ativo',

//   statusContrato: normalizeContractStatus(order.contracts?.[0]?.status),
//   linkAssinatura: order.contracts?.[0]?.link || null,

//   dataInicio: order.startDate ? order.startDate.split('T')[0] : '',
//   dataTermino: order.endDate ? order.endDate.split('T')[0] : '',

//   desconto: order.discount || 0,
//   descontoParcela: order.discountPerInstallment || 0,

//   clienteNome: order.customer?.name || 'Cliente Desconhecido',
//   clienteEmail: order.customer?.email || '',
//   planos: order.mediaPlan?.name || 'Plano Desconhecido',
//   valor: order.mediaPlan?.amount || 0,

//   quantidadeAnuncios: order.adsCount ?? 1,

//   contratoEnviado:
//     order.contracts?.[0]?.sent ||
//     order.contracts?.[0]?.status === 'SENT' ||
//     order.contracts?.[0]?.status === 'SIGNED' ||
//     false,

//   dataEnvioContrato: order.contracts?.[0]?.sentAt || null,
//   dataAssinaturaContrato: order.contracts?.[0]?.signedAt || null,
//   autentiqueDocId: order.contracts?.[0]?.autentiqueId || null,

//   boletosGerados: order.invoicesGenerated ?? null,

//   parcelas: order.installments?.map(inst => ({
//     id: inst.id,
//     numero: inst.installmentNumber,
//     valor: Number(inst.amount),
//     dataVencimento: inst.dueDate ? inst.dueDate.split('T')[0] : '',
//     pago: inst.status === 'Paid' || inst.status === 'PAID',
//     cancelada: inst.status === 'CANCELED' || inst.status === 'Canceled',
//     status: inst.status,
//     dataPagamento: inst.paidAt ? inst.paidAt.split('T')[0] : '',
//     valorPago: inst.paidAmount ? Number(inst.paidAmount) : Number(inst.amount),
//     invoiceUrl: inst.paymentLink || '',
//   })) ?? [],
// });


// // ─────────────────────────────────────────
// // PILL (substitui o Badge do react-bootstrap)
// // ─────────────────────────────────────────
// const Pill = ({ color = '#6c757d', textColor = '#fff', children }) => (
//   <span
//     className="d-inline-flex align-items-center gap-1 fw-semibold rounded-pill"
//     style={{
//       backgroundColor: color,
//       color: textColor,
//       fontSize: '0.72rem',
//       padding: '0.3rem 0.65rem',
//       lineHeight: 1,
//     }}
//   >
//     {children}
//   </span>
// );


// // ─────────────────────────────────────────
// // BADGES
// // ─────────────────────────────────────────
// const ContratoBadge = ({ status }) => {
//   const map = {
//     pendente:              { icon: FaClock,       text: 'Pendente',           color: '#6c757d' },
//     aguardando_assinatura: { icon: FaPaperPlane,  text: 'Aguard. Assinatura', color: '#ffc107', textColor: '#000' },
//     assinado:              { icon: FaCheckCircle, text: 'Assinado',           color: '#198754' },
//     dispensado:            { icon: FaTimesCircle, text: 'Dispensado',         color: '#0dcaf0', textColor: '#000' },
//   };

//   const cfg = map[status] || map.pendente;
//   const Icon = cfg.icon;

//   return (
//     <Pill color={cfg.color} textColor={cfg.textColor || '#fff'}>
//       <Icon size={10} />
//       {cfg.text}
//     </Pill>
//   );
// };


// const PedidoBadge = ({ status }) => {
//   const map = {
//     ativo:      { text: 'Ativo',      color: '#198754' },
//     finalizado: { text: 'Finalizado', color: '#000' },
//     cancelado:  { text: 'Cancelado',  color: '#dc3545' },
//   };

//   const cfg = map[status] || map.ativo;

//   return <Pill color={cfg.color}>{cfg.text}</Pill>;
// };


// // ─────────────────────────────────────────
// // PÁGINA PRINCIPAL
// // ─────────────────────────────────────────
// export default function Pedidos() {
//   const { tier, hasBoletoAccess, hasContratoAccess } = usePlanAccess();

//   const [pedidos, setPedidos] = useState([]);
//   const [clientes, setClientes] = useState([]);
//   const [planos, setPlanos] = useState([]);
//   const [equipamentos, setEquipamentos] = useState([]);
//   const [contractTemplates, setContractTemplates] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusPedidoFilter, setStatusPedidoFilter] = useState('');
//   const [statusContratoFilter, setStatusContratoFilter] = useState('');

//   const [showModal, setShowModal] = useState(false);
//   const [currentPedido, setCurrentPedido] = useState(null);

//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [pedidoToDelete, setPedidoToDelete] = useState(null);

//   const [hasLytexConfig, setHasLytexConfig] = useState(null);
//   const [hasAutentiqueConfig, setHasAutentiqueConfig] = useState(null);

//   const pollingRef = useRef(null);

//   useEffect(() => {
//     if (!showModal && pollingRef.current) {
//       clearInterval(pollingRef.current);
//       pollingRef.current = null;
//     }
//   }, [showModal]);

//   useEffect(() => {
//     return () => {
//       if (pollingRef.current) {
//         clearInterval(pollingRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);

//       await Promise.all([
//         fetchPedidos(),

//         api.get('/customers')
//           .then(r => setClientes(r.data.map(c => ({ ...c, nome: c.name }))))
//           .catch(() => {}),

//         api.get('/media-plans')
//           .then(r => setPlanos(r.data.map(p => ({
//             ...p,
//             valor: p.amount,
//             duracao: p.duration,
//             unidade: p.unit,
//             nome: p.name
//           }))))
//           .catch(() => {}),

//         api.get('/equipments')
//           .then(r => setEquipamentos(r.data.map(e => ({ ...e, nome: e.name }))))
//           .catch(() => {}),

//         api.get('/integrations/lytex/status')
//           .then(r => setHasLytexConfig(!!r.data?.configured))
//           .catch(() => setHasLytexConfig(false)),

//         api.get('/integrations/autentique/status')
//           .then(r => setHasAutentiqueConfig(!!r.data?.configured))
//           .catch(() => setHasAutentiqueConfig(false)),

//         api.get('/contract-templates')
//           .then(r => setContractTemplates(Array.isArray(r.data) ? r.data : []))
//           .catch(() => setContractTemplates([])),
//       ]);

//       setLoading(false);
//     };

//     load();
//   }, []);

//   const fetchPedidos = async () => {
//     try {
//       const res = await api.get('/orders');
//       setPedidos(res.data.map(formatarPedido));
//     } catch {
//       setError('Erro ao carregar pedidos.');
//     }
//   };

//   const startPollingInvoices = (orderId) => {
//     if (pollingRef.current) {
//       clearInterval(pollingRef.current);
//     }

//     let attempts = 0;
//     const MAX_ATTEMPTS = 20;
//     const INTERVAL_MS = 2000;

//     pollingRef.current = setInterval(async () => {
//       attempts++;

//       try {
//         const res = await api.get(`/orders/${orderId}`);
//         const pedidoAtualizado = formatarPedido(res.data);

//         const todasComBoleto = pedidoAtualizado.parcelas.every(p => !!p.invoiceUrl || p.cancelada);
//         const algumaComBoleto = pedidoAtualizado.parcelas.some(p => !!p.invoiceUrl);

//         if (algumaComBoleto) {
//           setCurrentPedido(pedidoAtualizado);
//           await fetchPedidos();
//         }

//         if (todasComBoleto || attempts >= MAX_ATTEMPTS) {
//           clearInterval(pollingRef.current);
//           pollingRef.current = null;

//           toast[todasComBoleto ? 'success' : 'warning'](
//             todasComBoleto
//               ? '✅ Todos os boletos foram gerados!'
//               : '⚠️ Alguns boletos ainda estão sendo processados.'
//           );
//         }
//       } catch {
//         clearInterval(pollingRef.current);
//         pollingRef.current = null;
//       }
//     }, INTERVAL_MS);
//   };

//   const handleSave = async (data) => {
//     if (saving) return;

//     setSaving(true);
//     setError('');

//     try {
//       if (data.id) {
//         await api.put(`/orders/${data.id}`, {
//           customerId: data.clienteId,
//           mediaPlanId: data.planoId,
//           equipments: data.equipamentosSelecionados,

//           adsCount: parseInt(data.quantidadeAnuncios, 10) || 1,

//           startDate: formatYmd(data.dataInicio),
//           endDate: formatYmd(data.dataTermino),
//           discount: Number(data.desconto) || 0,
//           discountPerInstallment: Number(data.descontoParcela) || 0,
//           status:
//             data.status === 'cancelado' ? 'CANCELADO' :
//             data.status === 'finalizado' ? 'CONCLUIDO' : 'ATIVO',

//           installments: data.parcelas
//             .filter(p => !p.cancelada)
//             .map(p => ({
//               id: p.id,
//               installmentNumber: p.numero,
//               amount: Number(p.valor),
//               dueDate: formatYmd(p.dataVencimento),
//               status: p.pago ? 'PAID' : 'PENDING',
//               paidAt: p.pago && p.dataPagamento ? formatYmd(p.dataPagamento) : null,
//               paidAmount: p.pago ? Number(p.valorPago || p.valor) : null,
//             })),
//         });

//         toast.success('Pedido atualizado!');
//         await fetchPedidos();
//         setShowModal(false);
//       } else {
//         const firstDate = data.parcelas[0]?.dataVencimento ?? data.dataInicio;

//         const deveGerarBoletos =
//           hasBoletoAccess &&
//           data.gerarBoletos === true &&
//           hasLytexConfig === true;

//         const deveGerarContrato =
//           hasContratoAccess &&
//           data.gerarContrato === true;

//         const deveEnviarContrato =
//           deveGerarContrato &&
//           data.enviarContratoAutentique === true &&
//           hasAutentiqueConfig === true;

//         const payload = {
//           customerId: data.clienteId,
//           mediaPlanId: data.planoId,
//           equipments: data.equipamentosSelecionados,

//           adsCount: parseInt(data.quantidadeAnuncios, 10) || 1,

//           startDate: formatYmd(data.dataInicio),
//           endDate: formatYmd(data.dataTermino),

//           discount: Number(data.desconto) || 0,
//           discountPerInstallment: Number(data.descontoParcela) || 0,

//           generateInvoices: deveGerarBoletos,

//           generateContract: deveGerarContrato,
//           sendContractToAutentique: deveEnviarContrato,
//           contractTemplateId: data.contractTemplateId || undefined,

//           financial: {
//             installmentsCount: data.parcelas.length || 1,
//             firstDueDate: formatYmd(firstDate),
//           },
//         };

//         const res = await api.post('/orders', payload);

//         const pedidoCriado = await api.get(`/orders/${res.data.id}`);
//         const pedidoFormatado = formatarPedido(pedidoCriado.data);

//         await fetchPedidos();

//         setCurrentPedido(pedidoFormatado);
//         setShowModal(true);

//         if (deveGerarBoletos) {
//           toast.success('Pedido criado! Gerando boletos...');
//           startPollingInvoices(res.data.id);
//         } else if (data.gerarBoletos && !hasLytexConfig) {
//           toast.warning('Pedido criado sem boletos — credenciais Lytex não configuradas.');
//         } else {
//           toast.success('Pedido criado com sucesso.');
//         }

//         if (deveGerarContrato) {
//           toast.success('Contrato gerado em rascunho.');
//         }

//         if (data.enviarContratoAutentique && !hasAutentiqueConfig) {
//           toast.warning('Contrato não enviado — Autentique não configurada.');
//         }

//         if (deveEnviarContrato) {
//           if (res.data?.contractSentToAutentique) {
//             toast.success('Contrato enviado para Autentique!');
//           } else if (res.data?.autentiqueError) {
//             toast.warning(`Contrato não enviado: ${res.data.autentiqueError}`);
//           } else {
//             toast.info('Envio para Autentique solicitado.');
//           }
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.error || 'Erro ao salvar pedido.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleCancelar = async (pedido) => {
//     if (!window.confirm('Cancelar este pedido?')) return;

//     try {
//       await api.patch(`/orders/${pedido.id}/cancel`);
//       toast.success('Pedido cancelado!');
//       fetchPedidos();
//     } catch (err) {
//       setError(err.response?.data?.error || 'Erro ao cancelar pedido.');
//     }
//   };

//   const handleDelete = async () => {
//     if (!pedidoToDelete) return;

//     try {
//       await api.delete(`/orders/${pedidoToDelete.id}`);

//       toast.success('Pedido excluído!');
//       setShowDeleteModal(false);
//       setPedidoToDelete(null);
//       fetchPedidos();
//     } catch {
//       setError('Erro ao excluir pedido.');
//     }
//   };

//   const filteredPedidos = pedidos.filter(p => {
//     const matchSearch =
//       !searchTerm ||
//       p.clienteNome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       p.planos?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       String(p.id).includes(searchTerm);

//     const matchStatus = !statusPedidoFilter || p.status === statusPedidoFilter;
//     const matchContrato = !statusContratoFilter || p.statusContrato === statusContratoFilter;

//     return matchSearch && matchStatus && matchContrato;
//   });

//   return (
//     <Container fluid className="p-4">
//       <PageHeader
//         title="Pedidos"
//         buttonLabel="Novo Pedido"
//         onButtonClick={() => {
//           setCurrentPedido(null);
//           setShowModal(true);
//         }}
//       />

//       {error && (
//         <Alert variant="danger" dismissible onClose={() => setError('')}>
//           {error}
//         </Alert>
//       )}

//       {hasBoletoAccess && hasLytexConfig === false && (
//         <Alert variant="warning" className="d-flex align-items-center">
//           <FaExclamationTriangle className="me-2 flex-shrink-0" size={20} />
//           <div>
//             <strong>Lytex não configurada.</strong> Seu plano permite geração de boletos, mas você ainda não configurou as credenciais.
//             {' '}Os pedidos serão criados <strong>sem boletos</strong> até que você configure a integração em{' '}
//             <a href="/configuracoes/integracoes">Configurações → Integrações</a>.
//           </div>
//         </Alert>
//       )}

//       {hasContratoAccess && hasAutentiqueConfig === false && (
//         <Alert variant="warning" className="d-flex align-items-center">
//           <FaExclamationTriangle className="me-2 flex-shrink-0" size={20} />
//           <div>
//             <strong>Autentique não configurada.</strong> Seu plano permite contratos digitais, mas o token da Autentique ainda não foi configurado.
//             {' '}O contrato poderá ser criado em rascunho, mas não será enviado automaticamente para assinatura até configurar em{' '}
//             <a href="/configuracoes/integracoes">Configurações → Integrações</a>.
//           </div>
//         </Alert>
//       )}

//       {/* ── Filtros ── */}
//       <Card className="mb-4 shadow-sm border-0">
//         <Card.Body>
//           <Row className="mb-3">
//             <Col>
//               <InputGroup>
//                 <InputGroup.Text className="bg-white">
//                   <FaSearch className="text-muted" />
//                 </InputGroup.Text>
//                 <Form.Control
//                   placeholder="Buscar por cliente, plano..."
//                   value={searchTerm}
//                   onChange={e => setSearchTerm(e.target.value)}
//                 />
//               </InputGroup>
//             </Col>
//           </Row>

//           <Row className="g-3">
//             <Col md={4}>
//               <Form.Label className="small text-muted mb-1">Status do Pedido</Form.Label>
//               <Form.Select
//                 size="sm"
//                 value={statusPedidoFilter}
//                 onChange={e => setStatusPedidoFilter(e.target.value)}
//               >
//                 <option value="">Todos</option>
//                 <option value="ativo">Ativo</option>
//                 <option value="finalizado">Finalizado</option>
//                 <option value="cancelado">Cancelado</option>
//               </Form.Select>
//             </Col>

//             <Col md={4}>
//               <Form.Label className="small text-muted mb-1">Status do Contrato</Form.Label>
//               <Form.Select
//                 size="sm"
//                 value={statusContratoFilter}
//                 onChange={e => setStatusContratoFilter(e.target.value)}
//               >
//                 <option value="">Todos</option>
//                 <option value="pendente">Pendente</option>
//                 <option value="aguardando_assinatura">Aguardando Assinatura</option>
//                 <option value="assinado">Assinado</option>
//                 <option value="dispensado">Dispensado</option>
//               </Form.Select>
//             </Col>

//             <Col md={4} className="d-flex align-items-end gap-2">
//               <Button
//                 variant="outline-secondary"
//                 size="sm"
//                 className="w-100"
//                 onClick={() => {
//                   setSearchTerm('');
//                   setStatusPedidoFilter('');
//                   setStatusContratoFilter('');
//                 }}
//               >
//                 <FaTimes className="me-1" />
//                 Limpar Filtros
//               </Button>

//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={fetchPedidos}
//                 title="Atualizar"
//               >
//                 <FaRedo />
//               </Button>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* ── Tabela ── */}
//       {loading ? (
//         <div className="text-center mt-5">
//           <Spinner animation="border" />
//         </div>
//       ) : (
//         <Card className="shadow-sm border-0">
//           <Card.Body>
//             <div className="table-responsive">
//               <Table hover className="align-middle">
//                 <thead className="table-light">
//                   <tr>
//                     <th style={{ minWidth: 160, maxWidth: 260, width: '22%' }}>Cliente</th>
//                     <th style={{ minWidth: 160, maxWidth: 200, width: '20%' }}>Plano</th>
//                     <th className="text-center">Anúncios</th>
//                     <th>Valor Parcela</th>
//                     <th>Total</th>
//                     <th className="text-center" style={{ minWidth: 110 }}>Período</th>
//                     <th className="text-center">Status Pedido</th>
//                     <th className="text-center">Contrato</th>
//                     <th className="text-center">Ações</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {filteredPedidos.length === 0 && (
//                     <tr>
//                       <td colSpan={9} className="text-center py-4 text-muted">
//                         Nenhum pedido encontrado.
//                       </td>
//                     </tr>
//                   )}

//                   {filteredPedidos.map((p, i) => {
//                     // ✅ USA A FONTE ÚNICA — mesma fórmula do formulário
//                     const qtdEquip = Math.max(1, p.equipamentosSelecionados?.length || 1);
//                     const { totalFinal, descTotal, valorParcela } = calcularValores({
//                       quantidadeAnuncios: p.quantidadeAnuncios,
//                       valorPlano: p.valor,
//                       qtdEquipamentos: qtdEquip,
//                       desconto: p.desconto,
//                       descontoParcela: p.descontoParcela,
//                       qtdParcelas: p.parcelas.length || 1,
//                     });

//                     return (
//                       <tr key={p.id || i}>
//                         <td>
//                           <strong>{p.clienteNome}</strong>
//                           {p.clienteEmail && (
//                             <>
//                               <br />
//                               <small className="text-muted">{p.clienteEmail}</small>
//                             </>
//                           )}
//                         </td>

//                         {/* <td>{p.planos}</td> */}
//                         <td style={{ maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word' }}>
//                             <span className="d-inline-block" style={{ lineHeight: 1.25 }}>
//                                 {p.planos}
//                             </span>
//                         </td>


//                         <td className="text-center">
//                           <strong>{parseInt(p.quantidadeAnuncios || 1, 10)}</strong>
//                         </td>

//                         <td>
//                           <strong>{brl(valorParcela)}</strong>
//                         </td>

//                         <td>
//                           <strong>{brl(totalFinal)}</strong>
//                           {descTotal > 0 && (
//                             <>
//                               <br />
//                               <small className="text-danger">-{brl(descTotal)}</small>
//                             </>
//                           )}
//                         </td>

//                         <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
//                           <small className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Início</small>
//                           <small className="fw-semibold d-block">{formatBr(p.dataInicio)}</small>
//                           <hr className="my-1" />
//                           <small className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Término</small>
//                           <small className="fw-semibold d-block">{formatBr(p.dataTermino)}</small>
//                         </td>

//                         <td className="text-center">
//                           <PedidoBadge status={p.status} />
//                         </td>

//                         <td className="text-center">
//                           <ContratoBadge status={p.statusContrato} />

//                           {p.linkAssinatura && (
//                             <div className="mt-1">
//                               <a
//                                 href={p.linkAssinatura}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="small text-primary"
//                               >
//                                 <FaEye className="me-1" />
//                                 Ver Contrato
//                               </a>
//                             </div>
//                           )}
//                         </td>

//                         <td className="text-center">
//                           <div className="d-flex gap-1 justify-content-center">
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               title="Editar"
//                               onClick={async () => {
//                                 try {
//                                   const res = await api.get(`/orders/${p.id}`);
//                                   setCurrentPedido(formatarPedido(res.data));
//                                 } catch {
//                                   setCurrentPedido(p);
//                                 }

//                                 setShowModal(true);
//                               }}
//                             >
//                               <FaEdit />
//                             </Button>

//                             <Button
//                               variant="outline-danger"
//                               size="sm"
//                               title="Excluir"
//                               onClick={() => {
//                                 setPedidoToDelete(p);
//                                 setShowDeleteModal(true);
//                               }}
//                             >
//                               <FaTrash />
//                             </Button>

//                             {p.status === 'ativo' && (
//                               <Button
//                                 variant="warning"
//                                 size="sm"
//                                 title="Cancelar pedido"
//                                 onClick={() => handleCancelar(p)}
//                               >
//                                 <FaBan />
//                               </Button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {/* ── Modal Pedido ── */}
//       <Modal
//         show={showModal}
//         onHide={() => {
//           if (!saving) setShowModal(false);
//         }}
//         size="xl"
//         backdrop="static"
//       >
//         <Modal.Header closeButton={!saving}>
//           <div className="d-flex align-items-center justify-content-between w-100 me-3">
//             <Modal.Title className="d-flex align-items-center gap-2 mb-0">
//               {currentPedido?.id ? (
//                 <>
//                   <FaEdit className="text-primary" />
//                   Editar Pedido
//                 </>
//               ) : (
//                 <>
//                   <FaFileContract className="text-success" />
//                   Novo Pedido
//                 </>
//               )}
//             </Modal.Title>

//             {tier && (
//               <span
//                 className={`px-3 py-1 fw-semibold rounded-pill ${
//                   tier === 'PRO'
//                     ? 'bg-warning text-dark'
//                     : tier === 'ENTERPRISE'
//                     ? 'bg-success text-white'
//                     : 'bg-secondary text-white'
//                 }`}
//                 style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}
//               >
//                 Plano {tier}
//               </span>
//             )}
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <PedidoForm
//             pedido={currentPedido}
//             clientes={clientes}
//             planos={planos}
//             equipamentos={equipamentos}
//             contractTemplates={contractTemplates}
//             hasBoletoAccess={hasBoletoAccess}
//             hasContratoAccess={hasContratoAccess}
//             hasLytexConfig={hasLytexConfig}
//             hasAutentiqueConfig={hasAutentiqueConfig}
//             planTier={tier}
//             onSave={handleSave}
//             onCancel={() => setShowModal(false)}
//             error={error}
//             saving={saving}
//             onStartPolling={startPollingInvoices}
//             setCurrentPedido={setCurrentPedido}
//             refreshPedidos={fetchPedidos}
//           />
//         </Modal.Body>
//       </Modal>

//       {/* ── Modal Exclusão ── */}
//       <ConfirmModal
//         show={showDeleteModal}
//         onHide={() => setShowDeleteModal(false)}
//         onConfirm={handleDelete}
//         title="Confirmar Exclusão"
//         message={
//           <>
//             Tem certeza que deseja excluir o pedido de{' '}
//             <strong>{pedidoToDelete?.clienteNome}</strong>?
//           </>
//         }
//         confirmLabel="Excluir"
//         confirmVariant="danger"
//       />
//     </Container>
//   );
// }


// // ─────────────────────────────────────────
// // FORMULÁRIO DE PEDIDO
// // ─────────────────────────────────────────
// function PedidoForm({
//   pedido,
//   clientes,
//   planos,
//   equipamentos,
//   contractTemplates = [],
//   hasBoletoAccess,
//   hasContratoAccess,
//   hasLytexConfig,
//   hasAutentiqueConfig,
//   planTier,
//   onSave,
//   onCancel,
//   error,
//   saving,
//   onStartPolling,
//   setCurrentPedido,
//   refreshPedidos,
// }) {
//   const buildInit = (p) => p?.id ? {
//     id: p.id,
//     clienteId: p.clienteId,
//     planoId: p.planoId,
//     equipamentosSelecionados: p.equipamentosSelecionados || [],
//     quantidadeAnuncios: p.quantidadeAnuncios || 1,
//     valor: p.valor || '',
//     desconto: p.desconto || '0',
//     descontoParcela: p.descontoParcela || '0',
//     dataInicio: p.dataInicio || getToday(),
//     dataTermino: p.dataTermino || '',
//     status: p.status || 'ativo',
//     statusContrato: p.statusContrato || 'pendente',
//     contratoEnviado: p.contratoEnviado || false,
//     linkAssinatura: p.linkAssinatura || null,
//     dataEnvioContrato: p.dataEnvioContrato || null,
//     dataAssinaturaContrato: p.dataAssinaturaContrato || null,
//     autentiqueDocId: p.autentiqueDocId || null,

//     gerarBoletos: false,
//     gerarContrato: false,
//     enviarContratoAutentique: false,
//     contractTemplateId: '',

//     qtdParcelas: p.parcelas?.length || 1,
//     parcelas: p.parcelas || [],
//   } : {
//     id: null,
//     clienteId: '',
//     planoId: '',
//     equipamentosSelecionados: [],
//     quantidadeAnuncios: 1,
//     valor: '',
//     desconto: '0',
//     descontoParcela: '0',
//     dataInicio: getToday(),
//     dataTermino: '',
//     status: 'ativo',
//     statusContrato: 'pendente',
//     contratoEnviado: false,
//     linkAssinatura: null,
//     dataEnvioContrato: null,
//     dataAssinaturaContrato: null,
//     autentiqueDocId: null,

//     gerarBoletos: hasBoletoAccess && hasLytexConfig === true,
//     gerarContrato: hasContratoAccess === true,
//     enviarContratoAutentique: hasContratoAccess === true && hasAutentiqueConfig === true,
//     contractTemplateId: '',

//     qtdParcelas: 1,
//     parcelas: [],
//   };

//   const [formData, setFormData] = useState(() => buildInit(pedido));

//   const [generatingInvoice, setGeneratingInvoice] = useState(null);
//   const [generatingAll, setGeneratingAll] = useState(false);
//   const [generatingReceipt, setGeneratingReceipt] = useState(null);
//   const [cancelingInstallment, setCancelingInstallment] = useState(null);
//   const [cancelingRemaining, setCancelingRemaining] = useState(false);

//   // 🔑 Identificador estável do pedido
//   const pedidoKey = pedido?.id ?? null;

//   // 🔑 "Fingerprint" das parcelas + contrato vindos do PAI.
//   const pedidoFingerprint = pedido
//     ? [
//         (pedido.parcelas || [])
//           .map(p => `${p.id}:${p.invoiceUrl || ''}:${p.cancelada ? 1 : 0}:${p.pago ? 1 : 0}`)
//           .join('|'),
//         pedido.statusContrato || '',
//         pedido.status || '',
//         pedido.linkAssinatura || '',
//       ].join('#')
//     : '';

//   useEffect(() => {
//     setFormData(prev => {
//       if (!prev.id || prev.id !== pedidoKey) {
//         return buildInit(pedido);
//       }

//       if (!pedido) return prev;

//       return {
//         ...prev,
//         parcelas: pedido.parcelas || prev.parcelas,
//         statusContrato: pedido.statusContrato ?? prev.statusContrato,
//         linkAssinatura: pedido.linkAssinatura ?? prev.linkAssinatura,
//         contratoEnviado: pedido.contratoEnviado ?? prev.contratoEnviado,
//         dataEnvioContrato: pedido.dataEnvioContrato ?? prev.dataEnvioContrato,
//         dataAssinaturaContrato: pedido.dataAssinaturaContrato ?? prev.dataAssinaturaContrato,
//         autentiqueDocId: pedido.autentiqueDocId ?? prev.autentiqueDocId,
//         status: pedido.status ?? prev.status,
//       };
//     });
//   }, [pedidoKey, pedidoFingerprint]); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     if (!pedidoKey) {
//       setFormData(prev => ({
//         ...prev,
//         gerarBoletos: hasBoletoAccess && hasLytexConfig === true,
//         gerarContrato: hasContratoAccess === true,
//         enviarContratoAutentique: hasContratoAccess === true && hasAutentiqueConfig === true,
//       }));
//     }
//   }, [
//     hasLytexConfig,
//     hasBoletoAccess,
//     hasContratoAccess,
//     hasAutentiqueConfig,
//     pedidoKey
//   ]);

//   const refreshFormData = async () => {
//     if (!formData.id) return;

//     try {
//       const res = await api.get(`/orders/${formData.id}`);
//       const atualizado = formatarPedido(res.data);

//       setCurrentPedido(atualizado);
//       refreshPedidos?.();
//     } catch {
//       // silencioso
//     }
//   };

//   const aplicarMudanca = (updates) => {
//     setFormData(prev => {
//       const next = { ...prev, ...updates };

//       if (next.id) {
//         return next;
//       }

//       const p = planos.find(x => x.id === next.planoId);

//       if (!p || !next.dataInicio || !isValidYmd(next.dataInicio)) {
//         return { ...next, parcelas: [] };
//       }

//       next.valor = p.valor;
//       const qtdEquip = Math.max(1, next.equipamentosSelecionados.length);

//       const { totalFinal, valorParcela, qtdParc } = calcularValores({
//         quantidadeAnuncios: next.quantidadeAnuncios,
//         valorPlano: p.valor,
//         qtdEquipamentos: qtdEquip,
//         desconto: next.desconto,
//         descontoParcela: next.descontoParcela,
//         qtdParcelas: next.qtdParcelas,
//       });

//       if (totalFinal <= 0) {
//         return { ...next, parcelas: [] };
//       }

//       const novas = generateParcelas(
//         next.dataInicio, p.duracao, p.unidade, valorParcela, totalFinal, qtdParc
//       );

//       const merged = novas.map((nova, i) => ({
//         ...nova,
//         dataVencimento: prev.parcelas[i]?.dataVencimento || nova.dataVencimento,
//         pago: prev.parcelas[i]?.pago || false,
//         dataPagamento: prev.parcelas[i]?.dataPagamento || '',
//         valorPago: prev.parcelas[i]?.valorPago,
//       }));

//       return { ...next, parcelas: merged };
//     });
//   };

//   const handleGenerateOne = async (installmentId) => {
//     if (hasLytexConfig !== true) {
//       return toast.warning('Configure a integração Lytex antes de gerar boletos.');
//     }

//     setGeneratingInvoice(installmentId);

//     try {
//       await api.post(`/financial/installments/${installmentId}/generate-invoice`);

//       toast.success('Boleto gerado! Atualizando dados...');

//       setTimeout(async () => {
//         await refreshFormData();
//         setGeneratingInvoice(null);
//       }, 2000);
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao gerar boleto.');
//       setGeneratingInvoice(null);
//     }
//   };

//   const handleReissueOne = async (installmentId) => {
//     if (hasLytexConfig !== true) {
//       return toast.warning('Configure a integração Lytex antes de reemitir boletos.');
//     }

//     const parcela = formData.parcelas.find(p => p.id === installmentId);
//     if (!parcela) return;

//     const mensagem =
//       `Reemitir boleto da Parcela ${parcela.numero}?\n\n` +
//       `📅 Novo vencimento: ${parcela.dataVencimento}\n` +
//       `💰 Valor: R$ ${Number(parcela.valor).toFixed(2)}\n\n` +
//       `O boleto anterior será invalidado.`;

//     if (!window.confirm(mensagem)) return;

//     setGeneratingInvoice(installmentId);

//     try {
//       await api.post(
//         `/financial/installments/${installmentId}/generate-invoice?force=true`,
//         {
//           newDueDate: parcela.dataVencimento,
//           newAmount: Number(parcela.valor)
//         }
//       );

//       toast.success('Boleto reemitido com os novos dados!');

//       setTimeout(async () => {
//         await refreshFormData();
//         setGeneratingInvoice(null);
//       }, 2000);
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao reemitir boleto.');
//       setGeneratingInvoice(null);
//     }
//   };

//   const handleGenerateAll = async () => {
//     if (hasLytexConfig !== true) {
//       return toast.warning('Configure a integração Lytex antes de gerar boletos.');
//     }

//     if (!window.confirm('Gerar boletos para todas as parcelas pendentes deste pedido?')) return;

//     setGeneratingAll(true);

//     try {
//       const res = await api.post(`/orders/${formData.id}/generate-invoices`);
//       const { total, generated, failed } = res.data;

//       if (generated > 0) {
//         toast.success(`${generated} de ${total} boletos gerados!`);
//         onStartPolling?.(formData.id);
//       }

//       if (failed > 0) {
//         toast.warning(`${failed} boleto(s) falharam.`);
//         console.warn('[Boletos] Erros:', res.data.errors);
//       }

//       if (total === 0) {
//         toast.info('Nenhuma parcela pendente de boleto.');
//       }

//       await refreshFormData();
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao gerar boletos.');
//     } finally {
//       setGeneratingAll(false);
//     }
//   };

//   const handleGenerateReceipt = async (installmentId) => {
//     setGeneratingReceipt(installmentId);

//     try {
//       const response = await api.get(
//         `/receipts/installment/${installmentId}`,
//         { responseType: 'blob' }
//       );

//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const url = window.URL.createObjectURL(blob);

//       window.open(url, '_blank');

//       setTimeout(() => window.URL.revokeObjectURL(url), 10000);

//       toast.success('Recibo gerado!');
//     } catch (err) {
//       let msg = 'Erro ao gerar recibo.';

//       if (err.response?.data instanceof Blob) {
//         try {
//           const text = await err.response.data.text();
//           msg = JSON.parse(text).error || msg;
//         } catch {
//           // ignora
//         }
//       } else {
//         msg = err.response?.data?.error || msg;
//       }

//       toast.error(msg);
//     } finally {
//       setGeneratingReceipt(null);
//     }
//   };

//   const handleCancelInstallment = async (parcela) => {
//     const msg =
//       `Cancelar a Parcela ${parcela.numero}?\n\n` +
//       `💰 Valor: R$ ${Number(parcela.valor).toFixed(2)}\n` +
//       `📅 Vencimento: ${parcela.dataVencimento}\n\n` +
//       (parcela.invoiceUrl ? '⚠️ O boleto na Lytex também será cancelado.\n' : '') +
//       'Esta ação não pode ser desfeita.';

//     if (!window.confirm(msg)) return;

//     setCancelingInstallment(parcela.id);

//     try {
//       const res = await api.patch(`/installments/${parcela.id}/cancel`);

//       if (res.data?.lytexCanceled === false && parcela.invoiceUrl) {
//         toast.warning('Parcela cancelada, mas falha ao cancelar boleto na Lytex.');
//       } else {
//         toast.success('Parcela cancelada!');
//       }

//       await refreshFormData();
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao cancelar parcela.');
//     } finally {
//       setCancelingInstallment(null);
//     }
//   };

//   const handleCancelRemaining = async () => {
//     const pendentes = formData.parcelas.filter(p => !p.pago && !p.cancelada).length;

//     if (pendentes === 0) {
//       return toast.info('Não há parcelas pendentes para cancelar.');
//     }

//     const msg =
//       `Cancelar TODAS as ${pendentes} parcelas pendentes deste pedido?\n\n` +
//       `⚠️ Os boletos correspondentes também serão cancelados na Lytex.\n` +
//       `Esta ação não pode ser desfeita.`;

//     if (!window.confirm(msg)) return;

//     setCancelingRemaining(true);

//     try {
//       const res = await api.patch(`/orders/${formData.id}/cancel-remaining`, {
//         finalizeOrder: false
//       });

//       const { canceled, lytexCanceled, lytexFailed } = res.data;

//       toast.success(
//         `${canceled} parcela(s) cancelada(s). ` +
//         `${lytexCanceled} boleto(s) cancelados na Lytex` +
//         (lytexFailed > 0 ? ` (${lytexFailed} falha(s))` : '') + `.`
//       );

//       await refreshFormData();
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao cancelar parcelas.');
//     } finally {
//       setCancelingRemaining(false);
//     }
//   };

//   const parcelasSemBoleto = formData.parcelas.filter(p => !p.invoiceUrl && !p.pago && !p.cancelada).length;
//   const parcelasPendentes = formData.parcelas.filter(p => !p.pago && !p.cancelada).length;

//   // ── Derivados (FONTE ÚNICA — usa planoAtual.valor como verdade) ──
//   const planoAtual = planos.find(x => x.id === formData.planoId);
//   const isDias = ['dias', 'days'].includes(planoAtual?.unidade?.toLowerCase());
//   const qtdEquipamentos = Math.max(1, formData.equipamentosSelecionados.length);

//   const valorPlanoVerdade = planoAtual?.valor ?? formData.valor;

//   const {
//     valorBase: valorTotalBase,
//     totalFinal: valorTotalFinal,
//     valorParcela: valorParcelaFinal,
//   } = calcularValores({
//     quantidadeAnuncios: formData.quantidadeAnuncios,
//     valorPlano: valorPlanoVerdade,
//     qtdEquipamentos,
//     desconto: formData.desconto,
//     descontoParcela: formData.descontoParcela,
//     qtdParcelas: formData.qtdParcelas,
//   });

//   const getValorExibido = (parcela) =>
//     formData.id ? parcela.valor : valorParcelaFinal;

//   const clienteOptions = clientes.map(c => ({
//     value: c.id,
//     label: `${c.nome} (${c.cnpj || 'N/A'})`
//   }));

//   const planoOptions = planos.map(p => ({
//     value: p.id,
//     label: `${p.nome} - R$ ${p.valor}`
//   }));

//   const equipamentoOptions = equipamentos.map(e => ({
//     value: e.id,
//     label: e.nome
//   }));

//   const templateOptions = contractTemplates.map(t => ({
//     value: t.id,
//     label: t.name || t.nome || t.title || t.titulo || `Modelo ${t.id}`
//   }));

//   // ─────────────────────────────────────────
//   // HANDLERS — todos passam por aplicarMudanca
//   // ─────────────────────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     const updates = { [name]: value };

//     if (name === 'dataInicio' && isValidYmd(value)) {
//       const p = planos.find(x => x.id === formData.planoId);
//       if (p) {
//         updates.dataTermino = calculateEndDate(value, p.duracao, p.unidade);
//       }
//     }

//     aplicarMudanca(updates);
//   };

//   const handleQtdParcelasChange = (e) => {
//     const qtd = Math.max(1, parseInt(e.target.value, 10) || 1);
//     aplicarMudanca({ qtdParcelas: qtd });
//   };

//   const handleSelectChange = (name, selected) => {
//     const value = selected?.value || '';

//     const updates = { [name]: value };

//     if (name === 'planoId') {
//       const p = planos.find(x => x.id === value);

//       if (p && formData.dataInicio) {
//         const qtdSugerida = ['dias', 'days'].includes(p.unidade?.toLowerCase())
//           ? 1
//           : parseInt(p.duracao || 1, 10);

//         updates.valor = p.valor;
//         updates.qtdParcelas = qtdSugerida;
//         updates.dataTermino = calculateEndDate(formData.dataInicio, p.duracao, p.unidade);
//       } else if (!value) {
//         updates.valor = '';
//         updates.qtdParcelas = 1;
//         updates.dataTermino = '';
//       }
//     }

//     aplicarMudanca(updates);
//   };

//   const handleEquipamentosChange = (selected) => {
//     const value = selected ? selected.map(x => x.value) : [];
//     aplicarMudanca({ equipamentosSelecionados: value });
//   };

//   const handleParcelaChange = (index, field, value) => {
//     setFormData(prev => {
//       const novas = [...prev.parcelas];

//       if (field === 'pago') {
//         novas[index] = {
//           ...novas[index],
//           pago: value,
//           dataPagamento: value ? getToday() : '',
//           valorPago: value ? (novas[index].valorPago ?? novas[index].valor) : '',
//         };
//       } else {
//         novas[index] = { ...novas[index], [field]: value };
//       }

//       return { ...prev, parcelas: novas };
//     });
//   };

//   const handleGerarContratoChange = (checked) => {
//     setFormData(prev => ({
//       ...prev,
//       gerarContrato: checked,
//       enviarContratoAutentique: checked && hasAutentiqueConfig === true,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (saving) return;

//     if (
//       !formData.clienteId ||
//       !formData.planoId ||
//       formData.equipamentosSelecionados.length === 0
//     ) {
//       return toast.warning('Preencha Cliente, Plano e ao menos um Equipamento.');
//     }

//     if (!formData.id) {
//       const parcelasSincronizadas = formData.parcelas.map((parcela) => ({
//         ...parcela,
//         valor: valorParcelaFinal,
//       }));

//       if (parcelasSincronizadas.length > 0) {
//         const n = parcelasSincronizadas.length;
//         const somaParcial = Number((valorParcelaFinal * (n - 1)).toFixed(2));
//         parcelasSincronizadas[n - 1] = {
//           ...parcelasSincronizadas[n - 1],
//           valor: Number((valorTotalFinal - somaParcial).toFixed(2)),
//         };
//       }

//       return onSave({ ...formData, parcelas: parcelasSincronizadas });
//     }

//     onSave(formData);
//   };

//   const boletosPendentes = formData.id && hasBoletoAccess && formData.gerarBoletos
//     ? formData.parcelas.filter(p => !p.invoiceUrl && !p.cancelada).length
//     : 0;

//   const pedidoSemBoletos = formData.id && hasBoletoAccess
//     && formData.parcelas.length > 0
//     && formData.parcelas.every(p => !p.invoiceUrl)
//     && !formData.gerarBoletos;

//   const camposEntrada = [
//     { label: 'Anúncios', name: 'quantidadeAnuncios', value: formData.quantidadeAnuncios, type: 'number' },
//     { label: 'Desc. Global (R$)', name: 'desconto', value: formData.desconto, type: 'number' },
//     { label: 'Desc/Parcela (R$)', name: 'descontoParcela', value: formData.descontoParcela, type: 'number' },
//   ];


//   return (
//     <div>
//       {error && (
//         <Alert variant="danger" className="mb-3">
//           {error}
//         </Alert>
//       )}

//       {boletosPendentes > 0 && (
//         <Alert variant="info" className="d-flex align-items-center gap-2 mb-3">
//           <Spinner animation="border" size="sm" />
//           <span>
//             Gerando boletos em background...{' '}
//             <strong>{boletosPendentes} parcela{boletosPendentes > 1 ? 's' : ''}</strong> aguardando.
//           </span>
//         </Alert>
//       )}

//       {pedidoSemBoletos && (
//         <Alert variant="secondary" className="d-flex align-items-center gap-2 mb-3">
//           <FaFileInvoiceDollar size={18} className="flex-shrink-0" />
//           <span>
//             Este pedido foi criado <strong>sem geração de boletos</strong>.
//             Controle os pagamentos manualmente nas parcelas abaixo.
//           </span>
//         </Alert>
//       )}

//       <Form onSubmit={handleSubmit}>
//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 1: DADOS DO PEDIDO                  */}
//         {/* ═══════════════════════════════════════ */}
//         <Card className="mb-3 border-0 shadow-sm">
//           <Card.Header className="bg-white fw-semibold border-bottom">
//             <FaFileContract className="me-2 text-primary" />
//             Dados do Pedido
//           </Card.Header>
//           <Card.Body>
//             <Row>
//               <Col md={12}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Cliente *</Form.Label>
//                   <Select
//                     {...selectFix}
//                     options={clienteOptions}
//                     value={clienteOptions.find(o => o.value === formData.clienteId) || null}
//                     onChange={s => handleSelectChange('clienteId', s)}
//                     placeholder="Buscar cliente..."
//                     isClearable
//                     isDisabled={saving}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Equipamentos *</Form.Label>
//                   <Select
//                     {...selectFix}
//                     isMulti
//                     options={equipamentoOptions}
//                     value={equipamentoOptions.filter(o => formData.equipamentosSelecionados.includes(o.value))}
//                     onChange={handleEquipamentosChange}
//                     placeholder="Selecione painéis..."
//                     noOptionsMessage={() => 'Nenhum encontrado'}
//                     isDisabled={saving}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Plano *</Form.Label>
//                   <Select
//                     {...selectFix}
//                     options={planoOptions}
//                     value={planoOptions.find(o => o.value === formData.planoId) || null}
//                     onChange={s => handleSelectChange('planoId', s)}
//                     placeholder="Selecione um plano..."
//                     isClearable
//                     isDisabled={saving}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 2: VALORES                          */}
//         {/* ═══════════════════════════════════════ */}
//         <Card className="mb-3 border-0 shadow-sm">
//           <Card.Header className="bg-white fw-semibold border-bottom">
//             <FaFileInvoiceDollar className="me-2 text-success" />
//             Valores e Descontos
//           </Card.Header>
//           <Card.Body>
//             <Row className="g-3 align-items-end">
//               {camposEntrada.map(({ label, name, value, type }) => (
//                 <Col md={3} key={name}>
//                   <Form.Group>
//                     <Form.Label className="small">{label}</Form.Label>
//                     <Form.Control
//                       type={type}
//                       name={name}
//                       value={value}
//                       onChange={handleChange}
//                       readOnly={saving}
//                       min="0"
//                       step={['desconto', 'descontoParcela'].includes(name) ? '0.01' : undefined}
//                     />
//                   </Form.Group>
//                 </Col>
//               ))}
//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">
//                     Nº de Parcelas
//                     {planoAtual && (
//                       <span className="text-muted ms-2">
//                         (Plano: {planoAtual.duracao} {planoAtual.unidade})
//                       </span>
//                     )}
//                   </Form.Label>

//                   <Form.Control
//                     type="number"
//                     name="qtdParcelas"
//                     value={formData.qtdParcelas}
//                     min="1"
//                     max="120"
//                     disabled={saving || isDias}
//                     onChange={handleQtdParcelasChange}
//                   />

//                   {isDias && (
//                     <Form.Text className="text-muted">
//                       Planos em dias sempre geram 1 parcela.
//                     </Form.Text>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>

//             <Row className="mt-2 justify-content-center">
//               <Col md={12}>
//                 <div className="d-flex gap-3 flex-wrap">
//                   <div className="text-center px-3 py-2 rounded bg-light flex-grow-1">
//                     <small className="text-muted d-block">Valor Base</small>
//                     <strong>{brl(valorTotalBase)}</strong>
//                   </div>
//                   <div className="text-center px-3 py-2 rounded flex-grow-1" style={{ backgroundColor: '#e8f5e9' }}>
//                     <small className="text-muted d-block">Total Final</small>
//                     <strong style={{ color: '#28a745' }}>{brl(valorTotalFinal)}</strong>
//                   </div>
//                   <div className="text-center px-3 py-2 rounded flex-grow-1" style={{ backgroundColor: '#e7f1ff' }}>
//                     <small className="text-muted d-block">Valor/Parcela</small>
//                     <strong style={{ color: '#0d6efd' }}>{brl(valorParcelaFinal)}</strong>
//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 3: DATAS E STATUS                   */}
//         {/* ═══════════════════════════════════════ */}
//         <Card className="mb-3 border-0 shadow-sm">
//           <Card.Header className="bg-white fw-semibold border-bottom">
//             <FaCalendarAlt className="me-2 text-info" />
//             Período e Status
//           </Card.Header>
//           <Card.Body>
//             <Row className="g-3">
//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">Data de Início *</Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="dataInicio"
//                     value={formData.dataInicio}
//                     min="2020-01-01"
//                     max="2100-12-31"
//                     onChange={handleChange}
//                     required
//                     disabled={saving}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">Data de Término</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={formData.dataTermino}
//                     readOnly
//                     style={{ backgroundColor: '#e9ecef' }}
//                   />
//                 </Form.Group>
//               </Col>

//               {hasContratoAccess && (
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small">Status do Contrato</Form.Label>
//                     <Form.Select
//                       name="statusContrato"
//                       value={formData.statusContrato}
//                       onChange={handleChange}
//                       disabled={saving}
//                     >
//                       <option value="pendente">Pendente</option>
//                       <option value="aguardando_assinatura">Aguardando Assinatura</option>
//                       <option value="assinado">Assinado</option>
//                       <option value="dispensado">Dispensado</option>
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//               )}

//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">Status do Pedido</Form.Label>
//                   <div className="d-flex gap-2 flex-wrap">
//                     {[
//                       { s: 'ativo', label: 'Ativo', color: '#198754' },
//                       { s: 'finalizado', label: 'Finalizado', color: '#6c757d' },
//                       { s: 'cancelado', label: 'Cancelado', color: '#dc3545' },
//                     ].map(({ s, label, color }) => (
//                       <Button
//                         key={s}
//                         size="sm"
//                         type="button"
//                         variant={formData.status === s ? undefined : 'outline-secondary'}
//                         style={formData.status === s ? {
//                           backgroundColor: color,
//                           borderColor: color,
//                           color: '#fff'
//                         } : {}}
//                         disabled={saving}
//                         onClick={() => setFormData(prev => ({ ...prev, status: s }))}
//                       >
//                         {label}
//                       </Button>
//                     ))}
//                   </div>
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 4: AUTOMAÇÕES (boletos + contrato)  */}
//         {/* ═══════════════════════════════════════ */}
//         {!formData.id && (hasBoletoAccess || hasContratoAccess) && (
//           <Card className="mb-3 border-0 shadow-sm">
//             <Card.Header className="bg-white fw-semibold border-bottom">
//               <FaBolt className="me-2 text-warning" />
//               Automações do Pedido
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-4">
//                 {/* ── Coluna Boletos ── */}
//                 {hasBoletoAccess && (
//                   <Col md={hasContratoAccess ? 6 : 12}>
//                     <Form.Check
//                       type="switch"
//                       id="gerar-boletos-switch"
//                       checked={formData.gerarBoletos && hasLytexConfig === true}
//                       disabled={saving || hasLytexConfig !== true}
//                       onChange={e => setFormData(prev => ({ ...prev, gerarBoletos: e.target.checked }))}
//                       label={
//                         <span className="fw-semibold">
//                           <FaFileInvoiceDollar className="me-2 text-primary" />
//                           Gerar boletos (Lytex)
//                         </span>
//                       }
//                     />

//                     <div className="ms-4 mt-1">
//                       {hasLytexConfig === null && (
//                         <small className="text-muted">
//                           <Spinner animation="border" size="sm" className="me-1" />
//                           Verificando integração Lytex...
//                         </small>
//                       )}

//                       {hasLytexConfig === true && (
//                         <small className="text-muted">
//                           Desmarque se o cliente pagará em dinheiro/PIX, ou se você está
//                           migrando dados de um sistema antigo.
//                         </small>
//                       )}

//                       {hasLytexConfig === false && (
//                         <small className="text-warning">
//                           <FaExclamationTriangle className="me-1" />
//                           <strong>Credenciais Lytex não configuradas.</strong>{' '}
//                           <a href="/configuracoes/integracoes">Configurar agora</a>
//                         </small>
//                       )}
//                     </div>
//                   </Col>
//                 )}

//                 {/* ── Coluna Contrato ── */}
//                 {hasContratoAccess && (
//                   <Col md={hasBoletoAccess ? 6 : 12} className={hasBoletoAccess ? 'border-start' : ''}>
//                     <Form.Check
//                       type="switch"
//                       id="gerar-contrato-switch"
//                       checked={formData.gerarContrato}
//                       disabled={saving}
//                       onChange={e => handleGerarContratoChange(e.target.checked)}
//                       label={
//                         <span className="fw-semibold">
//                           <FaFileContract className="me-2 text-info" />
//                           Gerar contrato automaticamente
//                         </span>
//                       }
//                     />

//                     <small className="text-muted d-block ms-4 mt-1">
//                       Ao criar o pedido, o sistema gera o contrato com os dados do cliente, plano e período.
//                     </small>

//                     {formData.gerarContrato && (
//                       <div className="ms-4 mt-3 ps-3 border-start border-2 border-info-subtle">
//                         {templateOptions.length > 0 && (
//                           <Form.Group className="mb-3">
//                             <Form.Label className="small fw-semibold">Modelo de Contrato</Form.Label>
//                             <Select
//                               {...selectFix}
//                               options={templateOptions}
//                               value={
//                                 templateOptions.find(o => o.value === formData.contractTemplateId) || null
//                               }
//                               onChange={s => setFormData(prev => ({
//                                 ...prev,
//                                 contractTemplateId: s?.value || ''
//                               }))}
//                               placeholder="Selecione um modelo..."
//                               isDisabled={saving}
//                               isClearable
//                             />
//                           </Form.Group>
//                         )}

//                         <Form.Check
//                           type="switch"
//                           id="enviar-autentique-switch"
//                           checked={formData.enviarContratoAutentique && hasAutentiqueConfig === true}
//                           disabled={saving || hasAutentiqueConfig !== true}
//                           onChange={e => setFormData(prev => ({
//                             ...prev,
//                             enviarContratoAutentique: e.target.checked
//                           }))}
//                           label={
//                             <span className="fw-semibold small">
//                               <FaPaperPlane className="me-1 text-info" />
//                               Enviar para Autentique após criar
//                             </span>
//                           }
//                         />

//                         <div className="ms-4 mt-1">
//                           {hasAutentiqueConfig === null && (
//                             <small className="text-muted">
//                               <Spinner animation="border" size="sm" className="me-1" />
//                               Verificando integração Autentique...
//                             </small>
//                           )}

//                           {hasAutentiqueConfig === true && (
//                             <small className="text-muted">
//                               O contrato será enviado automaticamente para assinatura digital.
//                             </small>
//                           )}

//                           {hasAutentiqueConfig === false && (
//                             <small className="text-warning">
//                               <FaExclamationTriangle className="me-1" />
//                               <strong>Token da Autentique não configurado.</strong>{' '}
//                               <a href="/configuracoes/integracoes">Configurar agora</a>
//                             </small>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </Col>
//                 )}
//               </Row>
//             </Card.Body>
//           </Card>
//         )}

//         {/* ── Info contrato (modo edição) ── */}
//         {(formData.contratoEnviado || formData.linkAssinatura) && (
//           <Card className="mb-3 border-info shadow-sm">
//             <Card.Header className="bg-info text-white">
//               <FaFileContract className="me-2" />
//               Informações do Contrato
//             </Card.Header>

//             <Card.Body>
//               <Row className="g-3">
//                 {formData.dataEnvioContrato && (
//                   <Col md={3}>
//                     <strong>Envio:</strong>
//                     <br />
//                     {formatBr(formData.dataEnvioContrato)}
//                   </Col>
//                 )}

//                 {formData.dataAssinaturaContrato && (
//                   <Col md={3}>
//                     <strong>Assinatura:</strong>
//                     <br />
//                     {formatBr(formData.dataAssinaturaContrato)}
//                   </Col>
//                 )}

//                 {formData.autentiqueDocId && (
//                   <Col md={3}>
//                     <strong>ID Autentique:</strong>
//                     <br />
//                     <small>{formData.autentiqueDocId}</small>
//                   </Col>
//                 )}

//                 {formData.linkAssinatura && (
//                   <Col md={3} className="d-flex align-items-center">
//                     <a
//                       href={formData.linkAssinatura}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="btn btn-sm btn-outline-primary"
//                     >
//                       <FaEye className="me-1" />
//                       Ver Contrato
//                     </a>
//                   </Col>
//                 )}
//               </Row>
//             </Card.Body>
//           </Card>
//         )}

//         {/* ── Parcelas ── */}
//         {formData.parcelas.length > 0 ? (
//           <Card className="mb-3 border-0 shadow-sm">
//             <Card.Header className="bg-white d-flex justify-content-between align-items-center flex-wrap gap-2 border-bottom">
//               <h6 className="mb-0 fw-semibold">
//                 <FaCalendarAlt className="me-2 text-info" />
//                 Parcelas ({formData.parcelas.length}x de {brl(valorParcelaFinal)})

//                 {boletosPendentes > 0 && (
//                   <span className="ms-2 text-info" style={{ fontSize: '0.8rem' }}>
//                     <Spinner animation="border" size="sm" className="me-1" />
//                     {boletosPendentes} boleto{boletosPendentes > 1 ? 's' : ''} sendo gerado{boletosPendentes > 1 ? 's' : ''}...
//                   </span>
//                 )}
//               </h6>

//               <div className="d-flex gap-2 flex-wrap">
//                 {hasBoletoAccess && formData.id && parcelasSemBoleto > 0 && (
//                   <Button
//                     size="sm"
//                     variant="warning"
//                     disabled={generatingAll || hasLytexConfig !== true}
//                     onClick={handleGenerateAll}
//                     title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : ''}
//                   >
//                     {generatingAll ? (
//                       <>
//                         <Spinner animation="border" size="sm" className="me-1" />
//                         Gerando...
//                       </>
//                     ) : (
//                       <>
//                         <FaBolt className="me-1" />
//                         Gerar {parcelasSemBoleto} boleto{parcelasSemBoleto > 1 ? 's' : ''}
//                       </>
//                     )}
//                   </Button>
//                 )}

//                 {formData.id && parcelasPendentes > 0 && (
//                   <Button
//                     size="sm"
//                     variant="outline-danger"
//                     disabled={cancelingRemaining}
//                     onClick={handleCancelRemaining}
//                   >
//                     {cancelingRemaining ? (
//                       <>
//                         <Spinner animation="border" size="sm" className="me-1" />
//                         Cancelando...
//                       </>
//                     ) : (
//                       <>
//                         <FaBan className="me-1" />
//                         Cancelar {parcelasPendentes} restante{parcelasPendentes > 1 ? 's' : ''}
//                       </>
//                     )}
//                   </Button>
//                 )}
//               </div>
//             </Card.Header>

//             <Card.Body>
//               <Row>
//                 {formData.parcelas.map((parcela, index) => (
//                   <Col md={3} key={index} className="mb-3">
//                     <Card
//                       className={`h-100 ${
//                         parcela.cancelada
//                           ? 'border-danger'
//                           : parcela.pago
//                             ? 'border-success'
//                             : 'border-warning'
//                       }`}
//                       style={parcela.cancelada ? { opacity: 0.75 } : {}}
//                     >
//                       <Card.Header
//                         className={`py-2 d-flex align-items-center justify-content-between ${
//                           parcela.cancelada
//                             ? 'bg-danger text-white'
//                             : parcela.pago
//                               ? 'bg-success text-white'
//                               : 'bg-warning text-dark'
//                         }`}
//                       >
//                         <small>
//                           Parcela {parcela.numero}
//                           {parcela.cancelada && ' (Cancelada)'}
//                         </small>

//                         {!parcela.cancelada && (
//                           <Form.Switch
//                             id={`switch-${index}`}
//                             label="Pago"
//                             checked={parcela.pago}
//                             onChange={e => handleParcelaChange(index, 'pago', e.target.checked)}
//                             className="ms-2"
//                           />
//                         )}
//                       </Card.Header>

//                       <Card.Body className="py-2">
//                         <div className="mb-2">
//                           <strong>{brl(getValorExibido(parcela))}</strong>
//                         </div>

//                         {parcela.cancelada ? (
//                           <Alert variant="danger" className="py-2 mb-0 small text-center">
//                             <FaBan className="me-1" />
//                             Parcela cancelada
//                             <div className="mt-1">
//                               <small>Venc.: {formatBr(parcela.dataVencimento)}</small>
//                             </div>
//                           </Alert>
//                         ) : (
//                           <>
//                             <Form.Label className="small">Vencimento:</Form.Label>

//                             <Form.Control
//                               type="date"
//                               size="sm"
//                               value={parcela.dataVencimento || ''}
//                               min="2020-01-01"
//                               max="2100-12-31"
//                               onChange={e => handleParcelaChange(index, 'dataVencimento', e.target.value)}
//                               className="mb-2"
//                             />

//                             {hasBoletoAccess && formData.id && (() => {
//                               if (parcela.invoiceUrl) {
//                                 return (
//                                   <div className="my-2 d-flex gap-1">
//                                     <Button
//                                       size="sm"
//                                       className="flex-grow-1"
//                                       variant={parcela.pago ? 'secondary' : 'primary'}
//                                       style={parcela.pago ? { opacity: 0.6 } : {}}
//                                       onClick={() => window.open(parcela.invoiceUrl, '_blank')}
//                                     >
//                                       <FaCheckCircle className="me-1" />
//                                       {parcela.pago ? 'Boleto Pago' : 'Baixar Boleto'}
//                                     </Button>

//                                     {!parcela.pago && (
//                                       <Button
//                                         size="sm"
//                                         variant="outline-warning"
//                                         disabled={hasLytexConfig !== true || generatingInvoice === parcela.id}
//                                         onClick={() => handleReissueOne(parcela.id)}
//                                         title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : 'Reemitir boleto'}
//                                         style={{ flexShrink: 0 }}
//                                       >
//                                         {generatingInvoice === parcela.id
//                                           ? <Spinner animation="border" size="sm" />
//                                           : <FaRedo />
//                                         }
//                                       </Button>
//                                     )}
//                                   </div>
//                                 );
//                               }

//                               if (generatingInvoice === parcela.id || generatingAll) {
//                                 return (
//                                   <Button size="sm" className="my-2 w-100" variant="secondary" disabled>
//                                     <Spinner animation="border" size="sm" className="me-1" />
//                                     Gerando...
//                                   </Button>
//                                 );
//                               }

//                               if (formData.gerarBoletos) {
//                                 return (
//                                   <Button size="sm" className="my-2 w-100" variant="secondary" disabled>
//                                     <Spinner animation="border" size="sm" className="me-1" />
//                                     Aguardando...
//                                   </Button>
//                                 );
//                               }

//                               if (parcela.pago) {
//                                 return (
//                                   <Button size="sm" className="my-2 w-100" variant="outline-success" disabled>
//                                     <FaCheckCircle className="me-1" />
//                                     Paga sem boleto
//                                   </Button>
//                                 );
//                               }

//                               return (
//                                 <Button
//                                   size="sm"
//                                   className="my-2 w-100"
//                                   variant="outline-warning"
//                                   disabled={hasLytexConfig !== true}
//                                   onClick={() => handleGenerateOne(parcela.id)}
//                                   title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : 'Gerar boleto na Lytex'}
//                                 >
//                                   <FaBolt className="me-1" />
//                                   Gerar boleto
//                                 </Button>
//                               );
//                             })()}

//                             {parcela.pago && (
//                               <>
//                                 <Form.Label className="small">Data de Pagamento:</Form.Label>

//                                 <Form.Control
//                                   type="date"
//                                   size="sm"
//                                   value={parcela.dataPagamento || ''}
//                                   min="2020-01-01"
//                                   max="2100-12-31"
//                                   onChange={e => handleParcelaChange(index, 'dataPagamento', e.target.value)}
//                                   className="mb-2"
//                                 />

//                                 <Form.Label className="small">Valor Pago:</Form.Label>

//                                 <div className="d-flex align-items-center gap-2">
//                                   <span>R$</span>
//                                   <Form.Control
//                                     type="number"
//                                     size="sm"
//                                     min="0"
//                                     step="0.01"
//                                     value={parcela.valorPago ?? parcela.valor}
//                                     onChange={e => handleParcelaChange(
//                                       index,
//                                       'valorPago',
//                                       e.target.value === '' ? '' : Number(e.target.value)
//                                     )}
//                                     className="mb-2"
//                                   />
//                                 </div>

//                                 {formData.id && parcela.id && (
//                                   <Button
//                                     size="sm"
//                                     className="w-100 mt-1"
//                                     variant="outline-success"
//                                     disabled={generatingReceipt === parcela.id}
//                                     onClick={() => handleGenerateReceipt(parcela.id)}
//                                   >
//                                     {generatingReceipt === parcela.id ? (
//                                       <>
//                                         <Spinner animation="border" size="sm" className="me-1" />
//                                         Gerando...
//                                       </>
//                                     ) : (
//                                       <>
//                                         <FaFileInvoice className="me-1" />
//                                         Gerar Recibo
//                                       </>
//                                     )}
//                                   </Button>
//                                 )}
//                               </>
//                             )}

//                             {formData.id && parcela.id && !parcela.pago && (
//                               <Button
//                                 size="sm"
//                                 className="w-100 mt-2"
//                                 variant="outline-danger"
//                                 disabled={cancelingInstallment === parcela.id}
//                                 onClick={() => handleCancelInstallment(parcela)}
//                               >
//                                 {cancelingInstallment === parcela.id ? (
//                                   <>
//                                     <Spinner animation="border" size="sm" className="me-1" />
//                                     Cancelando...
//                                   </>
//                                 ) : (
//                                   <>
//                                     <FaBan className="me-1" />
//                                     Cancelar parcela
//                                   </>
//                                 )}
//                               </Button>
//                             )}
//                           </>
//                         )}
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 ))}
//               </Row>
//             </Card.Body>
//           </Card>
//         ) : formData.id && (
//           <Alert variant="warning" className="mb-3">
//             <FaClock className="me-2" />
//             Parcelas não carregadas. Verifique o backend.
//           </Alert>
//         )}

//         {/* ── Botões ── */}
//         <div className="d-flex justify-content-end mt-4 gap-2">
//           <Button variant="secondary" type="button" onClick={onCancel} disabled={saving}>
//             <FaTimes className="me-1" />
//             Cancelar
//           </Button>

//           <Button variant="success" type="submit" disabled={saving}>
//             {saving ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 {formData.id ? 'Salvando...' : 'Criando pedido...'}
//               </>
//             ) : (
//               <>
//                 <FaSave className="me-2" />
//                 {formData.id ? 'Atualizar' : 'Criar'}
//               </>
//             )}
//           </Button>
//         </div>
//       </Form>
//     </div>
//   );
// }





// import React, { useEffect, useState, useRef } from 'react';
// import {
//   Container, Card, Table, Button, Modal, Form, Row, Col,
//   Spinner, Alert, InputGroup
// } from 'react-bootstrap';
// import {
//   FaEdit, FaTrash, FaSave, FaTimes, FaCalendarAlt,
//   FaFileContract, FaCheckCircle, FaClock,
//   FaTimesCircle, FaEye, FaSearch, FaBan, FaPaperPlane,
//   FaFileInvoiceDollar, FaExclamationTriangle, FaBolt,
//   FaRedo, FaFileInvoice
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import api from '../../services/api';
// import Select from 'react-select';

// import { PageHeader } from '../../components/shared/PageHeader';
// import { ConfirmModal } from '../../components/shared/ConfirmModal';
// import { usePlanAccess } from '../../hooks/usePlanAccess';

// // ─────────────────────────────────────────
// // SELECT FIX (resolve dropdown escondido atrás de cards)
// // ─────────────────────────────────────────
// const selectFix = {
//   menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
//   menuPosition: 'fixed',
//   styles: {
//     menuPortal: base => ({ ...base, zIndex: 9999 }),
//   },
// };

// // ─────────────────────────────────────────
// // UTILS
// // ─────────────────────────────────────────
// const toDate = (v) => {
//   if (!v) return null;

//   if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
//     const [y, m, d] = v.split('-').map(Number);
//     return new Date(y, m - 1, d, 12, 0, 0);
//   }

//   const d = new Date(v);
//   return isNaN(d) ? null : d;
// };

// const formatYmd = (v) => {
//   const d = toDate(v);
//   if (!d) return '';

//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
// };

// // Formata YYYY-MM-DD → DD/MM/YYYY (curto, sem quebrar linha)
// const formatBr = (v) => {
//   const d = toDate(v);
//   if (!d) return '-';
//   return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
// };

// const isValidYmd = (v) => {
//   if (!v || typeof v !== 'string') return false;
//   if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;

//   const year = parseInt(v.split('-')[0], 10);
//   return year >= 1900 && year <= 2100;
// };

// const getToday = () => {
//   const d = new Date();

//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
// };

// const brl = (value) => {
//   return Number(value || 0).toLocaleString('pt-BR', {
//     style: 'currency',
//     currency: 'BRL'
//   });
// };

// const calculateEndDate = (start, dur, unit) => {
//   if (!start || !dur || !unit) return '';

//   const [y, mo, d] = start.split('-').map(Number);
//   const date = new Date(y, mo - 1, d, 12, 0, 0);
//   const n = parseInt(dur, 10);

//   switch (String(unit).toLowerCase()) {
//     case 'dias':
//     case 'days':
//       date.setDate(date.getDate() + n);
//       break;

//     case 'semanas':
//     case 'weeks':
//       date.setDate(date.getDate() + n * 7);
//       break;

//     case 'meses':
//     case 'months':
//       date.setMonth(date.getMonth() + n);
//       break;

//     case 'anos':
//     case 'years':
//       date.setFullYear(date.getFullYear() + n);
//       break;

//     default:
//       return '';
//   }

//   return formatYmd(date);
// };

// // ─────────────────────────────────────────
// // CÁLCULO CENTRAL DE VALORES (FONTE ÚNICA DE VERDADE)
// // Usado tanto na tabela quanto no formulário.
// // 🔑 valorBaseManual: se vier válido (> 0), sobrescreve o cálculo automático.
// // ─────────────────────────────────────────
// const calcularValores = ({
//   quantidadeAnuncios,
//   valorPlano,
//   qtdEquipamentos,
//   desconto,
//   descontoParcela,
//   qtdParcelas,
//   valorBaseManual,
// }) => {
//   const qtdAds = Math.max(1, parseInt(quantidadeAnuncios || 1, 10));
//   const valPlano = parseFloat(valorPlano || 0);
//   const qtdEquip = Math.max(1, qtdEquipamentos || 1);
//   const descG = parseFloat(desconto || 0);
//   const descP = parseFloat(descontoParcela || 0);
//   const qtdParc = Math.max(1, parseInt(qtdParcelas || 1, 10));

//   // 🔑 Valor calculado automaticamente
//   const valorCalculado = qtdAds * valPlano * qtdEquip;

//   // 🔑 Se houver valor manual válido, usa ele. Senão, usa o calculado.
//   const temManual =
//     valorBaseManual !== undefined &&
//     valorBaseManual !== null &&
//     valorBaseManual !== '' &&
//     !isNaN(parseFloat(valorBaseManual));

//   const valorBase = temManual ? parseFloat(valorBaseManual) : valorCalculado;

//   const descTotal = descG + (descP * qtdParc);
//   const totalFinal = Math.max(valorBase - descTotal, 0);
//   const valorParcela = qtdParc > 0
//     ? Math.max((valorBase - descG) / qtdParc - descP, 0)
//     : 0;

//   return { valorBase, descTotal, totalFinal, valorParcela, qtdParc };
// };

// // ─────────────────────────────────────────
// // GERA PARCELAS — recebe o valor POR PARCELA já calculado
// // (mesma fonte do cabeçalho: valorParcela de calcularValores)
// // e distribui o resto de arredondamento na última parcela.
// // ─────────────────────────────────────────
// const generateParcelas = (start, dur, unit, valorParcela, totalFinal, qtd) => {
//   if (!start || !dur || !unit) return [];

//   const u = String(unit).toLowerCase();

//   // Planos em dias → 1 única parcela com o total final
//   if (u === 'dias' || u === 'days') {
//     return [{
//       numero: 1,
//       valor: Number(Number(totalFinal).toFixed(2)),
//       dataVencimento: start,
//       pago: false,
//       dataPagamento: '',
//     }];
//   }

//   const n = Math.max(1, parseInt(qtd || dur, 10) || 1);
//   const valParc = Number(Number(valorParcela).toFixed(2));

//   // Distribuição justa: todas iguais ao valorParcela,
//   // e a última absorve o resto de arredondamento p/ bater o total.
//   const somaParcial = valParc * (n - 1);
//   const valorUltima = Number((Number(totalFinal) - somaParcial).toFixed(2));

//   const [y, mo, d] = start.split('-').map(Number);
//   const base = new Date(y, mo - 1, d, 12, 0, 0);

//   return Array.from({ length: n }, (_, i) => {
//     const dt = new Date(base);

//     if (u === 'semanas' || u === 'weeks') {
//       dt.setDate(dt.getDate() + i * 7);
//     } else if (u === 'meses' || u === 'months') {
//       dt.setMonth(dt.getMonth() + i);
//     } else if (u === 'anos' || u === 'years') {
//       dt.setFullYear(dt.getFullYear() + i);
//     }

//     return {
//       numero: i + 1,
//       valor: i === n - 1 ? valorUltima : valParc,
//       dataVencimento: formatYmd(dt),
//       pago: false,
//       dataPagamento: '',
//     };
//   });
// };

// const normalizeContractStatus = (status) => {
//   const raw = String(status || '').trim();
//   const upper = raw.toUpperCase();
//   const lower = raw.toLowerCase();

//   if (upper === 'DRAFT') return 'pendente';
//   if (upper === 'SENT') return 'aguardando_assinatura';
//   if (upper === 'SIGNED') return 'assinado';

//   if (
//     upper === 'CANCELED' ||
//     upper === 'CANCELLED' ||
//     upper === 'DISPENSED'
//   ) {
//     return 'dispensado';
//   }

//   if (lower === 'pendente') return 'pendente';
//   if (lower === 'aguardando_assinatura') return 'aguardando_assinatura';
//   if (lower === 'assinado') return 'assinado';
//   if (lower === 'dispensado') return 'dispensado';

//   return 'pendente';
// };

// const formatarPedido = (order) => ({
//   id: order.id,
//   clienteId: order.customerId,
//   planoId: order.mediaPlanId,
//   equipamentosSelecionados: order.equipments?.map(e => e.equipmentId) ?? [],

//   status:
//     order.status === 'CANCELADO' ? 'cancelado' :
//     order.status === 'CONCLUIDO' ? 'finalizado' : 'ativo',

//   statusContrato: normalizeContractStatus(order.contracts?.[0]?.status),
//   linkAssinatura: order.contracts?.[0]?.link || null,

//   dataInicio: order.startDate ? order.startDate.split('T')[0] : '',
//   dataTermino: order.endDate ? order.endDate.split('T')[0] : '',

//   desconto: order.discount || 0,
//   descontoParcela: order.discountPerInstallment || 0,

//   // 🔑 Valor base manual vindo do backend (se existir)
//   valorBaseManual: order.baseAmount ?? null,

//   clienteNome: order.customer?.name || 'Cliente Desconhecido',
//   clienteEmail: order.customer?.email || '',
//   planos: order.mediaPlan?.name || 'Plano Desconhecido',
//   valor: order.mediaPlan?.amount || 0,

//   quantidadeAnuncios: order.adsCount ?? 1,

//   contratoEnviado:
//     order.contracts?.[0]?.sent ||
//     order.contracts?.[0]?.status === 'SENT' ||
//     order.contracts?.[0]?.status === 'SIGNED' ||
//     false,

//   dataEnvioContrato: order.contracts?.[0]?.sentAt || null,
//   dataAssinaturaContrato: order.contracts?.[0]?.signedAt || null,
//   autentiqueDocId: order.contracts?.[0]?.autentiqueId || null,

//   boletosGerados: order.invoicesGenerated ?? null,

//   parcelas: order.installments?.map(inst => ({
//     id: inst.id,
//     numero: inst.installmentNumber,
//     valor: Number(inst.amount),
//     dataVencimento: inst.dueDate ? inst.dueDate.split('T')[0] : '',
//     pago: inst.status === 'Paid' || inst.status === 'PAID',
//     cancelada: inst.status === 'CANCELED' || inst.status === 'Canceled',
//     status: inst.status,
//     dataPagamento: inst.paidAt ? inst.paidAt.split('T')[0] : '',
//     valorPago: inst.paidAmount ? Number(inst.paidAmount) : Number(inst.amount),
//     invoiceUrl: inst.paymentLink || '',
//   })) ?? [],
// });


// // ─────────────────────────────────────────
// // PILL (substitui o Badge do react-bootstrap)
// // ─────────────────────────────────────────
// const Pill = ({ color = '#6c757d', textColor = '#fff', children }) => (
//   <span
//     className="d-inline-flex align-items-center gap-1 fw-semibold rounded-pill"
//     style={{
//       backgroundColor: color,
//       color: textColor,
//       fontSize: '0.72rem',
//       padding: '0.3rem 0.65rem',
//       lineHeight: 1,
//     }}
//   >
//     {children}
//   </span>
// );


// // ─────────────────────────────────────────
// // BADGES
// // ─────────────────────────────────────────
// const ContratoBadge = ({ status }) => {
//   const map = {
//     pendente:              { icon: FaClock,       text: 'Pendente',           color: '#6c757d' },
//     aguardando_assinatura: { icon: FaPaperPlane,  text: 'Aguard. Assinatura', color: '#ffc107', textColor: '#000' },
//     assinado:              { icon: FaCheckCircle, text: 'Assinado',           color: '#198754' },
//     dispensado:            { icon: FaTimesCircle, text: 'Dispensado',         color: '#0dcaf0', textColor: '#000' },
//   };

//   const cfg = map[status] || map.pendente;
//   const Icon = cfg.icon;

//   return (
//     <Pill color={cfg.color} textColor={cfg.textColor || '#fff'}>
//       <Icon size={10} />
//       {cfg.text}
//     </Pill>
//   );
// };


// const PedidoBadge = ({ status }) => {
//   const map = {
//     ativo:      { text: 'Ativo',      color: '#198754' },
//     finalizado: { text: 'Finalizado', color: '#000' },
//     cancelado:  { text: 'Cancelado',  color: '#dc3545' },
//   };

//   const cfg = map[status] || map.ativo;

//   return <Pill color={cfg.color}>{cfg.text}</Pill>;
// };


// // ─────────────────────────────────────────
// // PÁGINA PRINCIPAL
// // ─────────────────────────────────────────
// export default function Pedidos() {
//   const { tier, hasBoletoAccess, hasContratoAccess } = usePlanAccess();

//   const [pedidos, setPedidos] = useState([]);
//   const [clientes, setClientes] = useState([]);
//   const [planos, setPlanos] = useState([]);
//   const [equipamentos, setEquipamentos] = useState([]);
//   const [contractTemplates, setContractTemplates] = useState([]);

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');

//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusPedidoFilter, setStatusPedidoFilter] = useState('');
//   const [statusContratoFilter, setStatusContratoFilter] = useState('');

//   const [showModal, setShowModal] = useState(false);
//   const [currentPedido, setCurrentPedido] = useState(null);

//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [pedidoToDelete, setPedidoToDelete] = useState(null);

//   const [hasLytexConfig, setHasLytexConfig] = useState(null);
//   const [hasAutentiqueConfig, setHasAutentiqueConfig] = useState(null);

//   const pollingRef = useRef(null);

//   useEffect(() => {
//     if (!showModal && pollingRef.current) {
//       clearInterval(pollingRef.current);
//       pollingRef.current = null;
//     }
//   }, [showModal]);

//   useEffect(() => {
//     return () => {
//       if (pollingRef.current) {
//         clearInterval(pollingRef.current);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       setLoading(true);

//       await Promise.all([
//         fetchPedidos(),

//         api.get('/customers')
//           .then(r => setClientes(r.data.map(c => ({ ...c, nome: c.name }))))
//           .catch(() => {}),

//         api.get('/media-plans')
//           .then(r => setPlanos(r.data.map(p => ({
//             ...p,
//             valor: p.amount,
//             duracao: p.duration,
//             unidade: p.unit,
//             nome: p.name
//           }))))
//           .catch(() => {}),

//         api.get('/equipments')
//           .then(r => setEquipamentos(r.data.map(e => ({ ...e, nome: e.name }))))
//           .catch(() => {}),

//         api.get('/integrations/lytex/status')
//           .then(r => setHasLytexConfig(!!r.data?.configured))
//           .catch(() => setHasLytexConfig(false)),

//         api.get('/integrations/autentique/status')
//           .then(r => setHasAutentiqueConfig(!!r.data?.configured))
//           .catch(() => setHasAutentiqueConfig(false)),

//         api.get('/contract-templates')
//           .then(r => setContractTemplates(Array.isArray(r.data) ? r.data : []))
//           .catch(() => setContractTemplates([])),
//       ]);

//       setLoading(false);
//     };

//     load();
//   }, []);

//   const fetchPedidos = async () => {
//     try {
//       const res = await api.get('/orders');
//       setPedidos(res.data.map(formatarPedido));
//     } catch {
//       setError('Erro ao carregar pedidos.');
//     }
//   };

//   const startPollingInvoices = (orderId) => {
//     if (pollingRef.current) {
//       clearInterval(pollingRef.current);
//     }

//     let attempts = 0;
//     const MAX_ATTEMPTS = 20;
//     const INTERVAL_MS = 2000;

//     pollingRef.current = setInterval(async () => {
//       attempts++;

//       try {
//         const res = await api.get(`/orders/${orderId}`);
//         const pedidoAtualizado = formatarPedido(res.data);

//         const todasComBoleto = pedidoAtualizado.parcelas.every(p => !!p.invoiceUrl || p.cancelada);
//         const algumaComBoleto = pedidoAtualizado.parcelas.some(p => !!p.invoiceUrl);

//         if (algumaComBoleto) {
//           setCurrentPedido(pedidoAtualizado);
//           await fetchPedidos();
//         }

//         if (todasComBoleto || attempts >= MAX_ATTEMPTS) {
//           clearInterval(pollingRef.current);
//           pollingRef.current = null;

//           toast[todasComBoleto ? 'success' : 'warning'](
//             todasComBoleto
//               ? '✅ Todos os boletos foram gerados!'
//               : '⚠️ Alguns boletos ainda estão sendo processados.'
//           );
//         }
//       } catch {
//         clearInterval(pollingRef.current);
//         pollingRef.current = null;
//       }
//     }, INTERVAL_MS);
//   };

//   const handleSave = async (data) => {
//     if (saving) return;

//     setSaving(true);
//     setError('');

//     try {
//       if (data.id) {
//         await api.put(`/orders/${data.id}`, {
//           customerId: data.clienteId,
//           mediaPlanId: data.planoId,
//           equipments: data.equipamentosSelecionados,

//           adsCount: parseInt(data.quantidadeAnuncios, 10) || 1,

//           startDate: formatYmd(data.dataInicio),
//           endDate: formatYmd(data.dataTermino),
//           discount: Number(data.desconto) || 0,
//           discountPerInstallment: Number(data.descontoParcela) || 0,

//           // 🔑 Valor base manual (null quando não usado → backend recalcula)
//           baseAmount: data.usarValorManual && data.valorBaseManual !== ''
//             ? Number(data.valorBaseManual)
//             : null,

//           status:
//             data.status === 'cancelado' ? 'CANCELADO' :
//             data.status === 'finalizado' ? 'CONCLUIDO' : 'ATIVO',

//           installments: data.parcelas
//             .filter(p => !p.cancelada)
//             .map(p => ({
//               id: p.id,
//               installmentNumber: p.numero,
//               amount: Number(p.valor),
//               dueDate: formatYmd(p.dataVencimento),
//               status: p.pago ? 'PAID' : 'PENDING',
//               paidAt: p.pago && p.dataPagamento ? formatYmd(p.dataPagamento) : null,
//               paidAmount: p.pago ? Number(p.valorPago || p.valor) : null,
//             })),
//         });

//         toast.success('Pedido atualizado!');
//         await fetchPedidos();
//         setShowModal(false);
//       } else {
//         const firstDate = data.parcelas[0]?.dataVencimento ?? data.dataInicio;

//         const deveGerarBoletos =
//           hasBoletoAccess &&
//           data.gerarBoletos === true &&
//           hasLytexConfig === true;

//         const deveGerarContrato =
//           hasContratoAccess &&
//           data.gerarContrato === true;

//         const deveEnviarContrato =
//           deveGerarContrato &&
//           data.enviarContratoAutentique === true &&
//           hasAutentiqueConfig === true;

//         const payload = {
//           customerId: data.clienteId,
//           mediaPlanId: data.planoId,
//           equipments: data.equipamentosSelecionados,

//           adsCount: parseInt(data.quantidadeAnuncios, 10) || 1,

//           startDate: formatYmd(data.dataInicio),
//           endDate: formatYmd(data.dataTermino),

//           discount: Number(data.desconto) || 0,
//           discountPerInstallment: Number(data.descontoParcela) || 0,

//           // 🔑 Valor base manual (null quando não usado)
//           baseAmount: data.usarValorManual && data.valorBaseManual !== ''
//             ? Number(data.valorBaseManual)
//             : null,

//           generateInvoices: deveGerarBoletos,

//           generateContract: deveGerarContrato,
//           sendContractToAutentique: deveEnviarContrato,
//           contractTemplateId: data.contractTemplateId || undefined,

//           financial: {
//             installmentsCount: data.parcelas.length || 1,
//             firstDueDate: formatYmd(firstDate),
//           },
//         };

//         const res = await api.post('/orders', payload);

//         const pedidoCriado = await api.get(`/orders/${res.data.id}`);
//         const pedidoFormatado = formatarPedido(pedidoCriado.data);

//         await fetchPedidos();

//         setCurrentPedido(pedidoFormatado);
//         setShowModal(true);

//         if (deveGerarBoletos) {
//           toast.success('Pedido criado! Gerando boletos...');
//           startPollingInvoices(res.data.id);
//         } else if (data.gerarBoletos && !hasLytexConfig) {
//           toast.warning('Pedido criado sem boletos — credenciais Lytex não configuradas.');
//         } else {
//           toast.success('Pedido criado com sucesso.');
//         }

//         if (deveGerarContrato) {
//           toast.success('Contrato gerado em rascunho.');
//         }

//         if (data.enviarContratoAutentique && !hasAutentiqueConfig) {
//           toast.warning('Contrato não enviado — Autentique não configurada.');
//         }

//         if (deveEnviarContrato) {
//           if (res.data?.contractSentToAutentique) {
//             toast.success('Contrato enviado para Autentique!');
//           } else if (res.data?.autentiqueError) {
//             toast.warning(`Contrato não enviado: ${res.data.autentiqueError}`);
//           } else {
//             toast.info('Envio para Autentique solicitado.');
//           }
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.error || 'Erro ao salvar pedido.');
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleCancelar = async (pedido) => {
//     if (!window.confirm('Cancelar este pedido?')) return;

//     try {
//       await api.patch(`/orders/${pedido.id}/cancel`);
//       toast.success('Pedido cancelado!');
//       fetchPedidos();
//     } catch (err) {
//       setError(err.response?.data?.error || 'Erro ao cancelar pedido.');
//     }
//   };

//   const handleDelete = async () => {
//     if (!pedidoToDelete) return;

//     try {
//       await api.delete(`/orders/${pedidoToDelete.id}`);

//       toast.success('Pedido excluído!');
//       setShowDeleteModal(false);
//       setPedidoToDelete(null);
//       fetchPedidos();
//     } catch {
//       setError('Erro ao excluir pedido.');
//     }
//   };

//   const filteredPedidos = pedidos.filter(p => {
//     const matchSearch =
//       !searchTerm ||
//       p.clienteNome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       p.planos?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       String(p.id).includes(searchTerm);

//     const matchStatus = !statusPedidoFilter || p.status === statusPedidoFilter;
//     const matchContrato = !statusContratoFilter || p.statusContrato === statusContratoFilter;

//     return matchSearch && matchStatus && matchContrato;
//   });

//   return (
//     <Container fluid className="p-4">
//       <PageHeader
//         title="Pedidos"
//         buttonLabel="Novo Pedido"
//         onButtonClick={() => {
//           setCurrentPedido(null);
//           setShowModal(true);
//         }}
//       />

//       {error && (
//         <Alert variant="danger" dismissible onClose={() => setError('')}>
//           {error}
//         </Alert>
//       )}

//       {hasBoletoAccess && hasLytexConfig === false && (
//         <Alert variant="warning" className="d-flex align-items-center">
//           <FaExclamationTriangle className="me-2 flex-shrink-0" size={20} />
//           <div>
//             <strong>Lytex não configurada.</strong> Seu plano permite geração de boletos, mas você ainda não configurou as credenciais.
//             {' '}Os pedidos serão criados <strong>sem boletos</strong> até que você configure a integração em{' '}
//             <a href="/configuracoes/integracoes">Configurações → Integrações</a>.
//           </div>
//         </Alert>
//       )}

//       {hasContratoAccess && hasAutentiqueConfig === false && (
//         <Alert variant="warning" className="d-flex align-items-center">
//           <FaExclamationTriangle className="me-2 flex-shrink-0" size={20} />
//           <div>
//             <strong>Autentique não configurada.</strong> Seu plano permite contratos digitais, mas o token da Autentique ainda não foi configurado.
//             {' '}O contrato poderá ser criado em rascunho, mas não será enviado automaticamente para assinatura até configurar em{' '}
//             <a href="/configuracoes/integracoes">Configurações → Integrações</a>.
//           </div>
//         </Alert>
//       )}

//       {/* ── Filtros ── */}
//       <Card className="mb-4 shadow-sm border-0">
//         <Card.Body>
//           <Row className="mb-3">
//             <Col>
//               <InputGroup>
//                 <InputGroup.Text className="bg-white">
//                   <FaSearch className="text-muted" />
//                 </InputGroup.Text>
//                 <Form.Control
//                   placeholder="Buscar por cliente, plano..."
//                   value={searchTerm}
//                   onChange={e => setSearchTerm(e.target.value)}
//                 />
//               </InputGroup>
//             </Col>
//           </Row>

//           <Row className="g-3">
//             <Col md={4}>
//               <Form.Label className="small text-muted mb-1">Status do Pedido</Form.Label>
//               <Form.Select
//                 size="sm"
//                 value={statusPedidoFilter}
//                 onChange={e => setStatusPedidoFilter(e.target.value)}
//               >
//                 <option value="">Todos</option>
//                 <option value="ativo">Ativo</option>
//                 <option value="finalizado">Finalizado</option>
//                 <option value="cancelado">Cancelado</option>
//               </Form.Select>
//             </Col>

//             <Col md={4}>
//               <Form.Label className="small text-muted mb-1">Status do Contrato</Form.Label>
//               <Form.Select
//                 size="sm"
//                 value={statusContratoFilter}
//                 onChange={e => setStatusContratoFilter(e.target.value)}
//               >
//                 <option value="">Todos</option>
//                 <option value="pendente">Pendente</option>
//                 <option value="aguardando_assinatura">Aguardando Assinatura</option>
//                 <option value="assinado">Assinado</option>
//                 <option value="dispensado">Dispensado</option>
//               </Form.Select>
//             </Col>

//             <Col md={4} className="d-flex align-items-end gap-2">
//               <Button
//                 variant="outline-secondary"
//                 size="sm"
//                 className="w-100"
//                 onClick={() => {
//                   setSearchTerm('');
//                   setStatusPedidoFilter('');
//                   setStatusContratoFilter('');
//                 }}
//               >
//                 <FaTimes className="me-1" />
//                 Limpar Filtros
//               </Button>

//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={fetchPedidos}
//                 title="Atualizar"
//               >
//                 <FaRedo />
//               </Button>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* ── Tabela ── */}
//       {loading ? (
//         <div className="text-center mt-5">
//           <Spinner animation="border" />
//         </div>
//       ) : (
//         <Card className="shadow-sm border-0">
//           <Card.Body>
//             <div className="table-responsive">
//               <Table hover className="align-middle">
//                 <thead className="table-light">
//                   <tr>
//                     <th style={{ minWidth: 160, maxWidth: 260, width: '22%' }}>Cliente</th>
//                     <th style={{ minWidth: 160, maxWidth: 200, width: '20%' }}>Plano</th>
//                     <th className="text-center">Anúncios</th>
//                     <th>Valor Parcela</th>
//                     <th>Total</th>
//                     <th className="text-center" style={{ minWidth: 110 }}>Período</th>
//                     <th className="text-center">Status Pedido</th>
//                     <th className="text-center">Contrato</th>
//                     <th className="text-center">Ações</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {filteredPedidos.length === 0 && (
//                     <tr>
//                       <td colSpan={9} className="text-center py-4 text-muted">
//                         Nenhum pedido encontrado.
//                       </td>
//                     </tr>
//                   )}

//                   {filteredPedidos.map((p, i) => {
//                     // ✅ USA A FONTE ÚNICA — mesma fórmula do formulário
//                     const qtdEquip = Math.max(1, p.equipamentosSelecionados?.length || 1);
//                     const { totalFinal, descTotal, valorParcela } = calcularValores({
//                       quantidadeAnuncios: p.quantidadeAnuncios,
//                       valorPlano: p.valor,
//                       qtdEquipamentos: qtdEquip,
//                       desconto: p.desconto,
//                       descontoParcela: p.descontoParcela,
//                       qtdParcelas: p.parcelas.length || 1,
//                       // 🔑 respeita valor base manual salvo no pedido
//                       valorBaseManual: p.valorBaseManual,
//                     });

//                     return (
//                       <tr key={p.id || i}>
//                         <td>
//                           <strong>{p.clienteNome}</strong>
//                           {p.clienteEmail && (
//                             <>
//                               <br />
//                               <small className="text-muted">{p.clienteEmail}</small>
//                             </>
//                           )}
//                         </td>

//                         <td style={{ maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word' }}>
//                           <span className="d-inline-block" style={{ lineHeight: 1.25 }}>
//                             {p.planos}
//                           </span>
//                         </td>

//                         <td className="text-center">
//                           <strong>{parseInt(p.quantidadeAnuncios || 1, 10)}</strong>
//                         </td>

//                         <td>
//                           <strong>{brl(valorParcela)}</strong>
//                         </td>

//                         <td>
//                           <strong>{brl(totalFinal)}</strong>
//                           {descTotal > 0 && (
//                             <>
//                               <br />
//                               <small className="text-danger">-{brl(descTotal)}</small>
//                             </>
//                           )}
//                         </td>

//                         <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
//                           <small className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Início</small>
//                           <small className="fw-semibold d-block">{formatBr(p.dataInicio)}</small>
//                           <hr className="my-1" />
//                           <small className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Término</small>
//                           <small className="fw-semibold d-block">{formatBr(p.dataTermino)}</small>
//                         </td>

//                         <td className="text-center">
//                           <PedidoBadge status={p.status} />
//                         </td>

//                         <td className="text-center">
//                           <ContratoBadge status={p.statusContrato} />

//                           {p.linkAssinatura && (
//                             <div className="mt-1">
//                               <a
//                                 href={p.linkAssinatura}
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                                 className="small text-primary"
//                               >
//                                 <FaEye className="me-1" />
//                                 Ver Contrato
//                               </a>
//                             </div>
//                           )}
//                         </td>

//                         <td className="text-center">
//                           <div className="d-flex gap-1 justify-content-center">
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               title="Editar"
//                               onClick={async () => {
//                                 try {
//                                   const res = await api.get(`/orders/${p.id}`);
//                                   setCurrentPedido(formatarPedido(res.data));
//                                 } catch {
//                                   setCurrentPedido(p);
//                                 }

//                                 setShowModal(true);
//                               }}
//                             >
//                               <FaEdit />
//                             </Button>

//                             <Button
//                               variant="outline-danger"
//                               size="sm"
//                               title="Excluir"
//                               onClick={() => {
//                                 setPedidoToDelete(p);
//                                 setShowDeleteModal(true);
//                               }}
//                             >
//                               <FaTrash />
//                             </Button>

//                             {p.status === 'ativo' && (
//                               <Button
//                                 variant="warning"
//                                 size="sm"
//                                 title="Cancelar pedido"
//                                 onClick={() => handleCancelar(p)}
//                               >
//                                 <FaBan />
//                               </Button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </Table>
//             </div>
//           </Card.Body>
//         </Card>
//       )}

//       {/* ── Modal Pedido ── */}
//       <Modal
//         show={showModal}
//         onHide={() => {
//           if (!saving) setShowModal(false);
//         }}
//         size="xl"
//         backdrop="static"
//       >
//         <Modal.Header closeButton={!saving}>
//           <div className="d-flex align-items-center justify-content-between w-100 me-3">
//             <Modal.Title className="d-flex align-items-center gap-2 mb-0">
//               {currentPedido?.id ? (
//                 <>
//                   <FaEdit className="text-primary" />
//                   Editar Pedido
//                 </>
//               ) : (
//                 <>
//                   <FaFileContract className="text-success" />
//                   Novo Pedido
//                 </>
//               )}
//             </Modal.Title>

//             {tier && (
//               <span
//                 className={`px-3 py-1 fw-semibold rounded-pill ${
//                   tier === 'PRO'
//                     ? 'bg-warning text-dark'
//                     : tier === 'ENTERPRISE'
//                     ? 'bg-success text-white'
//                     : 'bg-secondary text-white'
//                 }`}
//                 style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}
//               >
//                 Plano {tier}
//               </span>
//             )}
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <PedidoForm
//             pedido={currentPedido}
//             clientes={clientes}
//             planos={planos}
//             equipamentos={equipamentos}
//             contractTemplates={contractTemplates}
//             hasBoletoAccess={hasBoletoAccess}
//             hasContratoAccess={hasContratoAccess}
//             hasLytexConfig={hasLytexConfig}
//             hasAutentiqueConfig={hasAutentiqueConfig}
//             planTier={tier}
//             onSave={handleSave}
//             onCancel={() => setShowModal(false)}
//             error={error}
//             saving={saving}
//             onStartPolling={startPollingInvoices}
//             setCurrentPedido={setCurrentPedido}
//             refreshPedidos={fetchPedidos}
//           />
//         </Modal.Body>
//       </Modal>

//       {/* ── Modal Exclusão ── */}
//       <ConfirmModal
//         show={showDeleteModal}
//         onHide={() => setShowDeleteModal(false)}
//         onConfirm={handleDelete}
//         title="Confirmar Exclusão"
//         message={
//           <>
//             Tem certeza que deseja excluir o pedido de{' '}
//             <strong>{pedidoToDelete?.clienteNome}</strong>?
//           </>
//         }
//         confirmLabel="Excluir"
//         confirmVariant="danger"
//       />
//     </Container>
//   );
// }


// // ─────────────────────────────────────────
// // FORMULÁRIO DE PEDIDO
// // ─────────────────────────────────────────
// function PedidoForm({
//   pedido,
//   clientes,
//   planos,
//   equipamentos,
//   contractTemplates = [],
//   hasBoletoAccess,
//   hasContratoAccess,
//   hasLytexConfig,
//   hasAutentiqueConfig,
//   planTier,
//   onSave,
//   onCancel,
//   error,
//   saving,
//   onStartPolling,
//   setCurrentPedido,
//   refreshPedidos,
// }) {
//   const buildInit = (p) => p?.id ? {
//     id: p.id,
//     clienteId: p.clienteId,
//     planoId: p.planoId,
//     equipamentosSelecionados: p.equipamentosSelecionados || [],
//     quantidadeAnuncios: p.quantidadeAnuncios || 1,
//     valor: p.valor || '',
//     desconto: p.desconto || '0',
//     descontoParcela: p.descontoParcela || '0',
//     dataInicio: p.dataInicio || getToday(),
//     dataTermino: p.dataTermino || '',
//     status: p.status || 'ativo',
//     statusContrato: p.statusContrato || 'pendente',
//     contratoEnviado: p.contratoEnviado || false,
//     linkAssinatura: p.linkAssinatura || null,
//     dataEnvioContrato: p.dataEnvioContrato || null,
//     dataAssinaturaContrato: p.dataAssinaturaContrato || null,
//     autentiqueDocId: p.autentiqueDocId || null,

//     // 🔑 Valor base manual (vindo do banco)
//     usarValorManual: p.valorBaseManual != null && p.valorBaseManual !== '',
//     valorBaseManual: p.valorBaseManual != null ? String(p.valorBaseManual) : '',

//     gerarBoletos: false,
//     gerarContrato: false,
//     enviarContratoAutentique: false,
//     contractTemplateId: '',

//     qtdParcelas: p.parcelas?.length || 1,
//     parcelas: p.parcelas || [],
//   } : {
//     id: null,
//     clienteId: '',
//     planoId: '',
//     equipamentosSelecionados: [],
//     quantidadeAnuncios: 1,
//     valor: '',
//     desconto: '0',
//     descontoParcela: '0',
//     dataInicio: getToday(),
//     dataTermino: '',
//     status: 'ativo',
//     statusContrato: 'pendente',
//     contratoEnviado: false,
//     linkAssinatura: null,
//     dataEnvioContrato: null,
//     dataAssinaturaContrato: null,
//     autentiqueDocId: null,

//     // 🔑 Valor base manual (criação)
//     usarValorManual: false,
//     valorBaseManual: '',

//     gerarBoletos: hasBoletoAccess && hasLytexConfig === true,
//     gerarContrato: hasContratoAccess === true,
//     enviarContratoAutentique: hasContratoAccess === true && hasAutentiqueConfig === true,
//     contractTemplateId: '',

//     qtdParcelas: 1,
//     parcelas: [],
//   };

//   const [formData, setFormData] = useState(() => buildInit(pedido));

//   const [generatingInvoice, setGeneratingInvoice] = useState(null);
//   const [generatingAll, setGeneratingAll] = useState(false);
//   const [generatingReceipt, setGeneratingReceipt] = useState(null);
//   const [cancelingInstallment, setCancelingInstallment] = useState(null);
//   const [cancelingRemaining, setCancelingRemaining] = useState(false);

//   // 🔑 Identificador estável do pedido
//   const pedidoKey = pedido?.id ?? null;

//   // 🔑 "Fingerprint" das parcelas + contrato vindos do PAI.
//   const pedidoFingerprint = pedido
//     ? [
//         (pedido.parcelas || [])
//           .map(p => `${p.id}:${p.invoiceUrl || ''}:${p.cancelada ? 1 : 0}:${p.pago ? 1 : 0}`)
//           .join('|'),
//         pedido.statusContrato || '',
//         pedido.status || '',
//         pedido.linkAssinatura || '',
//       ].join('#')
//     : '';

//   useEffect(() => {
//     setFormData(prev => {
//       if (!prev.id || prev.id !== pedidoKey) {
//         return buildInit(pedido);
//       }

//       if (!pedido) return prev;

//       return {
//         ...prev,
//         parcelas: pedido.parcelas || prev.parcelas,
//         statusContrato: pedido.statusContrato ?? prev.statusContrato,
//         linkAssinatura: pedido.linkAssinatura ?? prev.linkAssinatura,
//         contratoEnviado: pedido.contratoEnviado ?? prev.contratoEnviado,
//         dataEnvioContrato: pedido.dataEnvioContrato ?? prev.dataEnvioContrato,
//         dataAssinaturaContrato: pedido.dataAssinaturaContrato ?? prev.dataAssinaturaContrato,
//         autentiqueDocId: pedido.autentiqueDocId ?? prev.autentiqueDocId,
//         status: pedido.status ?? prev.status,
//       };
//     });
//   }, [pedidoKey, pedidoFingerprint]); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     if (!pedidoKey) {
//       setFormData(prev => ({
//         ...prev,
//         gerarBoletos: hasBoletoAccess && hasLytexConfig === true,
//         gerarContrato: hasContratoAccess === true,
//         enviarContratoAutentique: hasContratoAccess === true && hasAutentiqueConfig === true,
//       }));
//     }
//   }, [
//     hasLytexConfig,
//     hasBoletoAccess,
//     hasContratoAccess,
//     hasAutentiqueConfig,
//     pedidoKey
//   ]);

//   const refreshFormData = async () => {
//     if (!formData.id) return;

//     try {
//       const res = await api.get(`/orders/${formData.id}`);
//       const atualizado = formatarPedido(res.data);

//       setCurrentPedido(atualizado);
//       refreshPedidos?.();
//     } catch {
//       // silencioso
//     }
//   };

//   const aplicarMudanca = (updates) => {
//     setFormData(prev => {
//       const next = { ...prev, ...updates };

//       if (next.id) {
//         return next;
//       }

//       const p = planos.find(x => x.id === next.planoId);

//       if (!p || !next.dataInicio || !isValidYmd(next.dataInicio)) {
//         return { ...next, parcelas: [] };
//       }

//       next.valor = p.valor;
//       const qtdEquip = Math.max(1, next.equipamentosSelecionados.length);

//       const { totalFinal, valorParcela, qtdParc } = calcularValores({
//         quantidadeAnuncios: next.quantidadeAnuncios,
//         valorPlano: p.valor,
//         qtdEquipamentos: qtdEquip,
//         desconto: next.desconto,
//         descontoParcela: next.descontoParcela,
//         qtdParcelas: next.qtdParcelas,
//         // 🔑 só passa o manual se o toggle estiver ligado
//         valorBaseManual: next.usarValorManual ? next.valorBaseManual : undefined,
//       });

//       if (totalFinal <= 0) {
//         return { ...next, parcelas: [] };
//       }

//       const novas = generateParcelas(
//         next.dataInicio, p.duracao, p.unidade, valorParcela, totalFinal, qtdParc
//       );

//       const merged = novas.map((nova, i) => ({
//         ...nova,
//         dataVencimento: prev.parcelas[i]?.dataVencimento || nova.dataVencimento,
//         pago: prev.parcelas[i]?.pago || false,
//         dataPagamento: prev.parcelas[i]?.dataPagamento || '',
//         valorPago: prev.parcelas[i]?.valorPago,
//       }));

//       return { ...next, parcelas: merged };
//     });
//   };

//   const handleGenerateOne = async (installmentId) => {
//     if (hasLytexConfig !== true) {
//       return toast.warning('Configure a integração Lytex antes de gerar boletos.');
//     }

//     setGeneratingInvoice(installmentId);

//     try {
//       await api.post(`/financial/installments/${installmentId}/generate-invoice`);

//       toast.success('Boleto gerado! Atualizando dados...');

//       setTimeout(async () => {
//         await refreshFormData();
//         setGeneratingInvoice(null);
//       }, 2000);
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao gerar boleto.');
//       setGeneratingInvoice(null);
//     }
//   };

//   const handleReissueOne = async (installmentId) => {
//     if (hasLytexConfig !== true) {
//       return toast.warning('Configure a integração Lytex antes de reemitir boletos.');
//     }

//     const parcela = formData.parcelas.find(p => p.id === installmentId);
//     if (!parcela) return;

//     const mensagem =
//       `Reemitir boleto da Parcela ${parcela.numero}?\n\n` +
//       `📅 Novo vencimento: ${parcela.dataVencimento}\n` +
//       `💰 Valor: R$ ${Number(parcela.valor).toFixed(2)}\n\n` +
//       `O boleto anterior será invalidado.`;

//     if (!window.confirm(mensagem)) return;

//     setGeneratingInvoice(installmentId);

//     try {
//       await api.post(
//         `/financial/installments/${installmentId}/generate-invoice?force=true`,
//         {
//           newDueDate: parcela.dataVencimento,
//           newAmount: Number(parcela.valor)
//         }
//       );

//       toast.success('Boleto reemitido com os novos dados!');

//       setTimeout(async () => {
//         await refreshFormData();
//         setGeneratingInvoice(null);
//       }, 2000);
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao reemitir boleto.');
//       setGeneratingInvoice(null);
//     }
//   };

//   const handleGenerateAll = async () => {
//     if (hasLytexConfig !== true) {
//       return toast.warning('Configure a integração Lytex antes de gerar boletos.');
//     }

//     if (!window.confirm('Gerar boletos para todas as parcelas pendentes deste pedido?')) return;

//     setGeneratingAll(true);

//     try {
//       const res = await api.post(`/orders/${formData.id}/generate-invoices`);
//       const { total, generated, failed } = res.data;

//       if (generated > 0) {
//         toast.success(`${generated} de ${total} boletos gerados!`);
//         onStartPolling?.(formData.id);
//       }

//       if (failed > 0) {
//         toast.warning(`${failed} boleto(s) falharam.`);
//         console.warn('[Boletos] Erros:', res.data.errors);
//       }

//       if (total === 0) {
//         toast.info('Nenhuma parcela pendente de boleto.');
//       }

//       await refreshFormData();
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao gerar boletos.');
//     } finally {
//       setGeneratingAll(false);
//     }
//   };

//   const handleGenerateReceipt = async (installmentId) => {
//     setGeneratingReceipt(installmentId);

//     try {
//       const response = await api.get(
//         `/receipts/installment/${installmentId}`,
//         { responseType: 'blob' }
//       );

//       const blob = new Blob([response.data], { type: 'application/pdf' });
//       const url = window.URL.createObjectURL(blob);

//       window.open(url, '_blank');

//       setTimeout(() => window.URL.revokeObjectURL(url), 10000);

//       toast.success('Recibo gerado!');
//     } catch (err) {
//       let msg = 'Erro ao gerar recibo.';

//       if (err.response?.data instanceof Blob) {
//         try {
//           const text = await err.response.data.text();
//           msg = JSON.parse(text).error || msg;
//         } catch {
//           // ignora
//         }
//       } else {
//         msg = err.response?.data?.error || msg;
//       }

//       toast.error(msg);
//     } finally {
//       setGeneratingReceipt(null);
//     }
//   };

//   const handleCancelInstallment = async (parcela) => {
//     const msg =
//       `Cancelar a Parcela ${parcela.numero}?\n\n` +
//       `💰 Valor: R$ ${Number(parcela.valor).toFixed(2)}\n` +
//       `📅 Vencimento: ${parcela.dataVencimento}\n\n` +
//       (parcela.invoiceUrl ? '⚠️ O boleto na Lytex também será cancelado.\n' : '') +
//       'Esta ação não pode ser desfeita.';

//     if (!window.confirm(msg)) return;

//     setCancelingInstallment(parcela.id);

//     try {
//       const res = await api.patch(`/installments/${parcela.id}/cancel`);

//       if (res.data?.lytexCanceled === false && parcela.invoiceUrl) {
//         toast.warning('Parcela cancelada, mas falha ao cancelar boleto na Lytex.');
//       } else {
//         toast.success('Parcela cancelada!');
//       }

//       await refreshFormData();
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao cancelar parcela.');
//     } finally {
//       setCancelingInstallment(null);
//     }
//   };

//   const handleCancelRemaining = async () => {
//     const pendentes = formData.parcelas.filter(p => !p.pago && !p.cancelada).length;

//     if (pendentes === 0) {
//       return toast.info('Não há parcelas pendentes para cancelar.');
//     }

//     const msg =
//       `Cancelar TODAS as ${pendentes} parcelas pendentes deste pedido?\n\n` +
//       `⚠️ Os boletos correspondentes também serão cancelados na Lytex.\n` +
//       `Esta ação não pode ser desfeita.`;

//     if (!window.confirm(msg)) return;

//     setCancelingRemaining(true);

//     try {
//       const res = await api.patch(`/orders/${formData.id}/cancel-remaining`, {
//         finalizeOrder: false
//       });

//       const { canceled, lytexCanceled, lytexFailed } = res.data;

//       toast.success(
//         `${canceled} parcela(s) cancelada(s). ` +
//         `${lytexCanceled} boleto(s) cancelados na Lytex` +
//         (lytexFailed > 0 ? ` (${lytexFailed} falha(s))` : '') + `.`
//       );

//       await refreshFormData();
//     } catch (err) {
//       toast.error(err.response?.data?.error || 'Erro ao cancelar parcelas.');
//     } finally {
//       setCancelingRemaining(false);
//     }
//   };

//   const parcelasSemBoleto = formData.parcelas.filter(p => !p.invoiceUrl && !p.pago && !p.cancelada).length;
//   const parcelasPendentes = formData.parcelas.filter(p => !p.pago && !p.cancelada).length;

//   // ── Derivados (FONTE ÚNICA — usa planoAtual.valor como verdade) ──
//   const planoAtual = planos.find(x => x.id === formData.planoId);
//   const isDias = ['dias', 'days'].includes(planoAtual?.unidade?.toLowerCase());
//   const qtdEquipamentos = Math.max(1, formData.equipamentosSelecionados.length);

//   const valorPlanoVerdade = planoAtual?.valor ?? formData.valor;

//   const {
//     valorBase: valorTotalBase,
//     totalFinal: valorTotalFinal,
//     valorParcela: valorParcelaFinal,
//   } = calcularValores({
//     quantidadeAnuncios: formData.quantidadeAnuncios,
//     valorPlano: valorPlanoVerdade,
//     qtdEquipamentos,
//     desconto: formData.desconto,
//     descontoParcela: formData.descontoParcela,
//     qtdParcelas: formData.qtdParcelas,
//     // 🔑 só usa o manual se o toggle estiver ligado
//     valorBaseManual: formData.usarValorManual ? formData.valorBaseManual : undefined,
//   });

//   const getValorExibido = (parcela) =>
//     formData.id ? parcela.valor : valorParcelaFinal;

//   const clienteOptions = clientes.map(c => ({
//     value: c.id,
//     label: `${c.nome} (${c.cnpj || 'N/A'})`
//   }));

//   const planoOptions = planos.map(p => ({
//     value: p.id,
//     label: `${p.nome} - R$ ${p.valor}`
//   }));

//   const equipamentoOptions = equipamentos.map(e => ({
//     value: e.id,
//     label: e.nome
//   }));

//   const templateOptions = contractTemplates.map(t => ({
//     value: t.id,
//     label: t.name || t.nome || t.title || t.titulo || `Modelo ${t.id}`
//   }));

//   // ─────────────────────────────────────────
//   // HANDLERS — todos passam por aplicarMudanca
//   // ─────────────────────────────────────────
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     const updates = { [name]: value };

//     if (name === 'dataInicio' && isValidYmd(value)) {
//       const p = planos.find(x => x.id === formData.planoId);
//       if (p) {
//         updates.dataTermino = calculateEndDate(value, p.duracao, p.unidade);
//       }
//     }

//     aplicarMudanca(updates);
//   };

//   const handleQtdParcelasChange = (e) => {
//     const qtd = Math.max(1, parseInt(e.target.value, 10) || 1);
//     aplicarMudanca({ qtdParcelas: qtd });
//   };

//   const handleSelectChange = (name, selected) => {
//     const value = selected?.value || '';

//     const updates = { [name]: value };

//     if (name === 'planoId') {
//       const p = planos.find(x => x.id === value);

//       if (p && formData.dataInicio) {
//         const qtdSugerida = ['dias', 'days'].includes(p.unidade?.toLowerCase())
//           ? 1
//           : parseInt(p.duracao || 1, 10);

//         updates.valor = p.valor;
//         updates.qtdParcelas = qtdSugerida;
//         updates.dataTermino = calculateEndDate(formData.dataInicio, p.duracao, p.unidade);
//       } else if (!value) {
//         updates.valor = '';
//         updates.qtdParcelas = 1;
//         updates.dataTermino = '';
//       }
//     }

//     aplicarMudanca(updates);
//   };

//   const handleEquipamentosChange = (selected) => {
//     const value = selected ? selected.map(x => x.value) : [];
//     aplicarMudanca({ equipamentosSelecionados: value });
//   };

//   const handleParcelaChange = (index, field, value) => {
//     setFormData(prev => {
//       const novas = [...prev.parcelas];

//       if (field === 'pago') {
//         novas[index] = {
//           ...novas[index],
//           pago: value,
//           dataPagamento: value ? getToday() : '',
//           valorPago: value ? (novas[index].valorPago ?? novas[index].valor) : '',
//         };
//       } else {
//         novas[index] = { ...novas[index], [field]: value };
//       }

//       return { ...prev, parcelas: novas };
//     });
//   };

//   const handleGerarContratoChange = (checked) => {
//     setFormData(prev => ({
//       ...prev,
//       gerarContrato: checked,
//       enviarContratoAutentique: checked && hasAutentiqueConfig === true,
//     }));
//   };

//   // 🔑 Toggle do valor base manual
//   const handleUsarValorManualChange = (checked) => {
//     aplicarMudanca({
//       usarValorManual: checked,
//       // se ligar e estiver vazio, sugere o valor calculado atual como ponto de partida
//       valorBaseManual: checked
//         ? (formData.valorBaseManual !== '' ? formData.valorBaseManual : String(valorTotalBase || ''))
//         : '',
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (saving) return;

//     if (
//       !formData.clienteId ||
//       !formData.planoId ||
//       formData.equipamentosSelecionados.length === 0
//     ) {
//       return toast.warning('Preencha Cliente, Plano e ao menos um Equipamento.');
//     }

//     // 🔑 Validação do valor manual
//     if (formData.usarValorManual) {
//       const v = parseFloat(formData.valorBaseManual);
//       if (formData.valorBaseManual === '' || isNaN(v) || v <= 0) {
//         return toast.warning('Informe um Valor Base manual válido (maior que zero).');
//       }
//     }

//     if (!formData.id) {
//       const parcelasSincronizadas = formData.parcelas.map((parcela) => ({
//         ...parcela,
//         valor: valorParcelaFinal,
//       }));

//       if (parcelasSincronizadas.length > 0) {
//         const n = parcelasSincronizadas.length;
//         const somaParcial = Number((valorParcelaFinal * (n - 1)).toFixed(2));
//         parcelasSincronizadas[n - 1] = {
//           ...parcelasSincronizadas[n - 1],
//           valor: Number((valorTotalFinal - somaParcial).toFixed(2)),
//         };
//       }

//       return onSave({ ...formData, parcelas: parcelasSincronizadas });
//     }

//     onSave(formData);
//   };

//   const boletosPendentes = formData.id && hasBoletoAccess && formData.gerarBoletos
//     ? formData.parcelas.filter(p => !p.invoiceUrl && !p.cancelada).length
//     : 0;

//   const pedidoSemBoletos = formData.id && hasBoletoAccess
//     && formData.parcelas.length > 0
//     && formData.parcelas.every(p => !p.invoiceUrl)
//     && !formData.gerarBoletos;

//   const camposEntrada = [
//     { label: 'Anúncios', name: 'quantidadeAnuncios', value: formData.quantidadeAnuncios, type: 'number' },
//     { label: 'Desc. Global (R$)', name: 'desconto', value: formData.desconto, type: 'number' },
//     { label: 'Desc/Parcela (R$)', name: 'descontoParcela', value: formData.descontoParcela, type: 'number' },
//   ];


//   return (
//     <div>
//       {error && (
//         <Alert variant="danger" className="mb-3">
//           {error}
//         </Alert>
//       )}

//       {boletosPendentes > 0 && (
//         <Alert variant="info" className="d-flex align-items-center gap-2 mb-3">
//           <Spinner animation="border" size="sm" />
//           <span>
//             Gerando boletos em background...{' '}
//             <strong>{boletosPendentes} parcela{boletosPendentes > 1 ? 's' : ''}</strong> aguardando.
//           </span>
//         </Alert>
//       )}

//       {pedidoSemBoletos && (
//         <Alert variant="secondary" className="d-flex align-items-center gap-2 mb-3">
//           <FaFileInvoiceDollar size={18} className="flex-shrink-0" />
//           <span>
//             Este pedido foi criado <strong>sem geração de boletos</strong>.
//             Controle os pagamentos manualmente nas parcelas abaixo.
//           </span>
//         </Alert>
//       )}

//       <Form onSubmit={handleSubmit}>
//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 1: DADOS DO PEDIDO                  */}
//         {/* ═══════════════════════════════════════ */}
//         <Card className="mb-3 border-0 shadow-sm">
//           <Card.Header className="bg-white fw-semibold border-bottom">
//             <FaFileContract className="me-2 text-primary" />
//             Dados do Pedido
//           </Card.Header>
//           <Card.Body>
//             <Row>
//               <Col md={12}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Cliente *</Form.Label>
//                   <Select
//                     {...selectFix}
//                     options={clienteOptions}
//                     value={clienteOptions.find(o => o.value === formData.clienteId) || null}
//                     onChange={s => handleSelectChange('clienteId', s)}
//                     placeholder="Buscar cliente..."
//                     isClearable
//                     isDisabled={saving}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Equipamentos *</Form.Label>
//                   <Select
//                     {...selectFix}
//                     isMulti
//                     options={equipamentoOptions}
//                     value={equipamentoOptions.filter(o => formData.equipamentosSelecionados.includes(o.value))}
//                     onChange={handleEquipamentosChange}
//                     placeholder="Selecione painéis..."
//                     noOptionsMessage={() => 'Nenhum encontrado'}
//                     isDisabled={saving}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Plano *</Form.Label>
//                   <Select
//                     {...selectFix}
//                     options={planoOptions}
//                     value={planoOptions.find(o => o.value === formData.planoId) || null}
//                     onChange={s => handleSelectChange('planoId', s)}
//                     placeholder="Selecione um plano..."
//                     isClearable
//                     isDisabled={saving}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 2: VALORES                          */}
//         {/* ═══════════════════════════════════════ */}
//         <Card className="mb-3 border-0 shadow-sm">
//           <Card.Header className="bg-white fw-semibold border-bottom">
//             <FaFileInvoiceDollar className="me-2 text-success" />
//             Valores e Descontos
//           </Card.Header>
//           <Card.Body>
//             <Row className="g-3 align-items-end">
//               {camposEntrada.map(({ label, name, value, type }) => (
//                 <Col md={3} key={name}>
//                   <Form.Group>
//                     <Form.Label className="small">{label}</Form.Label>
//                     <Form.Control
//                       type={type}
//                       name={name}
//                       value={value}
//                       onChange={handleChange}
//                       readOnly={saving}
//                       min="0"
//                       step={['desconto', 'descontoParcela'].includes(name) ? '0.01' : undefined}
//                     />
//                   </Form.Group>
//                 </Col>
//               ))}
//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">
//                     Nº de Parcelas
//                     {planoAtual && (
//                       <span className="text-muted ms-2">
//                         (Plano: {planoAtual.duracao} {planoAtual.unidade})
//                       </span>
//                     )}
//                   </Form.Label>

//                   <Form.Control
//                     type="number"
//                     name="qtdParcelas"
//                     value={formData.qtdParcelas}
//                     min="1"
//                     max="120"
//                     disabled={saving || isDias}
//                     onChange={handleQtdParcelasChange}
//                   />

//                   {isDias && (
//                     <Form.Text className="text-muted">
//                       Planos em dias sempre geram 1 parcela.
//                     </Form.Text>
//                   )}
//                 </Form.Group>
//               </Col>
//             </Row>

//             {/* 🔑 Toggle + campo de Valor Base manual */}
//             <Row className="g-3 mt-1 align-items-end">
//               <Col md={9}>
//                 <Form.Check
//                   type="switch"
//                   id="usar-valor-manual-switch"
//                   checked={formData.usarValorManual}
//                   disabled={saving}
//                   onChange={e => handleUsarValorManualChange(e.target.checked)}
//                   label={
//                     <span className="fw-semibold">
//                       <FaFileInvoiceDollar className="me-2 text-success" />
//                       Definir Valor Base manualmente
//                     </span>
//                   }
//                 />
//                 <small className="text-muted d-block ms-4 mt-1">
//                   Ative para sobrescrever o valor calculado automaticamente
//                   (anúncios × valor do plano × equipamentos).
//                 </small>
//               </Col>

//               {formData.usarValorManual && (
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold text-success">
//                       Valor Base (R$)
//                     </Form.Label>
//                     <Form.Control
//                       type="number"
//                       name="valorBaseManual"
//                       value={formData.valorBaseManual}
//                       min="0"
//                       step="0.01"
//                       disabled={saving}
//                       placeholder="0,00"
//                       onChange={handleChange}
//                     />
//                   </Form.Group>
//                 </Col>
//               )}
//             </Row>

//             <Row className="mt-3 justify-content-center">
//               <Col md={12}>
//                 <div className="d-flex gap-3 flex-wrap">
//                   <div className="text-center px-3 py-2 rounded bg-light flex-grow-1">
//                     <small className="text-muted d-block">
//                       Valor Base{' '}
//                       {formData.usarValorManual && (
//                         <span className="text-success fw-semibold">(manual)</span>
//                       )}
//                     </small>
//                     <strong>{brl(valorTotalBase)}</strong>
//                   </div>
//                   <div className="text-center px-3 py-2 rounded flex-grow-1" style={{ backgroundColor: '#e8f5e9' }}>
//                     <small className="text-muted d-block">Total Final</small>
//                     <strong style={{ color: '#28a745' }}>{brl(valorTotalFinal)}</strong>
//                   </div>
//                   <div className="text-center px-3 py-2 rounded flex-grow-1" style={{ backgroundColor: '#e7f1ff' }}>
//                     <small className="text-muted d-block">Valor/Parcela</small>
//                     <strong style={{ color: '#0d6efd' }}>{brl(valorParcelaFinal)}</strong>
//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 3: DATAS E STATUS                   */}
//         {/* ═══════════════════════════════════════ */}
//         <Card className="mb-3 border-0 shadow-sm">
//           <Card.Header className="bg-white fw-semibold border-bottom">
//             <FaCalendarAlt className="me-2 text-info" />
//             Período e Status
//           </Card.Header>
//           <Card.Body>
//             <Row className="g-3">
//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">Data de Início *</Form.Label>
//                   <Form.Control
//                     type="date"
//                     name="dataInicio"
//                     value={formData.dataInicio}
//                     min="2020-01-01"
//                     max="2100-12-31"
//                     onChange={handleChange}
//                     required
//                     disabled={saving}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">Data de Término</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={formData.dataTermino}
//                     readOnly
//                     style={{ backgroundColor: '#e9ecef' }}
//                   />
//                 </Form.Group>
//               </Col>

//               {hasContratoAccess && (
//                 <Col md={3}>
//                   <Form.Group>
//                     <Form.Label className="small">Status do Contrato</Form.Label>
//                     <Form.Select
//                       name="statusContrato"
//                       value={formData.statusContrato}
//                       onChange={handleChange}
//                       disabled={saving}
//                     >
//                       <option value="pendente">Pendente</option>
//                       <option value="aguardando_assinatura">Aguardando Assinatura</option>
//                       <option value="assinado">Assinado</option>
//                       <option value="dispensado">Dispensado</option>
//                     </Form.Select>
//                   </Form.Group>
//                 </Col>
//               )}

//               <Col md={3}>
//                 <Form.Group>
//                   <Form.Label className="small">Status do Pedido</Form.Label>
//                   <div className="d-flex gap-2 flex-wrap">
//                     {[
//                       { s: 'ativo', label: 'Ativo', color: '#198754' },
//                       { s: 'finalizado', label: 'Finalizado', color: '#6c757d' },
//                       { s: 'cancelado', label: 'Cancelado', color: '#dc3545' },
//                     ].map(({ s, label, color }) => (
//                       <Button
//                         key={s}
//                         size="sm"
//                         type="button"
//                         variant={formData.status === s ? undefined : 'outline-secondary'}
//                         style={formData.status === s ? {
//                           backgroundColor: color,
//                           borderColor: color,
//                           color: '#fff'
//                         } : {}}
//                         disabled={saving}
//                         onClick={() => setFormData(prev => ({ ...prev, status: s }))}
//                       >
//                         {label}
//                       </Button>
//                     ))}
//                   </div>
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Card.Body>
//         </Card>

//         {/* ═══════════════════════════════════════ */}
//         {/* SEÇÃO 4: AUTOMAÇÕES (boletos + contrato)  */}
//         {/* ═══════════════════════════════════════ */}
//         {!formData.id && (hasBoletoAccess || hasContratoAccess) && (
//           <Card className="mb-3 border-0 shadow-sm">
//             <Card.Header className="bg-white fw-semibold border-bottom">
//               <FaBolt className="me-2 text-warning" />
//               Automações do Pedido
//             </Card.Header>
//             <Card.Body>
//               <Row className="g-4">
//                 {/* ── Coluna Boletos ── */}
//                 {hasBoletoAccess && (
//                   <Col md={hasContratoAccess ? 6 : 12}>
//                     <Form.Check
//                       type="switch"
//                       id="gerar-boletos-switch"
//                       checked={formData.gerarBoletos && hasLytexConfig === true}
//                       disabled={saving || hasLytexConfig !== true}
//                       onChange={e => setFormData(prev => ({ ...prev, gerarBoletos: e.target.checked }))}
//                       label={
//                         <span className="fw-semibold">
//                           <FaFileInvoiceDollar className="me-2 text-primary" />
//                           Gerar boletos (Lytex)
//                         </span>
//                       }
//                     />

//                     <div className="ms-4 mt-1">
//                       {hasLytexConfig === null && (
//                         <small className="text-muted">
//                           <Spinner animation="border" size="sm" className="me-1" />
//                           Verificando integração Lytex...
//                         </small>
//                       )}

//                       {hasLytexConfig === true && (
//                         <small className="text-muted">
//                           Desmarque se o cliente pagará em dinheiro/PIX, ou se você está
//                           migrando dados de um sistema antigo.
//                         </small>
//                       )}

//                       {hasLytexConfig === false && (
//                         <small className="text-warning">
//                           <FaExclamationTriangle className="me-1" />
//                           <strong>Credenciais Lytex não configuradas.</strong>{' '}
//                           <a href="/configuracoes/integracoes">Configurar agora</a>
//                         </small>
//                       )}
//                     </div>
//                   </Col>
//                 )}

//                 {/* ── Coluna Contrato ── */}
//                 {hasContratoAccess && (
//                   <Col md={hasBoletoAccess ? 6 : 12} className={hasBoletoAccess ? 'border-start' : ''}>
//                     <Form.Check
//                       type="switch"
//                       id="gerar-contrato-switch"
//                       checked={formData.gerarContrato}
//                       disabled={saving}
//                       onChange={e => handleGerarContratoChange(e.target.checked)}
//                       label={
//                         <span className="fw-semibold">
//                           <FaFileContract className="me-2 text-info" />
//                           Gerar contrato automaticamente
//                         </span>
//                       }
//                     />

//                     <small className="text-muted d-block ms-4 mt-1">
//                       Ao criar o pedido, o sistema gera o contrato com os dados do cliente, plano e período.
//                     </small>

//                     {formData.gerarContrato && (
//                       <div className="ms-4 mt-3 ps-3 border-start border-2 border-info-subtle">
//                         {templateOptions.length > 0 && (
//                           <Form.Group className="mb-3">
//                             <Form.Label className="small fw-semibold">Modelo de Contrato</Form.Label>
//                             <Select
//                               {...selectFix}
//                               options={templateOptions}
//                               value={
//                                 templateOptions.find(o => o.value === formData.contractTemplateId) || null
//                               }
//                               onChange={s => setFormData(prev => ({
//                                 ...prev,
//                                 contractTemplateId: s?.value || ''
//                               }))}
//                               placeholder="Selecione um modelo..."
//                               isDisabled={saving}
//                               isClearable
//                             />
//                           </Form.Group>
//                         )}

//                         <Form.Check
//                           type="switch"
//                           id="enviar-autentique-switch"
//                           checked={formData.enviarContratoAutentique && hasAutentiqueConfig === true}
//                           disabled={saving || hasAutentiqueConfig !== true}
//                           onChange={e => setFormData(prev => ({
//                             ...prev,
//                             enviarContratoAutentique: e.target.checked
//                           }))}
//                           label={
//                             <span className="fw-semibold small">
//                               <FaPaperPlane className="me-1 text-info" />
//                               Enviar para Autentique após criar
//                             </span>
//                           }
//                         />

//                         <div className="ms-4 mt-1">
//                           {hasAutentiqueConfig === null && (
//                             <small className="text-muted">
//                               <Spinner animation="border" size="sm" className="me-1" />
//                               Verificando integração Autentique...
//                             </small>
//                           )}

//                           {hasAutentiqueConfig === true && (
//                             <small className="text-muted">
//                               O contrato será enviado automaticamente para assinatura digital.
//                             </small>
//                           )}

//                           {hasAutentiqueConfig === false && (
//                             <small className="text-warning">
//                               <FaExclamationTriangle className="me-1" />
//                               <strong>Token da Autentique não configurado.</strong>{' '}
//                               <a href="/configuracoes/integracoes">Configurar agora</a>
//                             </small>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </Col>
//                 )}
//               </Row>
//             </Card.Body>
//           </Card>
//         )}

//         {/* ── Info contrato (modo edição) ── */}
//         {(formData.contratoEnviado || formData.linkAssinatura) && (
//           <Card className="mb-3 border-info shadow-sm">
//             <Card.Header className="bg-info text-white">
//               <FaFileContract className="me-2" />
//               Informações do Contrato
//             </Card.Header>

//             <Card.Body>
//               <Row className="g-3">
//                 {formData.dataEnvioContrato && (
//                   <Col md={3}>
//                     <strong>Envio:</strong>
//                     <br />
//                     {formatBr(formData.dataEnvioContrato)}
//                   </Col>
//                 )}

//                 {formData.dataAssinaturaContrato && (
//                   <Col md={3}>
//                     <strong>Assinatura:</strong>
//                     <br />
//                     {formatBr(formData.dataAssinaturaContrato)}
//                   </Col>
//                 )}

//                 {formData.autentiqueDocId && (
//                   <Col md={3}>
//                     <strong>ID Autentique:</strong>
//                     <br />
//                     <small>{formData.autentiqueDocId}</small>
//                   </Col>
//                 )}

//                 {formData.linkAssinatura && (
//                   <Col md={3} className="d-flex align-items-center">
//                     <a
//                       href={formData.linkAssinatura}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="btn btn-sm btn-outline-primary"
//                     >
//                       <FaEye className="me-1" />
//                       Ver Contrato
//                     </a>
//                   </Col>
//                 )}
//               </Row>
//             </Card.Body>
//           </Card>
//         )}

//         {/* ── Parcelas ── */}
//         {formData.parcelas.length > 0 ? (
//           <Card className="mb-3 border-0 shadow-sm">
//             <Card.Header className="bg-white d-flex justify-content-between align-items-center flex-wrap gap-2 border-bottom">
//               <h6 className="mb-0 fw-semibold">
//                 <FaCalendarAlt className="me-2 text-info" />
//                 Parcelas ({formData.parcelas.length}x de {brl(valorParcelaFinal)})

//                 {boletosPendentes > 0 && (
//                   <span className="ms-2 text-info" style={{ fontSize: '0.8rem' }}>
//                     <Spinner animation="border" size="sm" className="me-1" />
//                     {boletosPendentes} boleto{boletosPendentes > 1 ? 's' : ''} sendo gerado{boletosPendentes > 1 ? 's' : ''}...
//                   </span>
//                 )}
//               </h6>

//               <div className="d-flex gap-2 flex-wrap">
//                 {hasBoletoAccess && formData.id && parcelasSemBoleto > 0 && (
//                   <Button
//                     size="sm"
//                     variant="warning"
//                     disabled={generatingAll || hasLytexConfig !== true}
//                     onClick={handleGenerateAll}
//                     title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : ''}
//                   >
//                     {generatingAll ? (
//                       <>
//                         <Spinner animation="border" size="sm" className="me-1" />
//                         Gerando...
//                       </>
//                     ) : (
//                       <>
//                         <FaBolt className="me-1" />
//                         Gerar {parcelasSemBoleto} boleto{parcelasSemBoleto > 1 ? 's' : ''}
//                       </>
//                     )}
//                   </Button>
//                 )}

//                 {formData.id && parcelasPendentes > 0 && (
//                   <Button
//                     size="sm"
//                     variant="outline-danger"
//                     disabled={cancelingRemaining}
//                     onClick={handleCancelRemaining}
//                   >
//                     {cancelingRemaining ? (
//                       <>
//                         <Spinner animation="border" size="sm" className="me-1" />
//                         Cancelando...
//                       </>
//                     ) : (
//                       <>
//                         <FaBan className="me-1" />
//                         Cancelar {parcelasPendentes} restante{parcelasPendentes > 1 ? 's' : ''}
//                       </>
//                     )}
//                   </Button>
//                 )}
//               </div>
//             </Card.Header>

//             <Card.Body>
//               <Row>
//                 {formData.parcelas.map((parcela, index) => (
//                   <Col md={3} key={index} className="mb-3">
//                     <Card
//                       className={`h-100 ${
//                         parcela.cancelada
//                           ? 'border-danger'
//                           : parcela.pago
//                             ? 'border-success'
//                             : 'border-warning'
//                       }`}
//                       style={parcela.cancelada ? { opacity: 0.75 } : {}}
//                     >
//                       <Card.Header
//                         className={`py-2 d-flex align-items-center justify-content-between ${
//                           parcela.cancelada
//                             ? 'bg-danger text-white'
//                             : parcela.pago
//                               ? 'bg-success text-white'
//                               : 'bg-warning text-dark'
//                         }`}
//                       >
//                         <small>
//                           Parcela {parcela.numero}
//                           {parcela.cancelada && ' (Cancelada)'}
//                         </small>

//                         {!parcela.cancelada && (
//                           <Form.Switch
//                             id={`switch-${index}`}
//                             label="Pago"
//                             checked={parcela.pago}
//                             onChange={e => handleParcelaChange(index, 'pago', e.target.checked)}
//                             className="ms-2"
//                           />
//                         )}
//                       </Card.Header>

//                       <Card.Body className="py-2">
//                         <div className="mb-2">
//                           <strong>{brl(getValorExibido(parcela))}</strong>
//                         </div>

//                         {parcela.cancelada ? (
//                           <Alert variant="danger" className="py-2 mb-0 small text-center">
//                             <FaBan className="me-1" />
//                             Parcela cancelada
//                             <div className="mt-1">
//                               <small>Venc.: {formatBr(parcela.dataVencimento)}</small>
//                             </div>
//                           </Alert>
//                         ) : (
//                           <>
//                             <Form.Label className="small">Vencimento:</Form.Label>

//                             <Form.Control
//                               type="date"
//                               size="sm"
//                               value={parcela.dataVencimento || ''}
//                               min="2020-01-01"
//                               max="2100-12-31"
//                               onChange={e => handleParcelaChange(index, 'dataVencimento', e.target.value)}
//                               className="mb-2"
//                             />

//                             {hasBoletoAccess && formData.id && (() => {
//                               if (parcela.invoiceUrl) {
//                                 return (
//                                   <div className="my-2 d-flex gap-1">
//                                     <Button
//                                       size="sm"
//                                       className="flex-grow-1"
//                                       variant={parcela.pago ? 'secondary' : 'primary'}
//                                       style={parcela.pago ? { opacity: 0.6 } : {}}
//                                       onClick={() => window.open(parcela.invoiceUrl, '_blank')}
//                                     >
//                                       <FaCheckCircle className="me-1" />
//                                       {parcela.pago ? 'Boleto Pago' : 'Baixar Boleto'}
//                                     </Button>

//                                     {!parcela.pago && (
//                                       <Button
//                                         size="sm"
//                                         variant="outline-warning"
//                                         disabled={hasLytexConfig !== true || generatingInvoice === parcela.id}
//                                         onClick={() => handleReissueOne(parcela.id)}
//                                         title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : 'Reemitir boleto'}
//                                         style={{ flexShrink: 0 }}
//                                       >
//                                         {generatingInvoice === parcela.id
//                                           ? <Spinner animation="border" size="sm" />
//                                           : <FaRedo />
//                                         }
//                                       </Button>
//                                     )}
//                                   </div>
//                                 );
//                               }

//                               if (generatingInvoice === parcela.id || generatingAll) {
//                                 return (
//                                   <Button size="sm" className="my-2 w-100" variant="secondary" disabled>
//                                     <Spinner animation="border" size="sm" className="me-1" />
//                                     Gerando...
//                                   </Button>
//                                 );
//                               }

//                               if (formData.gerarBoletos) {
//                                 return (
//                                   <Button size="sm" className="my-2 w-100" variant="secondary" disabled>
//                                     <Spinner animation="border" size="sm" className="me-1" />
//                                     Aguardando...
//                                   </Button>
//                                 );
//                               }

//                               if (parcela.pago) {
//                                 return (
//                                   <Button size="sm" className="my-2 w-100" variant="outline-success" disabled>
//                                     <FaCheckCircle className="me-1" />
//                                     Paga sem boleto
//                                   </Button>
//                                 );
//                               }

//                               return (
//                                 <Button
//                                   size="sm"
//                                   className="my-2 w-100"
//                                   variant="outline-warning"
//                                   disabled={hasLytexConfig !== true}
//                                   onClick={() => handleGenerateOne(parcela.id)}
//                                   title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : 'Gerar boleto na Lytex'}
//                                 >
//                                   <FaBolt className="me-1" />
//                                   Gerar boleto
//                                 </Button>
//                               );
//                             })()}

//                             {parcela.pago && (
//                               <>
//                                 <Form.Label className="small">Data de Pagamento:</Form.Label>

//                                 <Form.Control
//                                   type="date"
//                                   size="sm"
//                                   value={parcela.dataPagamento || ''}
//                                   min="2020-01-01"
//                                   max="2100-12-31"
//                                   onChange={e => handleParcelaChange(index, 'dataPagamento', e.target.value)}
//                                   className="mb-2"
//                                 />

//                                 <Form.Label className="small">Valor Pago:</Form.Label>

//                                 <div className="d-flex align-items-center gap-2">
//                                   <span>R$</span>
//                                   <Form.Control
//                                     type="number"
//                                     size="sm"
//                                     min="0"
//                                     step="0.01"
//                                     value={parcela.valorPago ?? parcela.valor}
//                                     onChange={e => handleParcelaChange(
//                                       index,
//                                       'valorPago',
//                                       e.target.value === '' ? '' : Number(e.target.value)
//                                     )}
//                                     className="mb-2"
//                                   />
//                                 </div>

//                                 {formData.id && parcela.id && (
//                                   <Button
//                                     size="sm"
//                                     className="w-100 mt-1"
//                                     variant="outline-success"
//                                     disabled={generatingReceipt === parcela.id}
//                                     onClick={() => handleGenerateReceipt(parcela.id)}
//                                   >
//                                     {generatingReceipt === parcela.id ? (
//                                       <>
//                                         <Spinner animation="border" size="sm" className="me-1" />
//                                         Gerando...
//                                       </>
//                                     ) : (
//                                       <>
//                                         <FaFileInvoice className="me-1" />
//                                         Gerar Recibo
//                                       </>
//                                     )}
//                                   </Button>
//                                 )}
//                               </>
//                             )}

//                             {formData.id && parcela.id && !parcela.pago && (
//                               <Button
//                                 size="sm"
//                                 className="w-100 mt-2"
//                                 variant="outline-danger"
//                                 disabled={cancelingInstallment === parcela.id}
//                                 onClick={() => handleCancelInstallment(parcela)}
//                               >
//                                 {cancelingInstallment === parcela.id ? (
//                                   <>
//                                     <Spinner animation="border" size="sm" className="me-1" />
//                                     Cancelando...
//                                   </>
//                                 ) : (
//                                   <>
//                                     <FaBan className="me-1" />
//                                     Cancelar parcela
//                                   </>
//                                 )}
//                               </Button>
//                             )}
//                           </>
//                         )}
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 ))}
//               </Row>
//             </Card.Body>
//           </Card>
//         ) : formData.id && (
//           <Alert variant="warning" className="mb-3">
//             <FaClock className="me-2" />
//             Parcelas não carregadas. Verifique o backend.
//           </Alert>
//         )}

//         {/* ── Botões ── */}
//         <div className="d-flex justify-content-end mt-4 gap-2">
//           <Button variant="secondary" type="button" onClick={onCancel} disabled={saving}>
//             <FaTimes className="me-1" />
//             Cancelar
//           </Button>

//           <Button variant="success" type="submit" disabled={saving}>
//             {saving ? (
//               <>
//                 <Spinner animation="border" size="sm" className="me-2" />
//                 {formData.id ? 'Salvando...' : 'Criando pedido...'}
//               </>
//             ) : (
//               <>
//                 <FaSave className="me-2" />
//                 {formData.id ? 'Atualizar' : 'Criar'}
//               </>
//             )}
//           </Button>
//         </div>
//       </Form>
//     </div>
//   );
// }


import React, { useEffect, useState, useRef } from 'react';
import {
  Container, Card, Table, Button, Modal, Form, Row, Col,
  Spinner, Alert, InputGroup
} from 'react-bootstrap';
import {
  FaEdit, FaTrash, FaSave, FaTimes, FaCalendarAlt,
  FaFileContract, FaCheckCircle, FaClock,
  FaTimesCircle, FaEye, FaSearch, FaBan, FaPaperPlane,
  FaFileInvoiceDollar, FaExclamationTriangle, FaBolt,
  FaRedo, FaFileInvoice, FaFilePdf
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import api from '../../services/api';
import Select from 'react-select';

import { PageHeader } from '../../components/shared/PageHeader';
import { ConfirmModal } from '../../components/shared/ConfirmModal';
import { usePlanAccess } from '../../hooks/usePlanAccess';

// ─────────────────────────────────────────
// SELECT FIX (resolve dropdown escondido atrás de cards)
// ─────────────────────────────────────────
const selectFix = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  menuPosition: 'fixed',
  styles: {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
  },
};

// ─────────────────────────────────────────
// UTILS
// ─────────────────────────────────────────
const toDate = (v) => {
  if (!v) return null;

  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split('-').map(Number);
    return new Date(y, m - 1, d, 12, 0, 0);
  }

  const d = new Date(v);
  return isNaN(d) ? null : d;
};

const formatYmd = (v) => {
  const d = toDate(v);
  if (!d) return '';

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Formata data → DD/MM/YYYY (curto, sem quebrar linha)
const formatBr = (v) => {
  const d = toDate(v);
  if (!d) return '-';
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

// 🔑 Formata data+hora → DD/MM/YYYY às HH:MM (útil p/ assinatura)
const formatBrDateTime = (v) => {
  if (!v) return '-';
  const d = new Date(v);
  if (isNaN(d)) return '-';
  const data = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  const hora = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  return `${data} às ${hora}`;
};

const isValidYmd = (v) => {
  if (!v || typeof v !== 'string') return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;

  const year = parseInt(v.split('-')[0], 10);
  return year >= 1900 && year <= 2100;
};

const getToday = () => {
  const d = new Date();

  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const brl = (value) => {
  return Number(value || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });
};

const calculateEndDate = (start, dur, unit) => {
  if (!start || !dur || !unit) return '';

  const [y, mo, d] = start.split('-').map(Number);
  const date = new Date(y, mo - 1, d, 12, 0, 0);
  const n = parseInt(dur, 10);

  switch (String(unit).toLowerCase()) {
    case 'dias':
    case 'days':
      date.setDate(date.getDate() + n);
      break;

    case 'semanas':
    case 'weeks':
      date.setDate(date.getDate() + n * 7);
      break;

    case 'meses':
    case 'months':
      date.setMonth(date.getMonth() + n);
      break;

    case 'anos':
    case 'years':
      date.setFullYear(date.getFullYear() + n);
      break;

    default:
      return '';
  }

  return formatYmd(date);
};

// ─────────────────────────────────────────
// CÁLCULO CENTRAL DE VALORES (FONTE ÚNICA DE VERDADE)
// 🔑 valorBaseManual: se vier válido (> 0), sobrescreve o cálculo automático.
// ─────────────────────────────────────────
const calcularValores = ({
  quantidadeAnuncios,
  valorPlano,
  qtdEquipamentos,
  desconto,
  descontoParcela,
  qtdParcelas,
  valorBaseManual,
}) => {
  const qtdAds = Math.max(1, parseInt(quantidadeAnuncios || 1, 10));
  const valPlano = parseFloat(valorPlano || 0);
  const qtdEquip = Math.max(1, qtdEquipamentos || 1);
  const descG = parseFloat(desconto || 0);
  const descP = parseFloat(descontoParcela || 0);
  const qtdParc = Math.max(1, parseInt(qtdParcelas || 1, 10));

  const valorCalculado = qtdAds * valPlano * qtdEquip;

  const temManual =
    valorBaseManual !== undefined &&
    valorBaseManual !== null &&
    valorBaseManual !== '' &&
    !isNaN(parseFloat(valorBaseManual));

  const valorBase = temManual ? parseFloat(valorBaseManual) : valorCalculado;

  const descTotal = descG + (descP * qtdParc);
  const totalFinal = Math.max(valorBase - descTotal, 0);
  const valorParcela = qtdParc > 0
    ? Math.max((valorBase - descG) / qtdParc - descP, 0)
    : 0;

  return { valorBase, descTotal, totalFinal, valorParcela, qtdParc };
};

// ─────────────────────────────────────────
// GERA PARCELAS
// ─────────────────────────────────────────
const generateParcelas = (start, dur, unit, valorParcela, totalFinal, qtd) => {
  if (!start || !dur || !unit) return [];

  const u = String(unit).toLowerCase();

  if (u === 'dias' || u === 'days') {
    return [{
      numero: 1,
      valor: Number(Number(totalFinal).toFixed(2)),
      dataVencimento: start,
      pago: false,
      dataPagamento: '',
    }];
  }

  const n = Math.max(1, parseInt(qtd || dur, 10) || 1);
  const valParc = Number(Number(valorParcela).toFixed(2));

  const somaParcial = valParc * (n - 1);
  const valorUltima = Number((Number(totalFinal) - somaParcial).toFixed(2));

  const [y, mo, d] = start.split('-').map(Number);
  const base = new Date(y, mo - 1, d, 12, 0, 0);

  return Array.from({ length: n }, (_, i) => {
    const dt = new Date(base);

    if (u === 'semanas' || u === 'weeks') {
      dt.setDate(dt.getDate() + i * 7);
    } else if (u === 'meses' || u === 'months') {
      dt.setMonth(dt.getMonth() + i);
    } else if (u === 'anos' || u === 'years') {
      dt.setFullYear(dt.getFullYear() + i);
    }

    return {
      numero: i + 1,
      valor: i === n - 1 ? valorUltima : valParc,
      dataVencimento: formatYmd(dt),
      pago: false,
      dataPagamento: '',
    };
  });
};

const normalizeContractStatus = (status) => {
  const raw = String(status || '').trim();
  const upper = raw.toUpperCase();
  const lower = raw.toLowerCase();

  if (upper === 'DRAFT') return 'pendente';
  if (upper === 'SENT') return 'aguardando_assinatura';
  if (upper === 'SIGNED') return 'assinado';

  if (
    upper === 'CANCELED' ||
    upper === 'CANCELLED' ||
    upper === 'REJECTED' ||
    upper === 'DISPENSED'
  ) {
    return 'dispensado';
  }

  if (lower === 'pendente') return 'pendente';
  if (lower === 'aguardando_assinatura') return 'aguardando_assinatura';
  if (lower === 'assinado') return 'assinado';
  if (lower === 'dispensado') return 'dispensado';

  return 'pendente';
};

// ─────────────────────────────────────────
// FORMATAR PEDIDO (campos alinhados ao schema Prisma)
// ─────────────────────────────────────────
const formatarPedido = (order) => {
  const contrato = order.contracts?.[0];

  return {
    id: order.id,
    clienteId: order.customerId,
    planoId: order.mediaPlanId,
    equipamentosSelecionados: order.equipments?.map(e => e.equipmentId) ?? [],

    status:
      order.status === 'CANCELADO' ? 'cancelado' :
      order.status === 'CONCLUIDO' ? 'finalizado' : 'ativo',

    // ── Contrato (campos corretos do schema) ──
    statusContrato: normalizeContractStatus(contrato?.status),
    contratoId: contrato?.id || null,
    linkAssinatura: contrato?.signatureLink || null,

    contratoEnviado:
      contrato?.status === 'SENT' ||
      contrato?.status === 'SIGNED' ||
      !!contrato?.sentAt ||
      false,

    contratoAssinado: contrato?.status === 'SIGNED',

    dataEnvioContrato: contrato?.sentAt || null,
    dataAssinaturaContrato: contrato?.signedAt || null,
    autentiqueDocId: contrato?.autentiqueDocId || null,
    signedDocumentUrl: contrato?.signedDocumentUrl || null,

    dataInicio: order.startDate ? order.startDate.split('T')[0] : '',
    dataTermino: order.endDate ? order.endDate.split('T')[0] : '',

    desconto: order.discount || 0,
    descontoParcela: order.discountPerInstallment || 0,

    // Valor base manual vindo do backend (se existir)
    valorBaseManual: order.baseAmount ?? null,

    clienteNome: order.customer?.name || 'Cliente Desconhecido',
    clienteEmail: order.customer?.email || '',
    planos: order.mediaPlan?.name || 'Plano Desconhecido',
    valor: order.mediaPlan?.amount || 0,

    quantidadeAnuncios: order.adsCount ?? 1,

    boletosGerados: order.invoicesGenerated ?? null,

    parcelas: order.installments?.map(inst => ({
      id: inst.id,
      numero: inst.installmentNumber,
      valor: Number(inst.amount),
      dataVencimento: inst.dueDate ? inst.dueDate.split('T')[0] : '',
      pago: inst.status === 'Paid' || inst.status === 'PAID',
      cancelada: inst.status === 'CANCELED' || inst.status === 'Canceled',
      status: inst.status,
      dataPagamento: inst.paidAt ? inst.paidAt.split('T')[0] : '',
      valorPago: inst.paidAmount ? Number(inst.paidAmount) : Number(inst.amount),
      invoiceUrl: inst.paymentLink || '',
    })) ?? [],
  };
};


// ─────────────────────────────────────────
// PILL
// ─────────────────────────────────────────
const Pill = ({ color = '#6c757d', textColor = '#fff', children }) => (
  <span
    className="d-inline-flex align-items-center gap-1 fw-semibold rounded-pill"
    style={{
      backgroundColor: color,
      color: textColor,
      fontSize: '0.72rem',
      padding: '0.3rem 0.65rem',
      lineHeight: 1,
    }}
  >
    {children}
  </span>
);


// ─────────────────────────────────────────
// BADGES
// ─────────────────────────────────────────
const ContratoBadge = ({ status }) => {
  const map = {
    pendente:              { icon: FaClock,       text: 'Pendente',           color: '#6c757d' },
    aguardando_assinatura: { icon: FaPaperPlane,  text: 'Aguard. Assinatura', color: '#ffc107', textColor: '#000' },
    assinado:              { icon: FaCheckCircle, text: 'Assinado',           color: '#198754' },
    dispensado:            { icon: FaTimesCircle, text: 'Dispensado',         color: '#0dcaf0', textColor: '#000' },
  };

  const cfg = map[status] || map.pendente;
  const Icon = cfg.icon;

  return (
    <Pill color={cfg.color} textColor={cfg.textColor || '#fff'}>
      <Icon size={10} />
      {cfg.text}
    </Pill>
  );
};


const PedidoBadge = ({ status }) => {
  const map = {
    ativo:      { text: 'Ativo',      color: '#198754' },
    finalizado: { text: 'Finalizado', color: '#000' },
    cancelado:  { text: 'Cancelado',  color: '#dc3545' },
  };

  const cfg = map[status] || map.ativo;

  return <Pill color={cfg.color}>{cfg.text}</Pill>;
};


// ─────────────────────────────────────────
// PÁGINA PRINCIPAL
// ─────────────────────────────────────────
export default function Pedidos() {
  const { tier, hasBoletoAccess, hasContratoAccess } = usePlanAccess();

  const [pedidos, setPedidos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [equipamentos, setEquipamentos] = useState([]);
  const [contractTemplates, setContractTemplates] = useState([]);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [statusPedidoFilter, setStatusPedidoFilter] = useState('');
  const [statusContratoFilter, setStatusContratoFilter] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [currentPedido, setCurrentPedido] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pedidoToDelete, setPedidoToDelete] = useState(null);

  const [hasLytexConfig, setHasLytexConfig] = useState(null);
  const [hasAutentiqueConfig, setHasAutentiqueConfig] = useState(null);

  const pollingRef = useRef(null);

  useEffect(() => {
    if (!showModal && pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
  }, [showModal]);

  useEffect(() => {
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const load = async () => {
      setLoading(true);

      await Promise.all([
        fetchPedidos(),

        api.get('/customers')
          .then(r => setClientes(r.data.map(c => ({ ...c, nome: c.name }))))
          .catch(() => {}),

        api.get('/media-plans')
          .then(r => setPlanos(r.data.map(p => ({
            ...p,
            valor: p.amount,
            duracao: p.duration,
            unidade: p.unit,
            nome: p.name
          }))))
          .catch(() => {}),

        api.get('/equipments')
          .then(r => setEquipamentos(r.data.map(e => ({ ...e, nome: e.name }))))
          .catch(() => {}),

        api.get('/integrations/lytex/status')
          .then(r => setHasLytexConfig(!!r.data?.configured))
          .catch(() => setHasLytexConfig(false)),

        api.get('/integrations/autentique/status')
          .then(r => setHasAutentiqueConfig(!!r.data?.configured))
          .catch(() => setHasAutentiqueConfig(false)),

        api.get('/contract-templates')
          .then(r => setContractTemplates(Array.isArray(r.data) ? r.data : []))
          .catch(() => setContractTemplates([])),
      ]);

      setLoading(false);
    };

    load();
  }, []);

  const fetchPedidos = async () => {
    try {
      const res = await api.get('/orders');
      setPedidos(res.data.map(formatarPedido));
    } catch {
      setError('Erro ao carregar pedidos.');
    }
  };

  const startPollingInvoices = (orderId) => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
    }

    let attempts = 0;
    const MAX_ATTEMPTS = 20;
    const INTERVAL_MS = 2000;

    pollingRef.current = setInterval(async () => {
      attempts++;

      try {
        const res = await api.get(`/orders/${orderId}`);
        const pedidoAtualizado = formatarPedido(res.data);

        const todasComBoleto = pedidoAtualizado.parcelas.every(p => !!p.invoiceUrl || p.cancelada);
        const algumaComBoleto = pedidoAtualizado.parcelas.some(p => !!p.invoiceUrl);

        if (algumaComBoleto) {
          setCurrentPedido(pedidoAtualizado);
          await fetchPedidos();
        }

        if (todasComBoleto || attempts >= MAX_ATTEMPTS) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;

          toast[todasComBoleto ? 'success' : 'warning'](
            todasComBoleto
              ? '✅ Todos os boletos foram gerados!'
              : '⚠️ Alguns boletos ainda estão sendo processados.'
          );
        }
      } catch {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    }, INTERVAL_MS);
  };

  const handleSave = async (data) => {
    if (saving) return;

    setSaving(true);
    setError('');

    try {
      if (data.id) {
        await api.put(`/orders/${data.id}`, {
          customerId: data.clienteId,
          mediaPlanId: data.planoId,
          equipments: data.equipamentosSelecionados,

          adsCount: parseInt(data.quantidadeAnuncios, 10) || 1,

          startDate: formatYmd(data.dataInicio),
          endDate: formatYmd(data.dataTermino),
          discount: Number(data.desconto) || 0,
          discountPerInstallment: Number(data.descontoParcela) || 0,

          baseAmount: data.usarValorManual && data.valorBaseManual !== ''
            ? Number(data.valorBaseManual)
            : null,

          status:
            data.status === 'cancelado' ? 'CANCELADO' :
            data.status === 'finalizado' ? 'CONCLUIDO' : 'ATIVO',

          installments: data.parcelas
            .filter(p => !p.cancelada)
            .map(p => ({
              id: p.id,
              installmentNumber: p.numero,
              amount: Number(p.valor),
              dueDate: formatYmd(p.dataVencimento),
              status: p.pago ? 'PAID' : 'PENDING',
              paidAt: p.pago && p.dataPagamento ? formatYmd(p.dataPagamento) : null,
              paidAmount: p.pago ? Number(p.valorPago || p.valor) : null,
            })),
        });

        toast.success('Pedido atualizado!');
        await fetchPedidos();
        setShowModal(false);
      } else {
        const firstDate = data.parcelas[0]?.dataVencimento ?? data.dataInicio;

        const deveGerarBoletos =
          hasBoletoAccess &&
          data.gerarBoletos === true &&
          hasLytexConfig === true;

        const deveGerarContrato =
          hasContratoAccess &&
          data.gerarContrato === true;

        const deveEnviarContrato =
          deveGerarContrato &&
          data.enviarContratoAutentique === true &&
          hasAutentiqueConfig === true;

        const payload = {
          customerId: data.clienteId,
          mediaPlanId: data.planoId,
          equipments: data.equipamentosSelecionados,

          adsCount: parseInt(data.quantidadeAnuncios, 10) || 1,

          startDate: formatYmd(data.dataInicio),
          endDate: formatYmd(data.dataTermino),

          discount: Number(data.desconto) || 0,
          discountPerInstallment: Number(data.descontoParcela) || 0,

          baseAmount: data.usarValorManual && data.valorBaseManual !== ''
            ? Number(data.valorBaseManual)
            : null,

          generateInvoices: deveGerarBoletos,

          generateContract: deveGerarContrato,
          sendContractToAutentique: deveEnviarContrato,
          contractTemplateId: data.contractTemplateId || undefined,

          financial: {
            installmentsCount: data.parcelas.length || 1,
            firstDueDate: formatYmd(firstDate),
          },
        };

        const res = await api.post('/orders', payload);

        const pedidoCriado = await api.get(`/orders/${res.data.id}`);
        const pedidoFormatado = formatarPedido(pedidoCriado.data);

        await fetchPedidos();

        setCurrentPedido(pedidoFormatado);
        setShowModal(true);

        if (deveGerarBoletos) {
          toast.success('Pedido criado! Gerando boletos...');
          startPollingInvoices(res.data.id);
        } else if (data.gerarBoletos && !hasLytexConfig) {
          toast.warning('Pedido criado sem boletos — credenciais Lytex não configuradas.');
        } else {
          toast.success('Pedido criado com sucesso.');
        }

        if (deveGerarContrato) {
          toast.success('Contrato gerado em rascunho.');
        }

        if (data.enviarContratoAutentique && !hasAutentiqueConfig) {
          toast.warning('Contrato não enviado — Autentique não configurada.');
        }

        if (deveEnviarContrato) {
          if (res.data?.contractSentToAutentique) {
            toast.success('Contrato enviado para Autentique!');
          } else if (res.data?.autentiqueError) {
            toast.warning(`Contrato não enviado: ${res.data.autentiqueError}`);
          } else {
            toast.info('Envio para Autentique solicitado.');
          }
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao salvar pedido.');
    } finally {
      setSaving(false);
    }
  };

  const handleCancelar = async (pedido) => {
    if (!window.confirm('Cancelar este pedido?')) return;

    try {
      await api.patch(`/orders/${pedido.id}/cancel`);
      toast.success('Pedido cancelado!');
      fetchPedidos();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao cancelar pedido.');
    }
  };

  const handleDelete = async () => {
    if (!pedidoToDelete) return;

    try {
      await api.delete(`/orders/${pedidoToDelete.id}`);

      toast.success('Pedido excluído!');
      setShowDeleteModal(false);
      setPedidoToDelete(null);
      fetchPedidos();
    } catch {
      setError('Erro ao excluir pedido.');
    }
  };

  const filteredPedidos = pedidos.filter(p => {
    const matchSearch =
      !searchTerm ||
      p.clienteNome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.planos?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(p.id).includes(searchTerm);

    const matchStatus = !statusPedidoFilter || p.status === statusPedidoFilter;
    const matchContrato = !statusContratoFilter || p.statusContrato === statusContratoFilter;

    return matchSearch && matchStatus && matchContrato;
  });

  return (
    <Container fluid className="p-4">
      <PageHeader
        title="Pedidos"
        buttonLabel="Novo Pedido"
        onButtonClick={() => {
          setCurrentPedido(null);
          setShowModal(true);
        }}
      />

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {hasBoletoAccess && hasLytexConfig === false && (
        <Alert variant="warning" className="d-flex align-items-center">
          <FaExclamationTriangle className="me-2 flex-shrink-0" size={20} />
          <div>
            <strong>Lytex não configurada.</strong> Seu plano permite geração de boletos, mas você ainda não configurou as credenciais.
            {' '}Os pedidos serão criados <strong>sem boletos</strong> até que você configure a integração em{' '}
            <a href="/configuracoes/integracoes">Configurações → Integrações</a>.
          </div>
        </Alert>
      )}

      {hasContratoAccess && hasAutentiqueConfig === false && (
        <Alert variant="warning" className="d-flex align-items-center">
          <FaExclamationTriangle className="me-2 flex-shrink-0" size={20} />
          <div>
            <strong>Autentique não configurada.</strong> Seu plano permite contratos digitais, mas o token da Autentique ainda não foi configurado.
            {' '}O contrato poderá ser criado em rascunho, mas não será enviado automaticamente para assinatura até configurar em{' '}
            <a href="/configuracoes/integracoes">Configurações → Integrações</a>.
          </div>
        </Alert>
      )}

      {/* ── Filtros ── */}
      <Card className="mb-4 shadow-sm border-0">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <InputGroup>
                <InputGroup.Text className="bg-white">
                  <FaSearch className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar por cliente, plano..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="g-3">
            <Col md={4}>
              <Form.Label className="small text-muted mb-1">Status do Pedido</Form.Label>
              <Form.Select
                size="sm"
                value={statusPedidoFilter}
                onChange={e => setStatusPedidoFilter(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="ativo">Ativo</option>
                <option value="finalizado">Finalizado</option>
                <option value="cancelado">Cancelado</option>
              </Form.Select>
            </Col>

            <Col md={4}>
              <Form.Label className="small text-muted mb-1">Status do Contrato</Form.Label>
              <Form.Select
                size="sm"
                value={statusContratoFilter}
                onChange={e => setStatusContratoFilter(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="pendente">Pendente</option>
                <option value="aguardando_assinatura">Aguardando Assinatura</option>
                <option value="assinado">Assinado</option>
                <option value="dispensado">Dispensado</option>
              </Form.Select>
            </Col>

            <Col md={4} className="d-flex align-items-end gap-2">
              <Button
                variant="outline-secondary"
                size="sm"
                className="w-100"
                onClick={() => {
                  setSearchTerm('');
                  setStatusPedidoFilter('');
                  setStatusContratoFilter('');
                }}
              >
                <FaTimes className="me-1" />
                Limpar Filtros
              </Button>

              <Button
                variant="outline-primary"
                size="sm"
                onClick={fetchPedidos}
                title="Atualizar"
              >
                <FaRedo />
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* ── Tabela ── */}
      {loading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <Card className="shadow-sm border-0">
          <Card.Body>
            <div className="table-responsive">
              <Table hover className="align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ minWidth: 160, maxWidth: 260, width: '22%' }}>Cliente</th>
                    <th style={{ minWidth: 160, maxWidth: 200, width: '20%' }}>Plano</th>
                    <th className="text-center">Anúncios</th>
                    <th>Valor Parcela</th>
                    <th>Total</th>
                    <th className="text-center" style={{ minWidth: 110 }}>Período</th>
                    <th className="text-center">Status Pedido</th>
                    <th className="text-center">Contrato</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredPedidos.length === 0 && (
                    <tr>
                      <td colSpan={9} className="text-center py-4 text-muted">
                        Nenhum pedido encontrado.
                      </td>
                    </tr>
                  )}

                  {filteredPedidos.map((p, i) => {
                    const qtdEquip = Math.max(1, p.equipamentosSelecionados?.length || 1);
                    const { totalFinal, descTotal, valorParcela } = calcularValores({
                      quantidadeAnuncios: p.quantidadeAnuncios,
                      valorPlano: p.valor,
                      qtdEquipamentos: qtdEquip,
                      desconto: p.desconto,
                      descontoParcela: p.descontoParcela,
                      qtdParcelas: p.parcelas.length || 1,
                      valorBaseManual: p.valorBaseManual,
                    });

                    return (
                      <tr key={p.id || i}>
                        <td>
                          <strong>{p.clienteNome}</strong>
                          {p.clienteEmail && (
                            <>
                              <br />
                              <small className="text-muted">{p.clienteEmail}</small>
                            </>
                          )}
                        </td>

                        <td style={{ maxWidth: 200, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                          <span className="d-inline-block" style={{ lineHeight: 1.25 }}>
                            {p.planos}
                          </span>
                        </td>

                        <td className="text-center">
                          <strong>{parseInt(p.quantidadeAnuncios || 1, 10)}</strong>
                        </td>

                        <td>
                          <strong>{brl(valorParcela)}</strong>
                        </td>

                        <td>
                          <strong>{brl(totalFinal)}</strong>
                          {descTotal > 0 && (
                            <>
                              <br />
                              <small className="text-danger">-{brl(descTotal)}</small>
                            </>
                          )}
                        </td>

                        <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                          <small className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Início</small>
                          <small className="fw-semibold d-block">{formatBr(p.dataInicio)}</small>
                          <hr className="my-1" />
                          <small className="d-block text-muted" style={{ fontSize: '0.7rem' }}>Término</small>
                          <small className="fw-semibold d-block">{formatBr(p.dataTermino)}</small>
                        </td>

                        <td className="text-center">
                          <PedidoBadge status={p.status} />
                        </td>

                        <td className="text-center">
                          <ContratoBadge status={p.statusContrato} />

                          {/* Link de assinatura (enquanto aguarda) */}
                          {p.linkAssinatura && p.statusContrato !== 'assinado' && (
                            <div className="mt-1">
                              <a
                                href={p.linkAssinatura}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="small text-primary"
                              >
                                <FaEye className="me-1" />
                                Ver Contrato
                              </a>
                            </div>
                          )}

                          {/* PDF assinado (quando já assinou) */}
                          {p.statusContrato === 'assinado' && (p.signedDocumentUrl || p.contratoId) && (
                            <div className="mt-1">
                              {/* <a
                                href={p.signedDocumentUrl || `${api.defaults.baseURL}/contracts/${p.contratoId}/signed-pdf`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="small text-success"
                              >
                                <FaFilePdf className="me-1" />
                                PDF Assinado
                              </a> */}
                            </div>
                          )}
                        </td>

                        <td className="text-center">
                          <div className="d-flex gap-1 justify-content-center">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              title="Editar"
                              onClick={async () => {
                                try {
                                  const res = await api.get(`/orders/${p.id}`);
                                  setCurrentPedido(formatarPedido(res.data));
                                } catch {
                                  setCurrentPedido(p);
                                }

                                setShowModal(true);
                              }}
                            >
                              <FaEdit />
                            </Button>

                            <Button
                              variant="outline-danger"
                              size="sm"
                              title="Excluir"
                              onClick={() => {
                                setPedidoToDelete(p);
                                setShowDeleteModal(true);
                              }}
                            >
                              <FaTrash />
                            </Button>

                            {p.status === 'ativo' && (
                              <Button
                                variant="warning"
                                size="sm"
                                title="Cancelar pedido"
                                onClick={() => handleCancelar(p)}
                              >
                                <FaBan />
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* ── Modal Pedido ── */}
      <Modal
        show={showModal}
        onHide={() => {
          if (!saving) setShowModal(false);
        }}
        size="xl"
        backdrop="static"
      >
        <Modal.Header closeButton={!saving}>
          <div className="d-flex align-items-center justify-content-between w-100 me-3">
            <Modal.Title className="d-flex align-items-center gap-2 mb-0">
              {currentPedido?.id ? (
                <>
                  <FaEdit className="text-primary" />
                  Editar Pedido
                </>
              ) : (
                <>
                  <FaFileContract className="text-success" />
                  Novo Pedido
                </>
              )}
            </Modal.Title>

            {tier && (
              <span
                className={`px-3 py-1 fw-semibold rounded-pill ${
                  tier === 'PRO'
                    ? 'bg-warning text-dark'
                    : tier === 'ENTERPRISE'
                    ? 'bg-success text-white'
                    : 'bg-secondary text-white'
                }`}
                style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}
              >
                Plano {tier}
              </span>
            )}
          </div>
        </Modal.Header>

        <Modal.Body>
          <PedidoForm
            pedido={currentPedido}
            clientes={clientes}
            planos={planos}
            equipamentos={equipamentos}
            contractTemplates={contractTemplates}
            hasBoletoAccess={hasBoletoAccess}
            hasContratoAccess={hasContratoAccess}
            hasLytexConfig={hasLytexConfig}
            hasAutentiqueConfig={hasAutentiqueConfig}
            planTier={tier}
            onSave={handleSave}
            onCancel={() => setShowModal(false)}
            error={error}
            saving={saving}
            onStartPolling={startPollingInvoices}
            setCurrentPedido={setCurrentPedido}
            refreshPedidos={fetchPedidos}
          />
        </Modal.Body>
      </Modal>

      {/* ── Modal Exclusão ── */}
      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
        title="Confirmar Exclusão"
        message={
          <>
            Tem certeza que deseja excluir o pedido de{' '}
            <strong>{pedidoToDelete?.clienteNome}</strong>?
          </>
        }
        confirmLabel="Excluir"
        confirmVariant="danger"
      />
    </Container>
  );
}


// ─────────────────────────────────────────
// FORMULÁRIO DE PEDIDO
// ─────────────────────────────────────────
function PedidoForm({
  pedido,
  clientes,
  planos,
  equipamentos,
  contractTemplates = [],
  hasBoletoAccess,
  hasContratoAccess,
  hasLytexConfig,
  hasAutentiqueConfig,
  planTier,
  onSave,
  onCancel,
  error,
  saving,
  onStartPolling,
  setCurrentPedido,
  refreshPedidos,
}) {
  const buildInit = (p) => p?.id ? {
    id: p.id,
    clienteId: p.clienteId,
    planoId: p.planoId,
    equipamentosSelecionados: p.equipamentosSelecionados || [],
    quantidadeAnuncios: p.quantidadeAnuncios || 1,
    valor: p.valor || '',
    desconto: p.desconto || '0',
    descontoParcela: p.descontoParcela || '0',
    dataInicio: p.dataInicio || getToday(),
    dataTermino: p.dataTermino || '',
    status: p.status || 'ativo',
    statusContrato: p.statusContrato || 'pendente',
    contratoEnviado: p.contratoEnviado || false,
    contratoAssinado: p.contratoAssinado || false,
    contratoId: p.contratoId || null,
    linkAssinatura: p.linkAssinatura || null,
    signedDocumentUrl: p.signedDocumentUrl || null,
    dataEnvioContrato: p.dataEnvioContrato || null,
    dataAssinaturaContrato: p.dataAssinaturaContrato || null,
    autentiqueDocId: p.autentiqueDocId || null,

    usarValorManual: p.valorBaseManual != null && p.valorBaseManual !== '',
    valorBaseManual: p.valorBaseManual != null ? String(p.valorBaseManual) : '',

    gerarBoletos: false,
    gerarContrato: false,
    enviarContratoAutentique: false,
    contractTemplateId: '',

    qtdParcelas: p.parcelas?.length || 1,
    parcelas: p.parcelas || [],
  } : {
    id: null,
    clienteId: '',
    planoId: '',
    equipamentosSelecionados: [],
    quantidadeAnuncios: 1,
    valor: '',
    desconto: '0',
    descontoParcela: '0',
    dataInicio: getToday(),
    dataTermino: '',
    status: 'ativo',
    statusContrato: 'pendente',
    contratoEnviado: false,
    contratoAssinado: false,
    contratoId: null,
    linkAssinatura: null,
    signedDocumentUrl: null,
    dataEnvioContrato: null,
    dataAssinaturaContrato: null,
    autentiqueDocId: null,

    usarValorManual: false,
    valorBaseManual: '',

    gerarBoletos: hasBoletoAccess && hasLytexConfig === true,
    gerarContrato: hasContratoAccess === true,
    enviarContratoAutentique: hasContratoAccess === true && hasAutentiqueConfig === true,
    contractTemplateId: '',

    qtdParcelas: 1,
    parcelas: [],
  };

  const [formData, setFormData] = useState(() => buildInit(pedido));

  const [generatingInvoice, setGeneratingInvoice] = useState(null);
  const [generatingAll, setGeneratingAll] = useState(false);
  const [generatingReceipt, setGeneratingReceipt] = useState(null);
  const [cancelingInstallment, setCancelingInstallment] = useState(null);
  const [cancelingRemaining, setCancelingRemaining] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(false); // 🔑 PDF assinado

  const pedidoKey = pedido?.id ?? null;

  const pedidoFingerprint = pedido
    ? [
        (pedido.parcelas || [])
          .map(p => `${p.id}:${p.invoiceUrl || ''}:${p.cancelada ? 1 : 0}:${p.pago ? 1 : 0}`)
          .join('|'),
        pedido.statusContrato || '',
        pedido.status || '',
        pedido.linkAssinatura || '',
        pedido.signedDocumentUrl || '',
      ].join('#')
    : '';

  useEffect(() => {
    setFormData(prev => {
      if (!prev.id || prev.id !== pedidoKey) {
        return buildInit(pedido);
      }

      if (!pedido) return prev;

      return {
        ...prev,
        parcelas: pedido.parcelas || prev.parcelas,
        statusContrato: pedido.statusContrato ?? prev.statusContrato,
        contratoId: pedido.contratoId ?? prev.contratoId,
        contratoAssinado: pedido.contratoAssinado ?? prev.contratoAssinado,
        linkAssinatura: pedido.linkAssinatura ?? prev.linkAssinatura,
        signedDocumentUrl: pedido.signedDocumentUrl ?? prev.signedDocumentUrl,
        contratoEnviado: pedido.contratoEnviado ?? prev.contratoEnviado,
        dataEnvioContrato: pedido.dataEnvioContrato ?? prev.dataEnvioContrato,
        dataAssinaturaContrato: pedido.dataAssinaturaContrato ?? prev.dataAssinaturaContrato,
        autentiqueDocId: pedido.autentiqueDocId ?? prev.autentiqueDocId,
        status: pedido.status ?? prev.status,
      };
    });
  }, [pedidoKey, pedidoFingerprint]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!pedidoKey) {
      setFormData(prev => ({
        ...prev,
        gerarBoletos: hasBoletoAccess && hasLytexConfig === true,
        gerarContrato: hasContratoAccess === true,
        enviarContratoAutentique: hasContratoAccess === true && hasAutentiqueConfig === true,
      }));
    }
  }, [
    hasLytexConfig,
    hasBoletoAccess,
    hasContratoAccess,
    hasAutentiqueConfig,
    pedidoKey
  ]);

  const refreshFormData = async () => {
    if (!formData.id) return;

    try {
      const res = await api.get(`/orders/${formData.id}`);
      const atualizado = formatarPedido(res.data);

      setCurrentPedido(atualizado);
      refreshPedidos?.();
    } catch {
      // silencioso
    }
  };

  const aplicarMudanca = (updates) => {
    setFormData(prev => {
      const next = { ...prev, ...updates };

      if (next.id) {
        return next;
      }

      const p = planos.find(x => x.id === next.planoId);

      if (!p || !next.dataInicio || !isValidYmd(next.dataInicio)) {
        return { ...next, parcelas: [] };
      }

      next.valor = p.valor;
      const qtdEquip = Math.max(1, next.equipamentosSelecionados.length);

      const { totalFinal, valorParcela, qtdParc } = calcularValores({
        quantidadeAnuncios: next.quantidadeAnuncios,
        valorPlano: p.valor,
        qtdEquipamentos: qtdEquip,
        desconto: next.desconto,
        descontoParcela: next.descontoParcela,
        qtdParcelas: next.qtdParcelas,
        valorBaseManual: next.usarValorManual ? next.valorBaseManual : undefined,
      });

      if (totalFinal <= 0) {
        return { ...next, parcelas: [] };
      }

      const novas = generateParcelas(
        next.dataInicio, p.duracao, p.unidade, valorParcela, totalFinal, qtdParc
      );

      const merged = novas.map((nova, i) => ({
        ...nova,
        dataVencimento: prev.parcelas[i]?.dataVencimento || nova.dataVencimento,
        pago: prev.parcelas[i]?.pago || false,
        dataPagamento: prev.parcelas[i]?.dataPagamento || '',
        valorPago: prev.parcelas[i]?.valorPago,
      }));

      return { ...next, parcelas: merged };
    });
  };

  // 🔑 Download do PDF assinado via proxy do backend (blob)
  const handleDownloadSignedPdf = async () => {
    // 1) Se tiver URL pública direta, abre direto
    if (formData.signedDocumentUrl) {
      window.open(formData.signedDocumentUrl, '_blank');
      return;
    }

    // 2) Senão, usa o proxy do backend (com token)
    if (!formData.contratoId) {
      toast.warning('Contrato não disponível para download.');
      return;
    }

    setDownloadingPdf(true);
    try {
      const response = await api.get(
        `/contracts/${formData.contratoId}/signed-pdf`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);

      toast.success('PDF assinado aberto!');
    } catch (err) {
      let msg = 'Erro ao baixar PDF assinado.';
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          msg = JSON.parse(text).error || msg;
        } catch {
          // ignora
        }
      } else {
        msg = err.response?.data?.error || msg;
      }
      toast.error(msg);
    } finally {
      setDownloadingPdf(false);
    }
  };

  const handleGenerateOne = async (installmentId) => {
    if (hasLytexConfig !== true) {
      return toast.warning('Configure a integração Lytex antes de gerar boletos.');
    }

    setGeneratingInvoice(installmentId);

    try {
      await api.post(`/financial/installments/${installmentId}/generate-invoice`);

      toast.success('Boleto gerado! Atualizando dados...');

      setTimeout(async () => {
        await refreshFormData();
        setGeneratingInvoice(null);
      }, 2000);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao gerar boleto.');
      setGeneratingInvoice(null);
    }
  };

  const handleReissueOne = async (installmentId) => {
    if (hasLytexConfig !== true) {
      return toast.warning('Configure a integração Lytex antes de reemitir boletos.');
    }

    const parcela = formData.parcelas.find(p => p.id === installmentId);
    if (!parcela) return;

    const mensagem =
      `Reemitir boleto da Parcela ${parcela.numero}?\n\n` +
      `📅 Novo vencimento: ${parcela.dataVencimento}\n` +
      `💰 Valor: R$ ${Number(parcela.valor).toFixed(2)}\n\n` +
      `O boleto anterior será invalidado.`;

    if (!window.confirm(mensagem)) return;

    setGeneratingInvoice(installmentId);

    try {
      await api.post(
        `/financial/installments/${installmentId}/generate-invoice?force=true`,
        {
          newDueDate: parcela.dataVencimento,
          newAmount: Number(parcela.valor)
        }
      );

      toast.success('Boleto reemitido com os novos dados!');

      setTimeout(async () => {
        await refreshFormData();
        setGeneratingInvoice(null);
      }, 2000);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao reemitir boleto.');
      setGeneratingInvoice(null);
    }
  };

  const handleGenerateAll = async () => {
    if (hasLytexConfig !== true) {
      return toast.warning('Configure a integração Lytex antes de gerar boletos.');
    }

    if (!window.confirm('Gerar boletos para todas as parcelas pendentes deste pedido?')) return;

    setGeneratingAll(true);

    try {
      const res = await api.post(`/orders/${formData.id}/generate-invoices`);
      const { total, generated, failed } = res.data;

      if (generated > 0) {
        toast.success(`${generated} de ${total} boletos gerados!`);
        onStartPolling?.(formData.id);
      }

      if (failed > 0) {
        toast.warning(`${failed} boleto(s) falharam.`);
        console.warn('[Boletos] Erros:', res.data.errors);
      }

      if (total === 0) {
        toast.info('Nenhuma parcela pendente de boleto.');
      }

      await refreshFormData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao gerar boletos.');
    } finally {
      setGeneratingAll(false);
    }
  };

  const handleGenerateReceipt = async (installmentId) => {
    setGeneratingReceipt(installmentId);

    try {
      const response = await api.get(
        `/receipts/installment/${installmentId}`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      window.open(url, '_blank');

      setTimeout(() => window.URL.revokeObjectURL(url), 10000);

      toast.success('Recibo gerado!');
    } catch (err) {
      let msg = 'Erro ao gerar recibo.';

      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          msg = JSON.parse(text).error || msg;
        } catch {
          // ignora
        }
      } else {
        msg = err.response?.data?.error || msg;
      }

      toast.error(msg);
    } finally {
      setGeneratingReceipt(null);
    }
  };

  const handleCancelInstallment = async (parcela) => {
    const msg =
      `Cancelar a Parcela ${parcela.numero}?\n\n` +
      `💰 Valor: R$ ${Number(parcela.valor).toFixed(2)}\n` +
      `📅 Vencimento: ${parcela.dataVencimento}\n\n` +
      (parcela.invoiceUrl ? '⚠️ O boleto na Lytex também será cancelado.\n' : '') +
      'Esta ação não pode ser desfeita.';

    if (!window.confirm(msg)) return;

    setCancelingInstallment(parcela.id);

    try {
      const res = await api.patch(`/installments/${parcela.id}/cancel`);

      if (res.data?.lytexCanceled === false && parcela.invoiceUrl) {
        toast.warning('Parcela cancelada, mas falha ao cancelar boleto na Lytex.');
      } else {
        toast.success('Parcela cancelada!');
      }

      await refreshFormData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao cancelar parcela.');
    } finally {
      setCancelingInstallment(null);
    }
  };

  const handleCancelRemaining = async () => {
    const pendentes = formData.parcelas.filter(p => !p.pago && !p.cancelada).length;

    if (pendentes === 0) {
      return toast.info('Não há parcelas pendentes para cancelar.');
    }

    const msg =
      `Cancelar TODAS as ${pendentes} parcelas pendentes deste pedido?\n\n` +
      `⚠️ Os boletos correspondentes também serão cancelados na Lytex.\n` +
      `Esta ação não pode ser desfeita.`;

    if (!window.confirm(msg)) return;

    setCancelingRemaining(true);

    try {
      const res = await api.patch(`/orders/${formData.id}/cancel-remaining`, {
        finalizeOrder: false
      });

      const { canceled, lytexCanceled, lytexFailed } = res.data;

      toast.success(
        `${canceled} parcela(s) cancelada(s). ` +
        `${lytexCanceled} boleto(s) cancelados na Lytex` +
        (lytexFailed > 0 ? ` (${lytexFailed} falha(s))` : '') + `.`
      );

      await refreshFormData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao cancelar parcelas.');
    } finally {
      setCancelingRemaining(false);
    }
  };

  const parcelasSemBoleto = formData.parcelas.filter(p => !p.invoiceUrl && !p.pago && !p.cancelada).length;
  const parcelasPendentes = formData.parcelas.filter(p => !p.pago && !p.cancelada).length;

  const planoAtual = planos.find(x => x.id === formData.planoId);
  const isDias = ['dias', 'days'].includes(planoAtual?.unidade?.toLowerCase());
  const qtdEquipamentos = Math.max(1, formData.equipamentosSelecionados.length);

  const valorPlanoVerdade = planoAtual?.valor ?? formData.valor;

  const {
    valorBase: valorTotalBase,
    totalFinal: valorTotalFinal,
    valorParcela: valorParcelaFinal,
  } = calcularValores({
    quantidadeAnuncios: formData.quantidadeAnuncios,
    valorPlano: valorPlanoVerdade,
    qtdEquipamentos,
    desconto: formData.desconto,
    descontoParcela: formData.descontoParcela,
    qtdParcelas: formData.qtdParcelas,
    valorBaseManual: formData.usarValorManual ? formData.valorBaseManual : undefined,
  });

  const getValorExibido = (parcela) =>
    formData.id ? parcela.valor : valorParcelaFinal;

  const clienteOptions = clientes.map(c => ({
    value: c.id,
    label: `${c.nome} (${c.cnpj || 'N/A'})`
  }));

  const planoOptions = planos.map(p => ({
    value: p.id,
    label: `${p.nome} - R$ ${p.valor}`
  }));

  const equipamentoOptions = equipamentos.map(e => ({
    value: e.id,
    label: e.nome
  }));

  const templateOptions = contractTemplates.map(t => ({
    value: t.id,
    label: t.name || t.nome || t.title || t.titulo || `Modelo ${t.id}`
  }));

  // ─────────────────────────────────────────
  // HANDLERS
  // ─────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updates = { [name]: value };

    if (name === 'dataInicio' && isValidYmd(value)) {
      const p = planos.find(x => x.id === formData.planoId);
      if (p) {
        updates.dataTermino = calculateEndDate(value, p.duracao, p.unidade);
      }
    }

    aplicarMudanca(updates);
  };

  const handleQtdParcelasChange = (e) => {
    const qtd = Math.max(1, parseInt(e.target.value, 10) || 1);
    aplicarMudanca({ qtdParcelas: qtd });
  };

  const handleSelectChange = (name, selected) => {
    const value = selected?.value || '';

    const updates = { [name]: value };

    if (name === 'planoId') {
      const p = planos.find(x => x.id === value);

      if (p && formData.dataInicio) {
        const qtdSugerida = ['dias', 'days'].includes(p.unidade?.toLowerCase())
          ? 1
          : parseInt(p.duracao || 1, 10);

        updates.valor = p.valor;
        updates.qtdParcelas = qtdSugerida;
        updates.dataTermino = calculateEndDate(formData.dataInicio, p.duracao, p.unidade);
      } else if (!value) {
        updates.valor = '';
        updates.qtdParcelas = 1;
        updates.dataTermino = '';
      }
    }

    aplicarMudanca(updates);
  };

  const handleEquipamentosChange = (selected) => {
    const value = selected ? selected.map(x => x.value) : [];
    aplicarMudanca({ equipamentosSelecionados: value });
  };

  const handleParcelaChange = (index, field, value) => {
    setFormData(prev => {
      const novas = [...prev.parcelas];

      if (field === 'pago') {
        novas[index] = {
          ...novas[index],
          pago: value,
          dataPagamento: value ? getToday() : '',
          valorPago: value ? (novas[index].valorPago ?? novas[index].valor) : '',
        };
      } else {
        novas[index] = { ...novas[index], [field]: value };
      }

      return { ...prev, parcelas: novas };
    });
  };

  const handleGerarContratoChange = (checked) => {
    setFormData(prev => ({
      ...prev,
      gerarContrato: checked,
      enviarContratoAutentique: checked && hasAutentiqueConfig === true,
    }));
  };

  const handleUsarValorManualChange = (checked) => {
    aplicarMudanca({
      usarValorManual: checked,
      valorBaseManual: checked
        ? (formData.valorBaseManual !== '' ? formData.valorBaseManual : String(valorTotalBase || ''))
        : '',
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (saving) return;

    if (
      !formData.clienteId ||
      !formData.planoId ||
      formData.equipamentosSelecionados.length === 0
    ) {
      return toast.warning('Preencha Cliente, Plano e ao menos um Equipamento.');
    }

    if (formData.usarValorManual) {
      const v = parseFloat(formData.valorBaseManual);
      if (formData.valorBaseManual === '' || isNaN(v) || v <= 0) {
        return toast.warning('Informe um Valor Base manual válido (maior que zero).');
      }
    }

    if (!formData.id) {
      const parcelasSincronizadas = formData.parcelas.map((parcela) => ({
        ...parcela,
        valor: valorParcelaFinal,
      }));

      if (parcelasSincronizadas.length > 0) {
        const n = parcelasSincronizadas.length;
        const somaParcial = Number((valorParcelaFinal * (n - 1)).toFixed(2));
        parcelasSincronizadas[n - 1] = {
          ...parcelasSincronizadas[n - 1],
          valor: Number((valorTotalFinal - somaParcial).toFixed(2)),
        };
      }

      return onSave({ ...formData, parcelas: parcelasSincronizadas });
    }

    onSave(formData);
  };

  const boletosPendentes = formData.id && hasBoletoAccess && formData.gerarBoletos
    ? formData.parcelas.filter(p => !p.invoiceUrl && !p.cancelada).length
    : 0;

  const pedidoSemBoletos = formData.id && hasBoletoAccess
    && formData.parcelas.length > 0
    && formData.parcelas.every(p => !p.invoiceUrl)
    && !formData.gerarBoletos;

  const camposEntrada = [
    { label: 'Anúncios', name: 'quantidadeAnuncios', value: formData.quantidadeAnuncios, type: 'number' },
    { label: 'Desc. Global (R$)', name: 'desconto', value: formData.desconto, type: 'number' },
    { label: 'Desc/Parcela (R$)', name: 'descontoParcela', value: formData.descontoParcela, type: 'number' },
  ];


  return (
    <div>
      {error && (
        <Alert variant="danger" className="mb-3">
          {error}
        </Alert>
      )}

      {boletosPendentes > 0 && (
        <Alert variant="info" className="d-flex align-items-center gap-2 mb-3">
          <Spinner animation="border" size="sm" />
          <span>
            Gerando boletos em background...{' '}
            <strong>{boletosPendentes} parcela{boletosPendentes > 1 ? 's' : ''}</strong> aguardando.
          </span>
        </Alert>
      )}

      {pedidoSemBoletos && (
        <Alert variant="secondary" className="d-flex align-items-center gap-2 mb-3">
          <FaFileInvoiceDollar size={18} className="flex-shrink-0" />
          <span>
            Este pedido foi criado <strong>sem geração de boletos</strong>.
            Controle os pagamentos manualmente nas parcelas abaixo.
          </span>
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        {/* SEÇÃO 1: DADOS DO PEDIDO */}
        <Card className="mb-3 border-0 shadow-sm">
          <Card.Header className="bg-white fw-semibold border-bottom">
            <FaFileContract className="me-2 text-primary" />
            Dados do Pedido
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Cliente *</Form.Label>
                  <Select
                    {...selectFix}
                    options={clienteOptions}
                    value={clienteOptions.find(o => o.value === formData.clienteId) || null}
                    onChange={s => handleSelectChange('clienteId', s)}
                    placeholder="Buscar cliente..."
                    isClearable
                    isDisabled={saving}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Equipamentos *</Form.Label>
                  <Select
                    {...selectFix}
                    isMulti
                    options={equipamentoOptions}
                    value={equipamentoOptions.filter(o => formData.equipamentosSelecionados.includes(o.value))}
                    onChange={handleEquipamentosChange}
                    placeholder="Selecione painéis..."
                    noOptionsMessage={() => 'Nenhum encontrado'}
                    isDisabled={saving}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Plano *</Form.Label>
                  <Select
                    {...selectFix}
                    options={planoOptions}
                    value={planoOptions.find(o => o.value === formData.planoId) || null}
                    onChange={s => handleSelectChange('planoId', s)}
                    placeholder="Selecione um plano..."
                    isClearable
                    isDisabled={saving}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* SEÇÃO 2: VALORES */}
        <Card className="mb-3 border-0 shadow-sm">
          <Card.Header className="bg-white fw-semibold border-bottom">
            <FaFileInvoiceDollar className="me-2 text-success" />
            Valores e Descontos
          </Card.Header>
          <Card.Body>
            <Row className="g-3 align-items-end">
              {camposEntrada.map(({ label, name, value, type }) => (
                <Col md={3} key={name}>
                  <Form.Group>
                    <Form.Label className="small">{label}</Form.Label>
                    <Form.Control
                      type={type}
                      name={name}
                      value={value}
                      onChange={handleChange}
                      readOnly={saving}
                      min="0"
                      step={['desconto', 'descontoParcela'].includes(name) ? '0.01' : undefined}
                    />
                  </Form.Group>
                </Col>
              ))}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small">
                    Nº de Parcelas
                    {planoAtual && (
                      <span className="text-muted ms-2">
                        (Plano: {planoAtual.duracao} {planoAtual.unidade})
                      </span>
                    )}
                  </Form.Label>

                  <Form.Control
                    type="number"
                    name="qtdParcelas"
                    value={formData.qtdParcelas}
                    min="1"
                    max="120"
                    disabled={saving || isDias}
                    onChange={handleQtdParcelasChange}
                  />

                  {/* {isDias && (
                    <Form.Text className="text-muted">
                      Planos em dias sempre geram 1 parcela.
                    </Form.Text>
                  )} */}
                </Form.Group>
              </Col>
            </Row>

            {/* Toggle + campo de Valor Base manual */}
            <Row className="g-3 mt-1 align-items-end">
              <Col md={9}>
                <Form.Check
                  type="switch"
                  id="usar-valor-manual-switch"
                  checked={formData.usarValorManual}
                  disabled={saving}
                  onChange={e => handleUsarValorManualChange(e.target.checked)}
                  label={
                    <span className="fw-semibold">
                      <FaFileInvoiceDollar className="me-2 text-success" />
                      Definir Valor Base manualmente
                    </span>
                  }
                />
                <small className="text-muted d-block ms-4 mt-1">
                  Ative para sobrescrever o valor calculado automaticamente
                  (anúncios × valor do plano × equipamentos).
                </small>
              </Col>

              {formData.usarValorManual && (
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="small fw-semibold text-success">
                      Valor Base (R$)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="valorBaseManual"
                      value={formData.valorBaseManual}
                      min="0"
                      step="0.01"
                      disabled={saving}
                      placeholder="0,00"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>

            <Row className="mt-3 justify-content-center">
              <Col md={12}>
                <div className="d-flex gap-3 flex-wrap">
                  <div className="text-center px-3 py-2 rounded bg-light flex-grow-1">
                    <small className="text-muted d-block">
                      Valor Base{' '}
                      {formData.usarValorManual && (
                        <span className="text-success fw-semibold">(manual)</span>
                      )}
                    </small>
                    <strong>{brl(valorTotalBase)}</strong>
                  </div>
                  <div className="text-center px-3 py-2 rounded flex-grow-1" style={{ backgroundColor: '#e8f5e9' }}>
                    <small className="text-muted d-block">Total Final</small>
                    <strong style={{ color: '#28a745' }}>{brl(valorTotalFinal)}</strong>
                  </div>
                  <div className="text-center px-3 py-2 rounded flex-grow-1" style={{ backgroundColor: '#e7f1ff' }}>
                    <small className="text-muted d-block">Valor/Parcela</small>
                    <strong style={{ color: '#0d6efd' }}>{brl(valorParcelaFinal)}</strong>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* SEÇÃO 3: DATAS E STATUS */}
        <Card className="mb-3 border-0 shadow-sm">
          <Card.Header className="bg-white fw-semibold border-bottom">
            <FaCalendarAlt className="me-2 text-info" />
            Período e Status
          </Card.Header>
          <Card.Body>
            <Row className="g-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small">Data de Início *</Form.Label>
                  <Form.Control
                    type="date"
                    name="dataInicio"
                    value={formData.dataInicio}
                    min="2020-01-01"
                    max="2100-12-31"
                    onChange={handleChange}
                    required
                    disabled={saving}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small">Data de Término</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.dataTermino}
                    readOnly
                    style={{ backgroundColor: '#e9ecef' }}
                  />
                </Form.Group>
              </Col>

              {hasContratoAccess && (
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="small">Status do Contrato</Form.Label>
                    <Form.Select
                      name="statusContrato"
                      value={formData.statusContrato}
                      onChange={handleChange}
                      disabled={saving}
                    >
                      <option value="pendente">Pendente</option>
                      <option value="aguardando_assinatura">Aguardando Assinatura</option>
                      <option value="assinado">Assinado</option>
                      <option value="dispensado">Dispensado</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              )}

              <Col md={3}>
                <Form.Group>
                  <Form.Label className="small">Status do Pedido</Form.Label>
                  <div className="d-flex gap-2 flex-wrap">
                    {[
                      { s: 'ativo', label: 'Ativo', color: '#198754' },
                      { s: 'finalizado', label: 'Finalizado', color: '#6c757d' },
                      { s: 'cancelado', label: 'Cancelado', color: '#dc3545' },
                    ].map(({ s, label, color }) => (
                      <Button
                        key={s}
                        size="sm"
                        type="button"
                        variant={formData.status === s ? undefined : 'outline-secondary'}
                        style={formData.status === s ? {
                          backgroundColor: color,
                          borderColor: color,
                          color: '#fff'
                        } : {}}
                        disabled={saving}
                        onClick={() => setFormData(prev => ({ ...prev, status: s }))}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* SEÇÃO 4: AUTOMAÇÕES (somente em criação) */}
        {!formData.id && (hasBoletoAccess || hasContratoAccess) && (
          <Card className="mb-3 border-0 shadow-sm">
            <Card.Header className="bg-white fw-semibold border-bottom">
              <FaBolt className="me-2 text-warning" />
              Automações do Pedido
            </Card.Header>
            <Card.Body>
              <Row className="g-4">
                {hasBoletoAccess && (
                  <Col md={hasContratoAccess ? 6 : 12}>
                    <Form.Check
                      type="switch"
                      id="gerar-boletos-switch"
                      checked={formData.gerarBoletos && hasLytexConfig === true}
                      disabled={saving || hasLytexConfig !== true}
                      onChange={e => setFormData(prev => ({ ...prev, gerarBoletos: e.target.checked }))}
                      label={
                        <span className="fw-semibold">
                          <FaFileInvoiceDollar className="me-2 text-primary" />
                          Gerar boletos (Lytex)
                        </span>
                      }
                    />

                    <div className="ms-4 mt-1">
                      {hasLytexConfig === null && (
                        <small className="text-muted">
                          <Spinner animation="border" size="sm" className="me-1" />
                          Verificando integração Lytex...
                        </small>
                      )}

                      {hasLytexConfig === true && (
                        <small className="text-muted">
                          Desmarque se o cliente pagará em dinheiro/PIX, ou se você está
                          migrando dados de um sistema antigo.
                        </small>
                      )}

                      {hasLytexConfig === false && (
                        <small className="text-warning">
                          <FaExclamationTriangle className="me-1" />
                          <strong>Credenciais Lytex não configuradas.</strong>{' '}
                          <a href="/configuracoes/integracoes">Configurar agora</a>
                        </small>
                      )}
                    </div>
                  </Col>
                )}

                {hasContratoAccess && (
                  <Col md={hasBoletoAccess ? 6 : 12} className={hasBoletoAccess ? 'border-start' : ''}>
                    <Form.Check
                      type="switch"
                      id="gerar-contrato-switch"
                      checked={formData.gerarContrato}
                      disabled={saving}
                      onChange={e => handleGerarContratoChange(e.target.checked)}
                      label={
                        <span className="fw-semibold">
                          <FaFileContract className="me-2 text-info" />
                          Gerar contrato automaticamente
                        </span>
                      }
                    />

                    <small className="text-muted d-block ms-4 mt-1">
                      Ao criar o pedido, o sistema gera o contrato com os dados do cliente, plano e período.
                    </small>

                    {formData.gerarContrato && (
                      <div className="ms-4 mt-3 ps-3 border-start border-2 border-info-subtle">
                        {templateOptions.length > 0 && (
                          <Form.Group className="mb-3">
                            <Form.Label className="small fw-semibold">Modelo de Contrato</Form.Label>
                            <Select
                              {...selectFix}
                              options={templateOptions}
                              value={
                                templateOptions.find(o => o.value === formData.contractTemplateId) || null
                              }
                              onChange={s => setFormData(prev => ({
                                ...prev,
                                contractTemplateId: s?.value || ''
                              }))}
                              placeholder="Selecione um modelo..."
                              isDisabled={saving}
                              isClearable
                            />
                          </Form.Group>
                        )}

                        <Form.Check
                          type="switch"
                          id="enviar-autentique-switch"
                          checked={formData.enviarContratoAutentique && hasAutentiqueConfig === true}
                          disabled={saving || hasAutentiqueConfig !== true}
                          onChange={e => setFormData(prev => ({
                            ...prev,
                            enviarContratoAutentique: e.target.checked
                          }))}
                          label={
                            <span className="fw-semibold small">
                              <FaPaperPlane className="me-1 text-info" />
                              Enviar para Autentique após criar
                            </span>
                          }
                        />

                        <div className="ms-4 mt-1">
                          {hasAutentiqueConfig === null && (
                            <small className="text-muted">
                              <Spinner animation="border" size="sm" className="me-1" />
                              Verificando integração Autentique...
                            </small>
                          )}

                          {hasAutentiqueConfig === true && (
                            <small className="text-muted">
                              O contrato será enviado automaticamente para assinatura digital.
                            </small>
                          )}

                          {hasAutentiqueConfig === false && (
                            <small className="text-warning">
                              <FaExclamationTriangle className="me-1" />
                              <strong>Token da Autentique não configurado.</strong>{' '}
                              <a href="/configuracoes/integracoes">Configurar agora</a>
                            </small>
                          )}
                        </div>
                      </div>
                    )}
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        )}

        {/* ── Info contrato (modo edição) ── */}
        {(formData.contratoEnviado || formData.linkAssinatura || formData.contratoAssinado) && (
          <Card className="mb-3 border-info shadow-sm">
            <Card.Header className="bg-info text-white">
              <FaFileContract className="me-2" />
              Informações do Contrato
            </Card.Header>

            <Card.Body>
              <Row className="g-3 align-items-center">
                {formData.dataEnvioContrato && (
                  <Col md={3}>
                    <strong>Envio:</strong>
                    <br />
                    {formatBr(formData.dataEnvioContrato)}
                  </Col>
                )}

                {formData.dataAssinaturaContrato && (
                  <Col md={3}>
                    <strong>Assinatura:</strong>
                    <br />
                    {formatBrDateTime(formData.dataAssinaturaContrato)}
                  </Col>
                )}

                {formData.autentiqueDocId && (
                  <Col md={3}>
                    <strong>ID Autentique:</strong>
                    <br />
                    <small>{formData.autentiqueDocId}</small>
                  </Col>
                )}

                {/* Link de assinatura (enquanto aguarda) */}
                {formData.linkAssinatura && !formData.contratoAssinado && (
                  <Col md={3} className="d-flex align-items-center">
                    <a
                      href={formData.linkAssinatura}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm btn-outline-primary"
                    >
                      <FaEye className="me-1" />
                      Ver Contrato
                    </a>
                  </Col>
                )}

                {/* 🔑 Botão Baixar PDF Assinado */}
                {(formData.contratoAssinado || formData.statusContrato === 'assinado') &&
                  (formData.signedDocumentUrl || formData.contratoId) && (
                  <Col md={3} className="d-flex align-items-center">
                    <Button
                      size="sm"
                      variant="success"
                      disabled={downloadingPdf}
                      onClick={handleDownloadSignedPdf}
                    >
                      {downloadingPdf ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-1" />
                          Baixando...
                        </>
                      ) : (
                        <>
                          <FaFilePdf className="me-1" />
                          Baixar PDF Assinado
                        </>
                      )}
                    </Button>
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        )}

        {/* ── Parcelas ── */}
        {formData.parcelas.length > 0 ? (
          <Card className="mb-3 border-0 shadow-sm">
            <Card.Header className="bg-white d-flex justify-content-between align-items-center flex-wrap gap-2 border-bottom">
              <h6 className="mb-0 fw-semibold">
                <FaCalendarAlt className="me-2 text-info" />
                Parcelas ({formData.parcelas.length}x de {brl(valorParcelaFinal)})

                {boletosPendentes > 0 && (
                  <span className="ms-2 text-info" style={{ fontSize: '0.8rem' }}>
                    <Spinner animation="border" size="sm" className="me-1" />
                    {boletosPendentes} boleto{boletosPendentes > 1 ? 's' : ''} sendo gerado{boletosPendentes > 1 ? 's' : ''}...
                  </span>
                )}
              </h6>

              <div className="d-flex gap-2 flex-wrap">
                {hasBoletoAccess && formData.id && parcelasSemBoleto > 0 && (
                  <Button
                    size="sm"
                    variant="warning"
                    disabled={generatingAll || hasLytexConfig !== true}
                    onClick={handleGenerateAll}
                    title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : ''}
                  >
                    {generatingAll ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-1" />
                        Gerando...
                      </>
                    ) : (
                      <>
                        <FaBolt className="me-1" />
                        Gerar {parcelasSemBoleto} boleto{parcelasSemBoleto > 1 ? 's' : ''}
                      </>
                    )}
                  </Button>
                )}

                {formData.id && parcelasPendentes > 0 && (
                  <Button
                    size="sm"
                    variant="outline-danger"
                    disabled={cancelingRemaining}
                    onClick={handleCancelRemaining}
                  >
                    {cancelingRemaining ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-1" />
                        Cancelando...
                      </>
                    ) : (
                      <>
                        <FaBan className="me-1" />
                        Cancelar {parcelasPendentes} restante{parcelasPendentes > 1 ? 's' : ''}
                      </>
                    )}
                  </Button>
                )}
              </div>
            </Card.Header>

            <Card.Body>
              <Row>
                {formData.parcelas.map((parcela, index) => (
                  <Col md={3} key={index} className="mb-3">
                    <Card
                      className={`h-100 ${
                        parcela.cancelada
                          ? 'border-danger'
                          : parcela.pago
                            ? 'border-success'
                            : 'border-warning'
                      }`}
                      style={parcela.cancelada ? { opacity: 0.75 } : {}}
                    >
                      <Card.Header
                        className={`py-2 d-flex align-items-center justify-content-between ${
                          parcela.cancelada
                            ? 'bg-danger text-white'
                            : parcela.pago
                              ? 'bg-success text-white'
                              : 'bg-warning text-dark'
                        }`}
                      >
                        <small>
                          Parcela {parcela.numero}
                          {parcela.cancelada && ' (Cancelada)'}
                        </small>

                        {!parcela.cancelada && (
                          <Form.Switch
                            id={`switch-${index}`}
                            label="Pago"
                            checked={parcela.pago}
                            onChange={e => handleParcelaChange(index, 'pago', e.target.checked)}
                            className="ms-2"
                          />
                        )}
                      </Card.Header>

                      <Card.Body className="py-2">
                        <div className="mb-2">
                          <strong>{brl(getValorExibido(parcela))}</strong>
                        </div>

                        {parcela.cancelada ? (
                          <Alert variant="danger" className="py-2 mb-0 small text-center">
                            <FaBan className="me-1" />
                            Parcela cancelada
                            <div className="mt-1">
                              <small>Venc.: {formatBr(parcela.dataVencimento)}</small>
                            </div>
                          </Alert>
                        ) : (
                          <>
                            <Form.Label className="small">Vencimento:</Form.Label>

                            <Form.Control
                              type="date"
                              size="sm"
                              value={parcela.dataVencimento || ''}
                              min="2020-01-01"
                              max="2100-12-31"
                              onChange={e => handleParcelaChange(index, 'dataVencimento', e.target.value)}
                              className="mb-2"
                            />

                            {hasBoletoAccess && formData.id && (() => {
                              if (parcela.invoiceUrl) {
                                return (
                                  <div className="my-2 d-flex gap-1">
                                    <Button
                                      size="sm"
                                      className="flex-grow-1"
                                      variant={parcela.pago ? 'secondary' : 'primary'}
                                      style={parcela.pago ? { opacity: 0.6 } : {}}
                                      onClick={() => window.open(parcela.invoiceUrl, '_blank')}
                                    >
                                      <FaCheckCircle className="me-1" />
                                      {parcela.pago ? 'Boleto Pago' : 'Baixar Boleto'}
                                    </Button>

                                    {!parcela.pago && (
                                      <Button
                                        size="sm"
                                        variant="outline-warning"
                                        disabled={hasLytexConfig !== true || generatingInvoice === parcela.id}
                                        onClick={() => handleReissueOne(parcela.id)}
                                        title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : 'Reemitir boleto'}
                                        style={{ flexShrink: 0 }}
                                      >
                                        {generatingInvoice === parcela.id
                                          ? <Spinner animation="border" size="sm" />
                                          : <FaRedo />
                                        }
                                      </Button>
                                    )}
                                  </div>
                                );
                              }

                              if (generatingInvoice === parcela.id || generatingAll) {
                                return (
                                  <Button size="sm" className="my-2 w-100" variant="secondary" disabled>
                                    <Spinner animation="border" size="sm" className="me-1" />
                                    Gerando...
                                  </Button>
                                );
                              }

                              if (formData.gerarBoletos) {
                                return (
                                  <Button size="sm" className="my-2 w-100" variant="secondary" disabled>
                                    <Spinner animation="border" size="sm" className="me-1" />
                                    Aguardando...
                                  </Button>
                                );
                              }

                              if (parcela.pago) {
                                return (
                                  <Button size="sm" className="my-2 w-100" variant="outline-success" disabled>
                                    <FaCheckCircle className="me-1" />
                                    Paga sem boleto
                                  </Button>
                                );
                              }

                              return (
                                <Button
                                  size="sm"
                                  className="my-2 w-100"
                                  variant="outline-warning"
                                  disabled={hasLytexConfig !== true}
                                  onClick={() => handleGenerateOne(parcela.id)}
                                  title={hasLytexConfig !== true ? 'Configure a Lytex primeiro' : 'Gerar boleto na Lytex'}
                                >
                                  <FaBolt className="me-1" />
                                  Gerar boleto
                                </Button>
                              );
                            })()}

                            {parcela.pago && (
                              <>
                                <Form.Label className="small">Data de Pagamento:</Form.Label>

                                <Form.Control
                                  type="date"
                                  size="sm"
                                  value={parcela.dataPagamento || ''}
                                  min="2020-01-01"
                                  max="2100-12-31"
                                  onChange={e => handleParcelaChange(index, 'dataPagamento', e.target.value)}
                                  className="mb-2"
                                />

                                <Form.Label className="small">Valor Pago:</Form.Label>

                                <div className="d-flex align-items-center gap-2">
                                  <span>R$</span>
                                  <Form.Control
                                    type="number"
                                    size="sm"
                                    min="0"
                                    step="0.01"
                                    value={parcela.valorPago ?? parcela.valor}
                                    onChange={e => handleParcelaChange(
                                      index,
                                      'valorPago',
                                      e.target.value === '' ? '' : Number(e.target.value)
                                    )}
                                    className="mb-2"
                                  />
                                </div>

                                {formData.id && parcela.id && (
                                  <Button
                                    size="sm"
                                    className="w-100 mt-1"
                                    variant="outline-success"
                                    disabled={generatingReceipt === parcela.id}
                                    onClick={() => handleGenerateReceipt(parcela.id)}
                                  >
                                    {generatingReceipt === parcela.id ? (
                                      <>
                                        <Spinner animation="border" size="sm" className="me-1" />
                                        Gerando...
                                      </>
                                    ) : (
                                      <>
                                        <FaFileInvoice className="me-1" />
                                        Gerar Recibo
                                      </>
                                    )}
                                  </Button>
                                )}
                              </>
                            )}

                            {formData.id && parcela.id && !parcela.pago && (
                              <Button
                                size="sm"
                                className="w-100 mt-2"
                                variant="outline-danger"
                                disabled={cancelingInstallment === parcela.id}
                                onClick={() => handleCancelInstallment(parcela)}
                              >
                                {cancelingInstallment === parcela.id ? (
                                  <>
                                    <Spinner animation="border" size="sm" className="me-1" />
                                    Cancelando...
                                  </>
                                ) : (
                                  <>
                                    <FaBan className="me-1" />
                                    Cancelar parcela
                                  </>
                                )}
                              </Button>
                            )}
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        ) : formData.id && (
          <Alert variant="warning" className="mb-3">
            <FaClock className="me-2" />
            Parcelas não carregadas. Verifique o backend.
          </Alert>
        )}

        {/* ── Botões ── */}
        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button variant="secondary" type="button" onClick={onCancel} disabled={saving}>
            <FaTimes className="me-1" />
            Cancelar
          </Button>

          <Button variant="success" type="submit" disabled={saving}>
            {saving ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                {formData.id ? 'Salvando...' : 'Criando pedido...'}
              </>
            ) : (
              <>
                <FaSave className="me-2" />
                {formData.id ? 'Atualizar' : 'Criar'}
              </>
            )}
          </Button>
        </div>
      </Form>
    </div>
  );
}
